// src/frontend/de.json
var setting = {
  preference: {
    notification: {
      sub: "Aktivieren Sie die erforderliche Popup-Benachrichtigung.",
      title: "Pr\xE4ferenz f\xFCr Benachrichtigungs-Popup",
      unsaved_screen: {
        sub: "Erhalten Sie eine Benachrichtigung, wenn Sie ein ungespeichertes Screener haben.",
        title: "Aktivieren Sie die Benachrichtigung f\xFCr ungespeichertes Screener"
      }
    },
    language: {
      subtitle: "W\xE4hlen Sie Ihre bevorzugte Sprache.",
      success_message: "Die Sprachpr\xE4ferenz wurde gespeichert.",
      title: "Sprache"
    },
    unsaved_screen_notification: {
      title: "Diese Benachrichtigung nicht mehr anzeigen",
      sub: "Wenn Sie dieses K\xE4stchen aktivieren, erhalten Sie diese Benachrichtigung nicht mehr. Sie k\xF6nnen diese Einstellung auf der Einstellungsseite zur\xFCck\xE4ndern."
    },
    save_changes: "\xC4nderungen speichern"
  },
  profile: {
    picture: {
      format_error: "Format oder Gr\xF6sse wahrscheinlich falsch.",
      error: "Das Bild konnte nicht hochgeladen werden"
    },
    profile_picture_title: "Profilbild",
    confirm_delete_pp: {
      cancel_button: "Stornieren",
      delete_button: "Konto l\xF6schen",
      modal_title: "L\xF6schen best\xE4tigen",
      msg: "Um zu best\xE4tigen, dass Sie Ihr Konto l\xF6schen m\xF6chten, geben Sie bitte Ihren Vornamen unten ein und klicken Sie auf die Schaltfl\xE4che Konto l\xF6schen."
    },
    notification: {
      error: "Ein Fehler ist aufgetreten",
      success: "Erfolgreich",
      send_email_duplicated_msg: "Eine Best\xE4tigungs-E-Mail wurde innerhalb einer Minute gesendet, bitte \xFCberpr\xFCfen Sie Ihr Postfach.",
      send_email_success_msg: "Eine Best\xE4tigungs-E-Mail wurde gesendet, bitte \xFCberpr\xFCfen Sie Ihre E-Mail-Adresse.",
      wrong_first_name_msg: "Bitte geben Sie Ihren korrekten Vornamen ein.",
      change_pp_success_msg: "Ihr Profilbild wurde erfolgreich ge\xE4ndert."
    },
    email_preferences: {
      marketing: {
        title: "Marketing-E-Mails",
        sub: "Erhalten Sie Nachrichten \xFCber das Unternehmen"
      },
      sub: "\xC4ndern Sie Ihre E-Mail-Einstellungen",
      title: "E-Mail-Pr\xE4ferenzen",
      technical: {
        sub: "Erhalten Sie \xC4nderungsprotokolle, wenn die App neue Funktionen hat",
        title: "Technische E-Mails"
      }
    },
    email_verification_note: {
      button: "Best\xE4tigungscode erneut senden",
      msg: "Bitte \xFCberpr\xFCfen Sie Ihre E-Mail-Adresse, bevor Sie die Plattform nutzen.",
      title: "\xDCberpr\xFCfen Sie Ihre E-Mail-Adresse"
    },
    profile_picture_title_sub: "Laden Sie Ihr Profilbild hoch.",
    delete_my_account_title: "Mein Konto l\xF6schen",
    personal_info_title: "Pers\xF6nliche Informationen",
    delete_my_account_title_sub: "Diese Entscheidung ist endg\xFCltig.",
    save_changes: "\xC4nderungen speichern",
    confirm_crop: "Best\xE4tigen",
    personal_info_title_sub: "Aktualisieren Sie Ihre pers\xF6nlichen Daten.",
    click_to_upload: "Klicken Sie hier, um das Profilbild hochzuladen",
    click_to_upload_file_constraints: "oder ziehen Sie eine PNG-, JPEG- oder JPG-Datei hierher"
  },
  seats: {
    am_table: {
      col_name: {
        email: "E-Mail-Adresse des Account-Managers",
        phone: "Telefonnummer des Account-Managers",
        name: "Account-Managers"
      }
    },
    payment_warning: {
      msg: {
        owner: "Bitte kontaktieren Sie Ihren Account-Manager.",
        user: "Bitte kontaktieren Sie diesen Unternehmensmanager.",
        unpaid: "Ihr Unternehmen befindet sich \xFCber dem F\xE4lligkeitsdatum der Zahlung. Ihr Abonnement muss reguliert werden.",
        ended: "Ihr Vertrag ist beendet. Haben Sie alle Vorteile unserer Dienstleistungen genutzt?",
        no_slot: "Ihnen wurde keine Lizenz zugewiesen. Bitte weisen Sie sich die entsprechende Lizenz zu.",
        end_trial: "Ihre Testphase ist vorbei. Haben Sie alle Vorteile unserer Dienstleistungen genutzt?"
      },
      button: "Kontaktieren Sie den Kundenservice",
      title: "Es gab ein Problem mit Ihrer Zahlung"
    },
    plan_card: {
      info: "{{used}} von {{total}} Licenzen"
    },
    member_table: {
      col_name: {
        role: "Rolle",
        name: "Name",
        right: "Rechte",
        last_activity_date: "Aktiv seit"
      }
    },
    delete_user: {
      multiple: {
        confirm_msg: "Sind Sie sicher, dass Sie diese {{number}} Benutzer l\xF6schen m\xF6chten?"
      },
      success_msg: "Der Benutzer wurde gel\xF6scht.",
      confirm_msg: "Sind Sie sicher, dass Sie diesen Benutzer {{firstName}} {{lastName}} l\xF6schen m\xF6chten?"
    },
    investor: {
      name: "Investor"
    },
    institutional: {
      name: "Institutionell"
    },
    no_slot_warning: {
      title: "Sie haben kein Abonnement"
    },
    consumer: {
      name: "Verbraucher"
    }
  },
  security: {
    link_device: {
      notice: "Wir werden Ihr aktuelles Ger\xE4t von Ihrem Konto trennen, damit Sie Ihr Konto mit einem neuen Ger\xE4t verkn\xFCpfen k\xF6nnen. Sie werden abgemeldet, um das neue Ger\xE4t zu verkn\xFCpfen. Der vorherige TOTP wird nicht mehr funktionieren. Bitte best\xE4tigen Sie, ob Sie mit dem Vorgang fortfahren m\xF6chten.",
      title: "Konto mit einem neuen Ger\xE4t verbinden",
      subtitle: "Verkn\xFCpfen Sie Ihr Konto mit einem neuen Ger\xE4t, wenn Sie keinen Zugriff mehr auf das derzeit verkn\xFCpfte Ger\xE4t haben."
    },
    warning_note: {
      content: "Es wird empfohlen, Ihre Wiederherstellungscodes regelm\xE4\xDFig neu zu generieren. F\xFChren Sie die Operation mit der Schaltfl\xE4che unten aus.",
      title: "Generieren Sie Ihre Wiederherstellungscodes neu"
    },
    password: {
      title: "Passwort",
      error_message: "Passw\xF6rter m\xFCssen \xFCbereinstimmen",
      disclaimer: "Das Passwort muss mindestens 8 Zeichen enthalten.",
      save_changes: "\xC4nderungen speichern",
      subtitle: "\xC4ndern Sie Ihr Passwort",
      confirm: "Neues Passwort best\xE4tigen",
      success_message: "Passwort erfolgreich aktualisiert !"
    },
    renegerate_code: {
      subtitle: "Ihre vorherigen Wiederherstellungscodes werden nicht mehr funktionieren.",
      success: "Die neuen Wiederherstellungscodes wurden erfolgreich gespeichert.",
      title: "Wiederherstellungscodes regenerieren"
    }
  },
  organization: {
    details: {
      zip: "Postleitzahl",
      city: "Stadt",
      name: "Unternehmensname",
      no_contact_name: "Keine Ansprechperson zugewiesen",
      title: "Unternehmensinformationen",
      phone: "Telefonnummer",
      subtitle: "Aktualisieren Sie die Einzelheiten Ihres Unternehmens.",
      contact_subtitle: "Ansprechperson",
      address: "Adresse",
      country: "Land",
      contact_name: "Ansprechperson",
      email: "E-Mail-Adresse"
    },
    notification: {
      update_success: "Die Updates wurden erfolgreich angewendet."
    },
    logo: {
      title: "Unternehmenslogo",
      subtitle: "Aktualisieren Sie das Logo Ihres Unternehmens."
    }
  },
  connections: {
    options: {
      day: "{{ number }} Tag",
      months: "{{ number }} Monate",
      year: "{{ number }} Jahr",
      days: "{{ number }} Tage"
    },
    modal: {
      delete: {
        title: "L\xF6schen Sie {{ count }} Schl\xFCssel",
        subtitle: "Sind Sie sicher, dass Sie diese Schl\xFCssel l\xF6schen m\xF6chten? Diese Aktion kann nicht r\xFCckg\xE4ngig gemacht werden."
      },
      name: {
        placeholder: "Platzhaltername",
        label: "Schl\xFCsselname"
      },
      warning: {
        title: "Fehlende Werte",
        fill: "Bitte f\xFCllen Sie alle Felder aus"
      },
      delete_confirm: "L\xF6schen",
      button_copy: "Kopieren und schlie\xDFen",
      copied: "Der Schl\xFCssel wurde in die Zwischenablage kopiert.",
      create: {
        title: "API-Schl\xFCssel erstellen",
        subtitle: "Sobald sie erstellt ist, wird dieser Schl\xFCssel nie wieder sichtbar sein. Soll der Schl\xFCssel gef\xE4hrdet werden, muss der Schl\xFCssel gel\xF6scht und ein neuer erstellt werden."
      },
      expiration: {
        label: "G\xFCltigkeitsdauer",
        placeholder: "W\xE4hlen Sie eine Dauer"
      },
      button_create: "Schl\xFCssel erstellen",
      delete_cancel: "Stornieren",
      copy_error: "Fehler beim Kopieren. Bitte manuell kopieren."
    },
    name: {
      error: "Der Name ist zu kurz"
    },
    tokens_table: {
      col_name: {
        expires_at: "Ablaufdatum",
        name: "Schl\xFCsselname",
        enterprise: "Unternehmen",
        user: "Benutzer",
        created_at: "Erstellungsdatum"
      }
    },
    table_name: {
      personnal: "Pers\xF6nliche Schl\xFCssel",
      app: "App-Schl\xFCssel"
    },
    days: {
      error: "Ablauf Tage sind erforderlich"
    }
  },
  collaborator: {
    table_name: "Teammitglieder",
    reinvite_user: "Eine Einladungsemail wurde erfolgreich gesendet.",
    modal: {
      link_companies: {
        success_msg: "Die von {{name}} verwalteten Unternehmen wurden erfolgreich aktualisiert.",
        subtitle: "Unternehmen",
        title: "Unternehmen"
      }
    },
    col: {
      companies: "Unternehmen",
      invitation_process: "Einladungsprozess"
    }
  },
  companies: {
    table_name: "Unternehmensmitglieder"
  },
  company: {
    set_contact_user: {
      success: "Der Benutzer wurde erfolgreich als Ansprechperson festgelegt."
    }
  }
};
var units = {
  official_installed_solar_power: "kW",
  computed_weighted_average_cost_of_debt: "%",
  energy_intensity: "kWh/m\xB2/Jahr",
  total_area: "m\xB2",
  transport_accessibility: "Pkt.",
  r_revenue_from_postal_and_bank_accounts: "CHF",
  r_estimated_liquidation_taxes: "CHF",
  total_expense_ratio_ref_gav: "%",
  r_resiential_net_rent: "CHF",
  one_month_return: "%",
  idc: "kWh/Jahr",
  stock_volume: "Einheiten",
  c_market_value: "CHF",
  roi: "%",
  canton_rent: "CHF",
  total_expense_ratio_ref_nav: "%",
  r_plots_net_rent: "CHF",
  distribution_yield: "%",
  r_construction_and_works_fees: "%",
  r_tna_after_distribution: "CHF",
  r_net_assets_at_end_of_the_financial_year: "CHF",
  c_commercial_market_value: "CHF",
  computed_loan_to_value: "%",
  commercial_net_rent_m2: "CHF/m\xB2",
  r_ebit: "CHF",
  c_five_years_total_return: "%",
  r_commercial_cost_price: "CHF",
  target_rent: "CHF",
  reported_market_value: "CHF",
  computed_total_cash_per_share: "CHF",
  rent_per_m2: "CHF/m\xB2",
  beta: "%",
  reported_performance: "%",
  total_tenant_charges: "CHF",
  r_share_buyback_commissions: "%",
  r_nav_before_distribution: "CHF",
  c_nav_after_distribution: "CHF",
  computed_earnings_per_share: "CHF",
  price_per_m2: "CHF/m\xB2",
  r_commercial_spaces_area: "m\xB2",
  r_other_expenses: "CHF",
  potential_charges_per_m2: "CHF",
  r_cost_price_per_m2: "CHF/m\xB2",
  r_roi: "%",
  reported_real_rent: "CHF",
  income_per_taxpayer: "CHF",
  portfolios: {
    floods_50_years: "%",
    hail_hazard_10_years_average: "%",
    avalanches: "%",
    landslides: "%",
    distribution: "%",
    accessibility: "m",
    overbank_sedimentation: "%",
    rockfalls: "%",
    distribution_area: "m\xB2",
    debris_flow: "%"
  },
  climate_risk_index: "%",
  c_three_years_total_return: "%",
  c_nav_compounded: "CHF",
  funds: {
    floods_50_years: "%",
    transactions: {
      value: "CHF"
    },
    sia261: "%",
    landslides: "%",
    rockfalls: "%",
    avalanches: "%",
    overbank_sedimentation: "%",
    debris_flow: "%",
    hail_hazard_10_years: "%"
  },
  five_years_return: "%",
  six_months_return: "%",
  r_valuation_and_auditing_expenses: "CHF",
  r_valuation_expenses: "CHF",
  official_area: "m\xB2",
  c_earnings_per_share: "CHF",
  c_total_market_value: "CHF",
  c_current_agio_after_distribution: "%",
  net_initial_yield: "%",
  c_tna_compounded: "CHF",
  return_on_invested_capital: "%",
  total_idc: "kWh/Jahr",
  total_co2: "kg/m\xB2/Jahr",
  press_score: "/10",
  r_profit_and_capital_taxes: "CHF",
  c_median_cost_of_debt: "%",
  r_taxes: "CHF",
  r_roa: "%",
  real_charges_monthly: "CHF",
  r_net_rent_q1: "CHF/m\xB2",
  ter_nav: "%",
  solar_existing_per_m2: "kWh/m\xB2",
  market_dividend: "CHF",
  solar_potential: "kWh/Jahr",
  c_median_maturity: "Jahr",
  c_resiential_net_rent: "CHF",
  computed_median_maturity: "Jahr",
  computed_roe: "%",
  mtd_net_return: "%",
  r_capital_employed: "CHF",
  r_management_fees: "%",
  r_realised_income: "CHF",
  r_tga_after_distribution: "CHF",
  r_tna_before_distribution: "CHF",
  three_months_avg_volume: "Einheiten",
  aged_care: "m",
  computed_roa: "%",
  reported_roe: "%",
  real_charges: "CHF",
  r_coverage_idc: "%",
  market_value_per_m2: "CHF/m\xB2",
  reported_dividend_yield: "%",
  computed_total_area: "m\xB2",
  listed_charges: "CHF",
  c_total_net_rent: "CHF",
  energy: {
    distribution_area: "m\xB2"
  },
  r_administration_of_buildings: "CHF",
  c_market_value_q1: "CHF/m\xB2",
  healthcare: "m",
  r_max_management_fees: "%",
  c_net_rent_q3: "CHF/m\xB2",
  computed_total_dwellings_area: "m\xB2",
  share_class_nav: "CHF",
  cultural_venues: "m",
  estimated_net_rent: "CHF",
  high: "CHF",
  r_mixed_market_value: "CHF",
  secondary_education: "m",
  r_total_properties: "CHF",
  r_tga_before_distribution: "CHF",
  r_total_cost_price: "CHF",
  r_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  r_residential_net_rent: "CHF",
  r_property_management_fees: "%",
  reported_residential_rental_space: "m\xB2",
  r_cost_price_q1: "CHF/m\xB2",
  estimated_net_rent_monthly: "CHF",
  residential_net_rent_m2: "CHF/m\xB2",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  rental_space: "m\xB2",
  distribution_value: "CHF",
  lot_area: "m\xB2",
  total_co2_scope_33: "kg/Jahr",
  r_total_expenses: "CHF",
  r_agio_at_year_end: "%",
  r_property_management_expenses: "CHF",
  r_total_liabilities: "CHF",
  public_utility_density: "%",
  idc_m2: "kWh/m\xB2/Jahr",
  estimated_total_net_charges: "CHF",
  computed_weighted_average_maturity: "Jahr",
  r_capital_distribution: "CHF",
  estimated_energy_intensity: "kWh/m\xB2/Jahr",
  r_mixed_cost_price: "CHF",
  return_on_investment: "%",
  r_net_rent_median: "CHF/m\xB2",
  climate_normals_temperature_1991_2020: "\xB0C",
  r_cost_price_median: "CHF/m\xB2",
  false: "Nein",
  computed_revenue_per_share: "CHF",
  relative_agio: "%",
  potential_net_rent_monthly: "CHF",
  pts: "Pkt.",
  c_weighted_average_interest_rate: "%",
  unit_outstanding: "Einheiten",
  turnover: "CHF",
  c_mixed_market_value: "CHF",
  real_roa: "CHF",
  c_market_value_median: "CHF/m\xB2",
  charges_per_m2: "CHF/m\xB2",
  r_residential_market_value: "CHF",
  reported_ebit: "CHF",
  r_wault: "Jahr",
  six_months_avg_volume: "Einheiten",
  r_invested_capital: "CHF",
  c_loan_to_value: "%",
  hist_volatility_30_days: "%",
  r_realised_capital_gains_and_losses: "CHF",
  r_mixed_rental_space: "m\xB2",
  estimated_total_net_rent_per_m2: "CHF",
  reported_payout_ratio: "%",
  r_dividend_distribution: "CHF",
  c_net_rent: "CHF",
  hail_hazard_10_years_average: "cm",
  birth: "%",
  r_real_rent_per_m2: "CHF/m\xB2",
  debt_financing_ratio: "%",
  computed_pe_ratio: "%",
  r_short_term_liabilities: "CHF",
  reported_target_rent: "CHF",
  r_rental_income: "CHF",
  estimated_charges_monthly: "CHF",
  c_weighted_average_maturity: "Jahr",
  c_pe_ratio: "%",
  five_years_avg_dividend_yield: "%",
  r_payout_ratio: "%",
  r_performance: "%",
  dividend_yield: "%",
  co2_scope_2_per_m2: "kg/m\xB2/Jahr",
  residential_area: "m\xB2",
  c_total_cash_per_share: "CHF",
  real_net_rent: "CHF",
  job_density: "VZ\xC4/ha",
  total_co2_scope_1_2_33: "kg/Jahr",
  c_debt_ratio: "%",
  computed_total_commercial_area: "m\xB2",
  c_total_agio_at_year_end: "CHF",
  estimated_area: "m\xB2",
  reported_roce: "%",
  r_maintenance_costs: "CHF",
  r_residential_rental_space: "m\xB2",
  r_max_purchase_and_sale_fees: "%",
  accessibility_index: "%",
  cost_price: "CHF",
  potential_market_value_per_m2: "CHF",
  r_share_issue_commissions: "%",
  r_retained_earnings: "CHF",
  r_idc: "kWh/Jahr",
  death: "%",
  m_market_cap: "CHF",
  swiss_net_rent: "CHF",
  potential_net_rent: "CHF",
  co2: "kg/Jahr",
  potential_roa: "%",
  r_share_price: "CHF",
  estimated_total_net_charges_per_m2: "CHF",
  estimated_total_income: "CHF",
  one_year_return: "%",
  r_market_value_median: "CHF/m\xB2",
  commercial_spaces_area: "m\xB2",
  computed_payout_ratio: "%",
  share_class_nb: "Einheiten",
  potential_charges_monthly: "CHF",
  reported_rental_losses: "%",
  m_share_price: "CHF",
  market_price_var: "%",
  r_roce: "%",
  reported_gross_yield: "%",
  r_auditing_expenses: "CHF",
  m_dividend: "CHF",
  r_net_assets_at_beginning_of_the_financial_year: "CHF",
  last: "CHF",
  r_cost_price_q3: "CHF/m\xB2",
  r_other_rental_space: "m\xB2",
  climate_normals_precipitation_1991_2020: "mm/Jahr",
  r_residential_area: "m\xB2",
  description: {
    distribution: "%",
    distribution_area: "m\xB2"
  },
  computed_median_cost_of_debt: "%",
  three_years_total_return: "%",
  reported_debt_ratio: "%",
  c_ebit_margin: "%",
  volume: "m\xB3",
  c_roce: "%",
  area: "m\xB2",
  estimated_net_rent_per_m2: "CHF",
  reported_mixed_rental_space: "m\xB2",
  net_rent: "CHF",
  r_residential_cost_price: "CHF",
  r_total_rental_space: "m\xB2",
  shops: "m",
  r_coverage_share_fossil: "%",
  reported_roic: "%",
  r_dividend_from_indirect_rental_income: "CHF",
  r_real_rent: "CHF",
  c_net_rent_q1: "CHF/m\xB2",
  r_co2: "kg/Jahr",
  hist_volatility_180_days: "%",
  r_dividend_yield: "%",
  population_density: "Personen/ha",
  market_market_cap: "CHF",
  co2_scope_1_2_33_per_m2: "kg/m\xB2/Jahr",
  share: {
    coverage: "%",
    fossil: "%",
    non_fossil: "%"
  },
  demographic: {
    ages: "%"
  },
  meter: "m",
  surface: "m\xB2",
  r_others_net_rent: "CHF",
  r_total_revenue: "CHF",
  r_long_term_liabilities: "CHF",
  r_absolute_management_fees: "CHF",
  total_expense_ratio_ref_mv: "%",
  road_accessibility: "Pkt.",
  total_co2_scope_1_2_3: "kg/Jahr",
  r_short_term_interest_bearing_mortgages: "CHF",
  r_debt_ratio: "%",
  potential_total_income: "CHF",
  r_gav_before_distribution: "CHF",
  r_market_value_per_m2: "CHF/m\xB2",
  r_total_market_value: "CHF",
  return_on_capital_employed: "%",
  c_current_agio_compounded: "%",
  c_mixed_net_rent: "CHF",
  ytd_net_return: "%",
  c_current_ratio: "%",
  agio: "%",
  r_custodian_bank_fees: "%",
  total_co2_scope_1_2: "kg/Jahr",
  r_ter_mv: "%",
  r_other_interest: "CHF",
  r_share_fossil: "%",
  c_tga_compounded: "CHF",
  one_month_avg_volume: "Einheiten",
  reported_rental_area: "m\xB2",
  reported_plots_rental_space: "m\xB2",
  c_payout_ratio: "%",
  reported_commercial_rental_space: "m\xB2",
  r_net_income_available_for_distribution: "CHF",
  five_years_total_return: "%",
  share_class_gav: "CHF",
  c_current_liabilities: "CHF",
  share_market_price: "CHF",
  return_on_equity: "%",
  r_others_cost_price: "CHF",
  estimated_co2_scope_1_2_33_per_m2: "kg/m\xB2/Jahr",
  potential_net_rent_per_m2: "CHF",
  potential_market_value: "CHF",
  r_dividend_from_capital_gains: "CHF",
  reported_ebit_margin: "%",
  r_idc_per_m2: "kWh/m\xB2/Jahr",
  c_net_initial_yield: "%",
  r_gross_yield: "%",
  r_total_net_assets: "CHF",
  c_roa: "%",
  debt_ratio: "%",
  r_total_net_rent: "CHF",
  computed_roce: "%",
  duplex: "m\xB2",
  c_total_current_agio_compounded: "CHF",
  c_price_to_book_value: "%",
  c_total_current_agio_after_distribution: "CHF",
  true: "Ja",
  one_year_total_return: "%",
  computed_debt_ratio: "%",
  r_absolute_custodian_bank_fees: "CHF",
  r_ter_gav: "%",
  dividend: "CHF",
  r_purchase_and_sale_fees: "%",
  tx_price: "CHF",
  r_coverage_co2: "%",
  commercial_area: "m\xB2",
  reported_other_rental_space: "m\xB2",
  computed_climate_avg_value: "CHF/Jahr",
  inhabitants_per_room: "Personen",
  wault: "Jahr",
  real_market_value: "CHF",
  r_commercial_net_rent: "CHF",
  inhabitants_per_100_m2: "Personen",
  market_cap: "CHF",
  computed_current_ratio: "%",
  r_ebit_margin: "%",
  reported_roi: "%",
  idc_per_m2: "kWh/m\xB2/Jahr",
  solar_existing: "kW",
  co2_scope_1_2_per_m2: "kg/m\xB2/Jahr",
  r_unrealised_capital_gains_and_losses: "CHF",
  total_net_assets: "CHF",
  reported_rental_income: "CHF",
  charges: "CHF",
  c_agio_at_year_end: "%",
  ground_area: "m\xB2",
  roa: "%",
  transport_train: "m",
  r_roic: "%",
  m_dividend_yield: "%",
  office_area: "m\xB2",
  estimated_market_value: "CHF",
  r_property_tax: "CHF",
  roe: "%",
  fifty_two_weeks_low: "CHF",
  ebit_margin: "%",
  c_gav_after_distribution: "CHF",
  co2_scope_1_2_3_per_m2: "kg/m\xB2/Jahr",
  actual_rental_status_target: "CHF",
  built_up: {
    area: "m\xB2",
    ratio: "%"
  },
  c_weighted_average_cost_of_debt: "%",
  c_residential_market_value: "CHF",
  actual_rental_status_real: "CHF",
  co2_scope_33_per_m2: "kg/m\xB2/Jahr",
  rate: "%",
  reported_roa: "%",
  low: "CHF",
  fifty_two_weeks_high: "CHF",
  c_others_market_value: "CHF",
  three_years_return: "%",
  primary_education: "m",
  c_roe: "%",
  r_other_revenue: "CHF",
  restaurants: "m",
  three_months_return: "%",
  r_commercial_rental_space: "m\xB2",
  r_total_interest: "CHF",
  r_maintenance_and_repairs_expenses: "CHF",
  early_years: "m",
  market_value: "CHF",
  r_market_value_q3: "CHF/m\xB2",
  r_long_term_interest_bearing_mortgages: "CHF",
  roic: "%",
  ter_mv: "%",
  reported_total_rental_space: "m\xB2",
  listed_net_rent: "CHF",
  computed_ebit_margin: "%",
  r_net_assets_before_estimated_liquidation_taxes: "CHF",
  actual_market_value: "CHF",
  r_max_share_buyback_commissions: "%",
  total_gross_assets: "CHF",
  estimated_charges_per_m2: "CHF",
  r_max_property_management_fees: "%",
  r_nopat: "CHF",
  total_co2_scope_2: "kg/Jahr",
  market_capitalization: "CHF",
  r_co2_per_m2: "kg/m\xB2/Jahr",
  one_year_avg_volume: "Einheiten",
  r_plots_rental_space: "m\xB2",
  c_revenue_per_share: "CHF",
  r_roe: "%",
  official_ground_area: "m\xB2",
  green_density: "%",
  r_total_income: "CHF",
  estimated_market_value_per_m2: "CHF",
  open: "CHF",
  c_operating_profit: "CHF",
  yearly_management_fee: "%",
  r_dividend_from_direct_rental_income: "CHF",
  actual_rental_status: "CHF",
  rental_losses: "%",
  r_net_income: "CHF",
  gross_rent: "CHF",
  decibels: "dB",
  ter_gav: "%",
  r_max_construction_and_works_fees: "%",
  estimated_charges: "CHF",
  r_market_maker_fees: "CHF",
  r_rental_losses: "%",
  qtd_net_return: "%",
  industrial_area: "m\xB2",
  divorce: "%",
  r_rental_space: "m\xB2",
  r_market_value_q1: "CHF/m\xB2",
  co2_scope_1_per_m2: "kg/m\xB2/Jahr",
  r_total_dividend: "CHF",
  reported_capital_employed: "CHF",
  c_gav_compounded: "CHF",
  r_max_share_issue_commissions: "%",
  implied_volatility: "%",
  vwap: "CHF",
  r_market_cap: "CHF",
  real_net_rent_monthly: "CHF",
  potential_charges: "CHF",
  m_share_price_var: "%",
  reported_wault: "Jahr",
  marriage: "%",
  r_commercial_market_value: "CHF",
  hist_volatility_90_days: "%",
  co2_m2: "kg/m\xB2/Jahr",
  c_net_rent_median: "CHF/m\xB2",
  r_market_value: "CHF",
  r_target_rent: "CHF",
  reported_cost_price: "CHF",
  minute: "min",
  return_on_asset: "%",
  r_mortgage_interest: "CHF",
  c_market_value_q3: "CHF/m\xB2",
  household_size: "Personen",
  r_total_cash: "CHF",
  real_rent: "CHF",
  c_commercial_net_rent: "CHF",
  r_mixed_net_rent: "CHF",
  r_max_custodian_bank_fees: "%",
  computed_net_initial_yield: "%",
  emigration: "%",
  hist_volatility_250_days: "%",
  r_other_short_term_liabilities: "CHF",
  market_price: "CHF",
  alpha: "%",
  payout_ratio: "%",
  transport_bus: "m",
  immigration: "%",
  rent_default_rate: "%",
  per_mill: "\u2030",
  reported_share_price: "CHF",
  r_total_area: "m\xB2",
  estimated_total_net_rent: "CHF",
  r_other_net_rent: "CHF",
  r_other_assets: "CHF",
  r_other_long_term_liabilities: "CHF",
  total_co2_scope_1: "kg/Jahr",
  computed_price_to_book_value: "%",
  r_ter_nav: "%",
  r_building_expenses: "CHF",
  r2: "%",
  five_days_avg_volume: "Einheiten",
  r_net_rent_q3: "CHF/m\xB2",
  r_negative_interest: "CHF",
  r_cost_price: "CHF",
  estimated_roa: "%",
  swiss_francs: "CHF",
  reported_purchase_and_sale_fees: "%",
  reported_long_term_liabilities: "CHF",
  reported_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  computed_three_years_total_return: "%",
  reported_total_revenue: "CHF",
  reported_total_properties: "CHF",
  reported_total_dividend: "CHF",
  computed_gav_after_distribution: "CHF",
  reported_short_term_interest_bearing_mortgages: "CHF",
  reported_net_income_available_for_distribution: "CHF",
  reported_ter_nav: "%",
  reported_absolute_management_fees: "CHF",
  reported_other_interest: "CHF",
  computed_current_agio_after_distribution: "%",
  computed_operating_profit: "CHF",
  reported_nav_before_distribution: "CHF",
  reported_share_issue_commissions: "%",
  reported_other_revenue: "CHF",
  reported_net_income: "CHF",
  computed_five_years_total_return: "%",
  market_last: "CHF",
  reported_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  reported_tga_before_distribution: "CHF",
  reported_net_assets_before_estimated_liquidation_taxes: "CHF",
  reported_dividend_from_indirect_rental_income: "CHF",
  reported_other_long_term_liabilities: "CHF",
  computed_gav_compounded: "CHF",
  reported_absolute_custodian_bank_fees: "CHF",
  reported_construction_and_works_fees: "%",
  market_five_years_return: "%",
  reported_short_term_liabilities: "CHF",
  reported_total_interest: "CHF",
  reported_ter_mv: "%",
  market_fifty_two_weeks_high: "CHF",
  market_vwap: "CHF",
  computed_tna_compounded: "CHF",
  market_six_months_return: "%",
  reported_total_cash: "CHF",
  market_one_month_return: "%",
  reported_total_income: "CHF",
  listed_total_charges: "CHF",
  reported_custodian_bank_fees: "%",
  reported_total_liabilities: "CHF",
  reported_other_assets: "CHF",
  reported_realised_income: "CHF",
  computed_nav_after_distribution: "CHF",
  reported_auditing_expenses: "CHF",
  reported_unrealised_capital_gains_and_losses: "CHF",
  reported_long_term_interest_bearing_mortgages: "CHF",
  reported_negative_interest: "CHF",
  computed_current_liabilities: "CHF",
  computed_total_current_agio_after_distribution: "CHF",
  market_share_price: "CHF",
  reported_total_expenses: "CHF",
  reported_dividend_from_direct_rental_income: "CHF",
  reported_management_fees: "%",
  market_one_year_total_return: "%",
  reported_valuation_and_auditing_expenses: "CHF",
  reported_net_assets_at_beginning_of_the_financial_year: "CHF",
  market_five_years_total_return: "%",
  reported_building_expenses: "CHF",
  listed_total_net_rent: "CHF",
  reported_property_management_fees: "%",
  reported_market_cap: "CHF",
  reported_other_short_term_liabilities: "CHF",
  reported_dividend_distribution: "CHF",
  reported_mortgage_interest: "CHF",
  reported_taxes: "CHF",
  reported_tna_before_distribution: "CHF",
  market_ytd_net_return: "%",
  reported_nopat: "CHF",
  reported_retained_earnings: "CHF",
  market_one_year_return: "%",
  reported_ter_gav: "%",
  listed_charges_monthly: "CHF",
  market_share_price_var: "%",
  market_fifty_two_weeks_low: "CHF",
  reported_valuation_expenses: "CHF",
  reported_other_expenses: "CHF",
  market_three_years_return: "%",
  reported_capital_distribution: "CHF",
  reported_estimated_liquidation_taxes: "CHF",
  reported_tga_after_distribution: "CHF",
  reported_share_buyback_commissions: "%",
  market_turnover: "CHF",
  market_five_years_avg_dividend_yield: "%",
  computed_current_agio_compounded: "%",
  computed_total_agio_at_year_end: "CHF",
  reported_dividend_from_capital_gains: "CHF",
  reported_administration_of_buildings: "CHF",
  computed_nav_compounded: "CHF",
  computed_total_current_agio_compounded: "CHF",
  market_dividend_yield: "%",
  reported_revenue_from_postal_and_bank_accounts: "CHF",
  reported_maintenance_and_repairs_expenses: "CHF",
  reported_profit_and_capital_taxes: "CHF",
  computed_tga_compounded: "CHF",
  market_three_months_return: "%",
  market_high: "CHF",
  reported_realised_capital_gains_and_losses: "CHF",
  reported_property_tax: "CHF",
  listed_net_rent_monthly: "CHF",
  reported_tna_after_distribution: "CHF",
  reported_agio_at_year_end: "%",
  reported_gav_before_distribution: "CHF"
};
var license_agreement = {
  part7: {
    content6: "tritt in eine Vereinbarung oder einen Vergleich mit seinen Gl\xE4ubigern im Allgemeinen ein oder schl\xE4gt diesen vor ; oder",
    content8: "Jede Partei kann die Lizenz durch schriftliche Mitteilung an die andere Partei k\xFCndigen, falls die andere Partei eine wesentliche Bestimmung dieser EULA verletzt hat und die Verletzung nicht innerhalb von drei\xDFig (30) Tagen nach Erhalt der schriftlichen Mitteilung durch die betroffene Partei behoben wurde. Eine solche K\xFCndigung l\xF6st kein Recht Ihrerseits auf R\xFCckerstattung aus.",
    content3: "ist nicht in der Lage, seine Schulden zu begleichen oder wird zahlungsunf\xE4hig ;",
    content1: "Die Lizenz ist f\xFCr die im entsprechenden TD genannte Laufzeit g\xFCltig. In Abwesenheit solcher im TD festgelegten Bedingungen ist die Lizenz ab dem Datum der Unterzeichnung des TD durch beide Parteien ein Jahr lang g\xFCltig und verl\xE4ngert sich automatisch um jeweils ein Jahr, es sei denn, eine der Parteien k\xFCndigt mit einer Frist von drei Monaten schriftlich.",
    title: "7. Begriff",
    content4: "ist Gegenstand eines erlassenen Auftrags oder eines gefassten Beschlusses zur Verwaltung, Abwicklung oder Aufl\xF6sung (au\xDFer zum Zweck einer solventen Fusion oder Rekonstruktion);",
    content5: "hat einen Verwaltungs- oder anderen Empf\xE4nger, Manager, Treuh\xE4nder, Liquidator, Administrator oder einen \xE4hnlichen Beamten ernannt, der \xFCber alle oder einen wesentlichen Teil seiner Verm\xF6genswerte eingesetzt ist;",
    content10: "Die Beendigung dieses EULA hat keine Auswirkungen auf etwaige aufgelaufene Anspr\xFCche, Rechte oder Verbindlichkeiten der Parteien, noch wird sie die Fortgeltung der folgenden Klauseln beeinflussen: 6, 11 und 13.",
    content2: "Jede Partei hat das Recht, unbeschadet ihrer anderen Rechte oder Rechtsmittel, die Lizenz sofort durch schriftliche Mitteilung an die andere Partei zu k\xFCndigen, wenn die andere Partei:",
    content7: "ist Gegenstand von Ereignissen oder Umst\xE4nden, die den oben genannten in einer anwendbaren Gerichtsbarkeit \xE4hnlich sind.",
    content9: "QUANTHOME kann die Lizenz ferner mit einer Frist von drei\xDFig (30) Tagen durch schriftliche Mitteilung k\xFCndigen, wenn Sie die APP nutzen, um gegen geltendes Recht im Zusammenhang mit der Nutzung der APP zu versto\xDFen, insbesondere gegen die Gesetze der Schweiz, oder wenn QUANTHOME vern\xFCnftigerweise der Ansicht ist, dass seine Marken oder sein Ruf durch Ihr Handeln oder Unterlassen gesch\xE4digt werden. Eine solche K\xFCndigung l\xF6st kein Recht Ihrerseits auf R\xFCckerstattung aus."
  },
  part8: {
    content7: "QUANTHOME \xDCBERNIMMT KEINE VERANTWORTUNG ODER HAFTUNG, WENN DIE APP IN IRGENDEINER WEISE MODIFIZIERT WURDE, ODER F\xDCR JEGLICHE FEHLER, DIE AUS DER NUTZUNG DER APP MIT EINER ANDEREN ALS DER EMPFOHLENEN HARDWAREKONFIGURATION, PLATTFORM ODER BETRIEBSSYSTEM ENTSTEHEN.",
    content6: "KEINE M\xDCNDLICHE ODER SCHRIFTLICHE INFORMATION ODER BERATUNG, DIE VON QUANTHOME, SEINEN H\xC4NDLERN, DISTRIBUTOREN, AGENTEN ODER MITARBEITERN GEGEBEN WIRD, ERSCHAFFT EINE GARANTIE ODER ERWEITERT IN IRGENDEINER WEISE DEN UMFANG EINER HIERIN BEREITGESTELLTEN GARANTIE.",
    content4: "DER INHALT DER APP KANN INFORMATIONEN ENTHALTEN, DIE VON DRITTQUELLEN STAMMEN, UND QUANTHOME \xDCBERNIMMT KEINE VERANTWORTUNG ODER HAFTUNG F\xDCR DIE GENAUIGKEIT ODER VOLLST\xC4NDIGKEIT SOLCHER INFORMATIONEN.",
    content5: "AUSDR\xDCCKLICH GIBT ES KEINE GARANTIE F\xDCR NICHTVERLETZUNG UND TITEL ODER RUHIGEN GENUSS. QUANTHOME GARANTIERT NICHT, DASS DIE APP FEHLERFREI IST ODER UNTERBRECHUNGSFREI FUNKTIONIERT. ES WERDEN KEINE RECHTE ODER RECHTSMITTEL AN SIE \xDCBERTRAGEN. DIE APP IST NICHT F\xDCR DIE NUTZUNG IN GEF\xC4HRLICHEN UMGEBUNGEN ENTWORFEN, BEABSICHTIGT ODER LIZENZIERT, DIE FEHLERSICHERE STEUERUNGEN ERFORDERN, EINSCHLIESSLICH, ABER NICHT BESCHR\xC4NKT AUF, DIE PLANUNG, DEN BAU, DIE WARTUNG ODER DEN BETRIEB VON KERNANLAGEN, FLUGZEUGNAVIGATION ODER KOMMUNIKATIONSSYSTEMEN, LUFTRAUM\xDCBERWACHUNG UND LEBENSUNTERST\xDCTZUNG ODER WAFFENSYSTEMEN. QUANTHOME SCHLIESST AUSDR\xDCCKLICH JEGLICHE AUSDR\xDCCKLICHE ODER IMPLIZITE GARANTIE F\xDCR SOLCHE ZWECKE AUS.",
    content3: "DER INHALT DER APP IST NICHT ALS UMFASSEND ANGESEHEN UND SOLL KEINE ERSATZ F\xDCR PROFESSIONELLE INVESTITIONS-, STEUER-, RECHTS- ODER ANDERE BERATUNG SEIN. SIE SOLLTEN IHRE FINANZ-, STEUER- ODER RECHTSBERATER ZUR INFORMATION \xDCBER IHRE INDIVIDUELLE SITUATION KONSULTIEREN.",
    title: "8. Haftungsausschluss f\xFCr Garantien",
    content1: "SIE BEST\xC4TIGEN AUSDR\xDCCKLICH UND STIMMEN ZU, DASS DIE NUTZUNG DER APP AUF IHR EIGENES UND ALLEINIGES RISIKO ERFOLGT. DIE APP WIRD \u201EWIE BESEHEN\u201C OHNE JEGLICHE GARANTIE VON QUANTHOME, SEINEN DIREKTOREN, MITARBEITERN, BEAUFTRAGTEN UND/ODER PARTNERN BEREITGESTELLT. SOWEIT VON DER ANWENDBAREN GESETZGEBUNG ERLAUBT, SCHLIESST QUANTHOME UND SEINE LIEFERANTEN UND PARTNER AUSDR\xDCCKLICH ALLE GARANTIEN UND ZUSICHERUNGEN AUS, OB AUSDR\xDCCKLICH, STILLSCHWEIGEND ODER ANDERS, EINSCHLIESSLICH DER GARANTIEN F\xDCR MARKTF\xC4HIGKEIT ODER EIGNUNG F\xDCR EINEN BESTIMMTEN ZWECK.",
    content2: "DER INHALT, DER \xDCBER DIE APP BEREITGESTELLT WIRD, DARF NICHT ALS ANLAGEBERATUNG, EMPFEHLUNG ODER ANGEBOT ZUM KAUF ODER VERKAUF IRGENDEINER FINANZINSTRUMENTE ODER ZUR TEILNAHME AN EINER BESTIMMTEN HANDELSSTRATEGIE INTERPRETIERT WERDEN. JEGLICHES VERTRAUEN, DAS SIE AUF DIESEN INHALT SETZEN, GESCHIEHT DAHER AUSSCHLIESSLICH AUF IHR EIGENES RISIKO."
  },
  part11: {
    content11: "Die Verarbeitung dieser Daten erfolgt gem\xE4\xDF unserer Datenschutzrichtlinie, die Sie hier finden k\xF6nnen.",
    content4: "verschl\xFCsseltes Passwort",
    content7: "Login- und Logout-Aktivit\xE4t (QUANTHOME beh\xE4lt sich das Recht vor, die allgemeine Aktivit\xE4t der Nutzer auf unserer Plattform zu protokollieren und zu \xFCberwachen, einschlie\xDFlich aber nicht beschr\xE4nkt auf die Navigation auf der Plattform, die durchgef\xFChrten Aktionen und die besuchten Seiten, um die Benutzererfahrung zu verbessern, die Sicherheit zu gew\xE4hrleisten und unsere Dienstleistungen zu optimieren)",
    content2: "vollst\xE4ndiger Name",
    content8: "Fehler, Ausf\xE4lle und Abst\xFCrze von APP und Ger\xE4ten",
    content3: "gesch\xE4ftliche E-Mail",
    content1: "Sie stimmen zu, dass die einzigen Personendaten, die von QUANTHOME infolge Ihres Zugriffs und Ihrer Nutzung der APP verarbeitet werden, bestehen aus:",
    content9: "f\xFCr jeden Benutzer, zu jeder Zeit (die \u201C<strong>Daten</strong>\u201D).",
    content6: "IP und Benutzeragent f\xFCr jede Session",
    content10: "Zus\xE4tzliche Informationen k\xF6nnen im Zusammenhang mit spezifischen TDs gesammelt und verarbeitet werden, und dies mit ausdr\xFCcklicher Zustimmung des Kunden.",
    content5: "ID und Name der Entit\xE4t, f\xFCr die der Benutzer Administrator, Mitglied oder Betreiber ist",
    title: "11. Datenschutz"
  },
  part12: {
    content7: "Nichts in dieser Endbenutzer-Lizenzvereinbarung (EULA) darf so ausgelegt werden, dass es eine Partnerschaft, Agentur, Joint Venture oder ein Arbeitgeber/Arbeitnehmer-Verh\xE4ltnis zwischen den Parteien schafft. Keine der Parteien hat die Befugnis, eine Verpflichtung oder Verantwortung, ausdr\xFCcklich oder stillschweigend, im Namen der anderen Partei zu \xFCbernehmen oder zu schaffen oder diese andere Partei in irgendeiner Weise zu binden.",
    content6: "Alle Mitteilungen gem\xE4\xDF dem EULA m\xFCssen schriftlich erfolgen und an die im EULA angegebene Gesch\xE4ftsadresse gesendet werden, es sei denn, eine Partei gibt schriftlich eine andere Adresse an. Die Parteien stimmen der Verwendung elektronischer Mittel und von Fax\xFCbertragungen f\xFCr Mitteilungen zu, die als unterzeichnete Schrift gelten. Jede Reproduktion des EULA, die durch zuverl\xE4ssige Mittel erstellt wird, gilt als Original.",
    content2: "Die Bestimmungen dieser EULA sind trennbar, sodass die Ung\xFCltigkeit einer Bestimmung dieser EULA, die von einem zust\xE4ndigen Gericht erkl\xE4rt wird, die G\xFCltigkeit der anderen Bestimmungen nicht beeintr\xE4chtigt. Jede solche ung\xFCltige Bestimmung unterliegt einer teilweisen Durchsetzung gem\xE4\xDF der urspr\xFCnglichen gemeinsamen Absicht der Parteien in dem maximalen Umfang, der nach geltendem Recht zul\xE4ssig ist.",
    content1: "Diese EULA oder der zugeh\xF6rige TD darf von Ihnen ohne die vorherige schriftliche Zustimmung von QUANTHOME nicht \xFCbertragen werden.",
    content5: "Im Falle von h\xF6herer Gewalt oder anderen au\xDFergew\xF6hnlichen Ereignissen (\u201E<strong>Force Majeure</strong>\u201C), f\xFCr die QUANTHOME nicht verantwortlich ist und die es unm\xF6glich oder erheblich schwieriger machen, die APP zu betreiben, kann QUANTHOME die APP w\xE4hrend der Dauer dieses Hindernisses einschr\xE4nken oder aussetzen oder die Endbenutzer-Lizenzvereinbarung (EULA) k\xFCndigen. H\xF6here Gewalt umfasst, ist aber nicht beschr\xE4nkt auf, Krieg, Unruhen, Rebellion, Sabotageakte und \xE4hnliche Ereignisse, Streiks oder andere industrielle Konflikte, neu erlassene Gesetze und Vorschriften, Verz\xF6gerungen, die durch Handlungen oder Unterlassungen von Seiten einer Regierung/Beh\xF6rden verursacht werden, Feuer, Explosionen oder andere unvermeidbare Ereignisse, Epidemien, Pandemien, \xDCberschwemmungen, St\xFCrme, Erdbeben oder andere au\xDFergew\xF6hnliche Naturereignisse. Unter keinen Umst\xE4nden kann QUANTHOME f\xFCr Anspr\xFCche im Zusammenhang mit Nichterf\xFCllung, unsachgem\xE4\xDFer Erf\xFCllung oder versp\xE4teter Erf\xFCllung von vertraglichen Verpflichtungen aufgrund solcher Ereignisse h\xF6herer Gewalt haftbar gemacht werden.",
    title: "12. Sonstiges",
    content4: "Das Vers\xE4umnis einer Partei, auf die strikte Erf\xFCllung einer Bestimmung hiervon zu bestehen, stellt keinen Verzicht auf diese Bestimmung oder einen Verzicht auf einen sp\xE4teren Versto\xDF gegen dieselbe Bestimmung dar. Alle Verzichtserkl\xE4rungen m\xFCssen schriftlich erfolgen, um hierunter durchsetzbar zu sein.",
    content3: "Diese EULA stellt die gesamte Vereinbarung zwischen den Parteien bez\xFCglich des Gegenstands dar und ersetzt alle vorherigen Vereinbarungen und Mitteilungen, sei es m\xFCndlich oder schriftlich, zwischen den Parteien in Bezug auf den Gegenstand und alle bisherigen Gesch\xE4ftspraktiken oder Branchengepflogenheiten. Wie hierin verwendet, bedeutet der Begriff \u201Eeinschlie\xDFlich\u201C \u201Eeinschlie\xDFlich, aber nicht beschr\xE4nkt auf\u201C."
  },
  part9: {
    content4: "DIE VORSTEHENDEN HAFTUNGSBEGRENZUNGEN SIND DARAUF AUSGERICHTET, F\xDCR ALLE BESTIMMUNGEN DIESER ENDNUTZER-LIZENZVERTRAG GILT.",
    title: "9. HAFTUNGSBESCHR\xC4NKUNG",
    content3: "UNTER KEINEN UMST\xC4NDEN HAFTET QUANTHOME ODER SEINE PARTNER F\xDCR EINE UNBEFUGTE NUTZUNG DER APP ZUR ENTWICKLUNG, VERBREITUNG ODER NUTZUNG VON MATERIALIEN, DIE VERLEUMDERISCH, EHRVERLETZEND, BELEIDIGEND ODER OBSZ\xD6N SIND, DIE EINE PERSON IN EINEM FALSCHEN LICHT DARSTELLEN ODER EINE VERLETZUNG EINES RECHTS AUF PRIVATSPH\xC4RE DARSTELLEN, DIE DIE RECHTE DRITTER VERLETZEN ODER DIE GEGEN AUSL\xC4NDISCHE, BUNDESSTAATLICHE ODER LOKALE GESETZE ODER VORSCHRIFTEN VERSTO\xDFEN.",
    content1: "SOWEIT ES DAS ANWENDBARE RECHT ERLAUBT, HAFTEN WEDER QUANTHOME NOCH SEINE LIEFERANTEN UND PARTNER IHNEN ODER DRITTEN GEGEN\xDCBER F\xDCR INDIREKTE, BESONDERE, NEBEN-, STRAF-, DECKUNGS- ODER FOLGESCH\xC4DEN (EINSCHLIESSLICH, ABER NICHT BESCHR\xC4NKT AUF SCH\xC4DEN F\xDCR DIE UNM\xD6GLICHKEIT, AUSR\xDCSTUNG ZU BENUTZEN ODER AUF DATEN ZUZUGREIFEN, GESCH\xC4FTSVERLUSTE, GEWINNVERLUSTE, UNTERBRECHUNG DES GESCH\xC4FTSBETRIEBS ODER \xC4HNLICHES), DIE AUS DER NUTZUNG DER APP ODER DER UNM\xD6GLICHKEIT DER NUTZUNG DER APP RESULTIEREN UND AUF JEDER HAFTUNGSTHEORIE BASIEREN, EINSCHLIESSLICH VERTRAGSBRUCH, GARANTIEVERLETZUNG, DELIKT (EINSCHLIESSLICH FAHRL\xC4SSIGKEIT), PRODUKTHAFTUNG ODER ANDEREN, AUCH WENN QUANTHOME ODER SEINE VERTRETER \xDCBER DIE M\xD6GLICHKEIT SOLCHER SCH\xC4DEN INFORMIERT WURDEN UND AUCH WENN EIN HIERIN FESTGELEGTER RECHTSBEHEB ALS FEHLGESCHLAGEN ANGESEHEN WIRD, SEINEN WESENTLICHEN ZWECK NICHT ZU ERREICHEN.",
    content2: "QUANTHOME \xDCBERNIMMT KEINE FINANZIELLE HAFTUNG im gr\xF6\xDFtm\xF6glichen Umfang, der nach geltendem Recht zul\xE4ssig ist."
  },
  part1: {
    title: "1. Definitionen",
    content2: "<strong>EULA</strong> bedeutet diesen Endbenutzer-Lizenzvertrag;",
    content1: "<strong>APP</strong> bezeichnet die von QUANTHOME bereitgestellte Webanwendung sowie, falls zutreffend, die entsprechende Dokumentation, zugeh\xF6rige Medien, gedruckte Materialien und Online- oder elektronische Dokumentation sowie alle Updates oder Upgrades der vorgenannten, die Ihnen zur Verf\xFCgung gestellt werden;",
    content3: "<strong>QUANTHOME</strong> bedeutet Quanthome SA, IDE: CHE-321.617.538, mit Sitz in Lausanne, Schweiz."
  },
  part2: {
    content: "QUANTHOME gew\xE4hrt Ihnen hiermit ein begrenztes, nicht exklusives, nicht \xFCbertragbares und nicht unterlizenzierbares Recht zur Nutzung der APP f\xFCr einen einmaligen Zeitraum von 365 Tagen nach dem Kauf einer Jahreslizenz gem\xE4\xDF dem im Anhang aufgef\xFChrten Transaktionsdokument (\u201E<strong>TD</strong>\u201C).",
    title: "2. Lizenz zur Nutzung der APP"
  },
  part13: {
    title: "13. Anwendbares Recht und Gerichtsbarkeit",
    content1: "Diese EULA unterliegt dem materiellen Recht der Schweiz, ohne dass die Grunds\xE4tze des internationalen Privatrechts Anwendung finden, insbesondere unter Ausschluss des \xDCbereinkommens der Vereinten Nationen \xFCber Vertr\xE4ge \xFCber den internationalen Warenverkauf. Dasselbe gilt f\xFCr jede TD, die im Rahmen dieser EULA abgeschlossen wird.",
    content2: "Jede Streitigkeit, die sich aus oder im Zusammenhang mit diesem EULA ergibt, unterliegt der ausschlie\xDFlichen Zust\xE4ndigkeit der ordentlichen Gerichte von Lausanne, Schweiz, denen die Parteien hiermit unwiderruflich zustimmen, unterworfen zu werden. Dasselbe gilt f\xFCr jeden TD, der im Rahmen dieses EULA abgeschlossen wird."
  },
  part3: {
    content1: "Sie d\xFCrfen die APP in keiner Weise reproduzieren oder Kopien davon verteilen, die APP in irgendeiner Weise Dritten zur Verf\xFCgung stellen, die APP auf einer Website hochladen oder die APP von einem Computer auf einen anderen oder \xFCber ein Netzwerk elektronisch \xFCbertragen, es sei denn, dies ist ausdr\xFCcklich gem\xE4\xDF den Bedingungen dieses EULA autorisiert.",
    content5: "Sie d\xFCrfen Ihr Konto nicht mit einer anderen Person oder Einrichtung teilen, wodurch Sie Ihr Kontonutzerlimit \xFCberschreiten.",
    content6: "Sie d\xFCrfen die APP nicht \xE4ndern oder abgeleitete Werke auf der Grundlage der APP erstellen.",
    content3: "Sie d\xFCrfen die APP nicht verkaufen, vermieten, verpachten, ausleihen oder unterlizenzieren.",
    content2: "Sie d\xFCrfen die APP weder ver\xE4ndern, zusammenf\xFChren, anpassen oder \xFCbersetzen, noch dekompilieren, r\xFCckentwickeln, disassemblieren oder die APP in sonstiger Weise in eine f\xFCr Menschen wahrnehmbare Form bringen. Ebenso ist es Ihnen untersagt, irgendwelche Handlungen vorzunehmen, die darauf abzielen oder dazu f\xFChren k\xF6nnten, den ordnungsgem\xE4\xDFen und/oder sicheren Betrieb der APP zu umgehen, zu beeintr\xE4chtigen oder au\xDFer Kraft zu setzen (oder dies zu erleichtern, zu modifizieren oder dabei behilflich zu sein), oder in irgendeiner Weise ein von QUANTHOME gehaltenes Patent oder eine von QUANTHOME eingereichte Patentanmeldung zu verletzen.",
    content4: "Sie d\xFCrfen die Ergebnisse der Nutzung der APP (insbesondere die Daten) nicht verteilen, vermieten, verpachten oder verkaufen.",
    title: "3. Lizenzbeschr\xE4nkungen"
  },
  part6: {
    content1: "Sie stimmen zu, alle anwendbaren Geb\xFChren zu zahlen, die in einem TD angegeben sind, sowie Geb\xFChren f\xFCr die Nutzung, die diese Genehmigungen \xFCberschreiten. Betr\xE4ge sind bei Erhalt der Rechnung f\xE4llig und innerhalb von 30 Tagen nach Rechnungsdatum auf ein von QUANTHOME angegebenes Konto zahlbar, und es k\xF6nnen Verzugsgeb\xFChren anfallen. QUANTHOME gew\xE4hrt keine Gutschriften oder R\xFCckerstattungen f\xFCr bereits f\xE4llige, bezahlte oder verpflichtete Vorauszahlungen, einmalige Geb\xFChren oder andere Geb\xFChren. QUANTHOME kann die Geb\xFChren bei der Erneuerung eines TD mit einer Frist von f\xFCnfundvierzig (45) Tagen schriftlich an Sie \xE4ndern.",
    content2: "QUANTHOME wird die f\xE4lligen Geb\xFChren j\xE4hrlich zu Beginn jeder Vertragslaufzeit in Rechnung stellen, au\xDFer bei \xDCbernutzung, die gegebenenfalls r\xFCckwirkend in Rechnung gestellt wird.",
    title: "6. Geb\xFChren und Zahlung f\xFCr TD"
  },
  part4: {
    content1: "Die vorstehende Lizenz gew\xE4hrt Ihnen eine eingeschr\xE4nkte Lizenz zur Nutzung der APP und es wird Ihnen hiermit keine andere Lizenz oder kein anderes Recht, weder ausdr\xFCcklich noch durch stillschweigende Zustimmung, gew\xE4hrt. QUANTHOME und seine Lieferanten und Partner behalten sich alle Rechte, Titel und Interessen vor, einschlie\xDFlich aller Urheberrechte und geistigen Eigentumsrechte, an der APP und allen Kopien davon.",
    title: "4. Eigentum",
    content2: "Alle Rechte, die in diesem EULA nicht ausdr\xFCcklich gew\xE4hrt werden, einschlie\xDFlich, aber nicht beschr\xE4nkt auf nationale und internationale Urheberrechte, sind vorbehalten von QUANTHOME, seinen Lieferanten und seinen Partnern."
  },
  update: {
    title: "Wir haben unser Lizenzvertrag aktualisiert."
  },
  input: {
    label: "Ich stimme dem Lizenzvertrag zu.",
    title: "Bitte best\xE4tigen Sie, dass Sie unseren <span>Lizenzvertrag</span> gelesen und akzeptiert haben.",
    error: "Es ist zwingend erforderlich, dem Lizenzvertrag zuzustimmen, um auf die App zuzugreifen."
  },
  part5: {
    content1: "Gem\xE4\xDF den Bedingungen dieser EULA stimmen Sie zu, die von QUANTHOME gelegentlich festgelegten Regeln und Richtlinien in Bezug auf die Updates und Sicherheitskomponenten der APP einzuhalten. QUANTHOME verpflichtet sich, diese Regeln und Richtlinien auf nicht diskriminierende Weise gegen\xFCber den Nutzern der APP anzuwenden, wobei diese Regeln beispielsweise, aber nicht ausschlie\xDFlich, erforderliche oder automatisierte Updates, \xC4nderungen und/oder Installationen der APP zur Behebung von Sicherheits-, Interoperabilit\xE4ts- und/oder Leistungsproblemen umfassen.",
    content2: "Diese Aktualisierungen, \xC4nderungen und dergleichen k\xF6nnen regelm\xE4\xDFig oder nach Bedarf erfolgen, ohne vorherige Benachrichtigung an Sie.",
    title: "5. Aktualisierungen, Sicherheit und Widerruf"
  },
  part10: {
    content2: "Die Einschr\xE4nkungen oder Ausschl\xFCsse von Garantien und Haftung, die in diesem EULA enthalten sind, beeintr\xE4chtigen oder benachteiligen nicht die gesetzlichen Rechte eines Verbrauchers.",
    title: "10. Nur Endverbraucher",
    content1: "Die Einschr\xE4nkungen oder Ausschl\xFCsse von Garantien und Haftung, die in diesem EULA enthalten sind, beeintr\xE4chtigen oder benachteiligen nicht die gesetzlichen Rechte eines Verbrauchers."
  },
  title: "Endbenutzer-Lizenzvertrag f\xFCr die Webanwendung von Quanthome SA",
  intro: {
    first: "WICHTIG: DIESER ENDBENUTZER-LIZENZVERTRAG (<strong>EULA</strong>) IST EIN RECHTLICH VERBINDLICHER VERTRAG ZWISCHEN IHNEN (ENTWEDER EINER PERSON ODER EINER EINHEIT) UND QUANTHOME. LESEN SIE DIESE VEREINBARUNG SORGF\xC4LTIG DURCH, BEVOR SIE DIE WEBANWENDUNG (<strong>APP</strong>) NUTZEN. SIE BEINHALTET EINE LIZENZ ZUR NUTZUNG DER APP UND ENTH\xC4LT GARANTIEINFORMATIONEN UND HAFTUNGSAUSSCHL\xDCSSE. INDEM SIE DEN BUTTON \u201EICH AKZEPTIERE\u201C AUSW\xC4HLEN UND DIE APP NUTZEN, BEST\xC4TIGEN SIE IHRE AKZEPTANZ DER APP UND STIMMEN ZU, AN DIE BEDINGUNGEN DIESER EULA GEBUNDEN ZU SEIN.",
    second: "WENN SIE NICHT EINVERSTANDEN SIND, AN DIESE BEDINGUNGEN GEBUNDEN ZU SEIN, DANN BENUTZEN SIE DIE APP NICHT."
  }
};
var funds = {
  environmental: {
    risks: {
      computed_climate_avg_rate: {
        key: "Erwarteter j\xE4hrlicher Schaden je 1'000 CHF",
        description: "Erwarteter gesamter j\xE4hrlicher Schaden an den Fondsgeb\xE4uden durch Hagel, \xFCberschwemmungen und St\xFCrme in CHF"
      },
      computed_climate_avg_value: {
        description: "Erwarteter gesamter j\xE4hrlicher Schaden in CHF an den Fondsgeb\xE4uden durch Hagel, \xFCberschwemmungen und St\xFCrme",
        key: "Erwarteter gesamter j\xE4hrlicher Hagelschaden in CHF"
      }
    },
    title: "Umwelt",
    hail_hazard_10_years: "Hagelkorngr\xF6ssen",
    climate: {
      risk: {
        description: "Der Klimarisiko-Index basiert auf der Exposition der Geb\xE4ude innerhalb von Anlagevehikeln gegen\xFCber verschiedenen Umweltrisiken. Jedes Risiko wird im Index gleich gewichtet."
      }
    },
    building_with_solar_existing: "Geb\xE4ude mit Photovoltaikanlage",
    share: {
      fossil: "Anteil fossile Energie",
      r_coverage_share_fossil: "Abdeckung",
      coverage: "Deckungsgrad",
      r_share_fossil: "Anteil fossile Energietr\xE4ger",
      non_fossil: "Anteil nicht-fossile Energie"
    },
    tile: {
      environmental_risks_details: "Details",
      environmental_risks_total: "Total",
      energy_source: "Energiequelle",
      environmental_risks: "Umweltgefahren",
      solar: "Solar",
      climate_risk_index: "Klimarisikoindex",
      share: "Energieanteil",
      idc_and_co2: "Energieintensit\xE4t & CO\u2082"
    },
    solar_potential: "Gesamtes Solarpotenzial",
    estimated_co2_emission_per_m2: "CO\u2082 pro m\xB2",
    idc: {
      idc_per_m2: {
        description: "Die CO\u2082-Emissionen werden berechnet, indem f\xFCr jedes Geb\xE4ude die Energieintensit\xE4t mit dem entsprechenden REIDA-Koeffizienten multipliziert wird. Die gesamten CO\u2082-Emissionen des Anlagevehikels ergeben sich aus einem gewichteten Durchschnitt aller Geb\xE4ude, wobei jedes Geb\xE4ude entsprechend seiner Heizfl\xE4che gewichtet wird.",
        key: "Energieintensit\xE4t"
      },
      r_idc: "Gesamtenergie",
      r_coverage_idc: "Abdeckung",
      title: "Energieintensit\xE4t",
      total_idc: "Gesamtenergie",
      r_idc_per_m2: "Energieintensit\xE4t"
    },
    avalanches: "Lawinen",
    estimated_idc_per_m2: "Energieintensit\xE4t pro m\xB2",
    computed_windstorm_avg_rate: "Sturm",
    total_estimated_idc: "Gesamte Energieintensit\xE4t",
    sia261: "SIA261",
    computed_hail_avg_rate: "Hagelkorn",
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (Scope 1 + 2 + 3.3)",
      total_co2_scope_1_2_33: "Total CO\u2082 (Scope 1 + 2 + 3.3)",
      title: "CO\u2082-Emissionen",
      co2_scope_1_per_m2: "CO\u2082 (Scope 1)",
      r_coverage_co2: "Abdeckung",
      co2_scope_2_per_m2: "CO\u2082 (Scope 2)",
      co2_scope_1_2_per_m2: {
        key: "CO\u2082 (Scope 1 + 2)",
        description: "Die CO\u2082-Emissionen werden berechnet, indem die Energieintensit\xE4t mit dem REIDA-Koeffizienten f\xFCr jedes Geb\xE4ude multipliziert wird. Die gesamten CO\u2082-Emissionen des Anlagevehikels werden anschlie\xDFend als gewichteter Durchschnitt der Geb\xE4ude ermittelt."
      },
      r_co2_per_m2: "CO\u2082-Emissionen",
      co2_scope_33_per_m2: "CO\u2082 (Scope 3.3)",
      r_co2: "Gesamte CO\u2082-Emissionen",
      total_co2_scope_1_2: "Gesamt CO\u2082 (Scope 1 + 2)"
    },
    risk: {
      title: "Risiko"
    },
    total_estimated_co2_emission: "Gesamt CO\u2082",
    overbank_sedimentation: "Sedimentation im \xDCberflutungsbereich",
    energy: {
      title: "Energie"
    },
    floods_50_years: "\xDCberschwemmungen",
    landslides: "Erdrutsche",
    debris_flow: "Tr\xFCmmerstrom",
    evolution: {
      chart: {
        title: "Diagramm"
      },
      title: "Entwicklung"
    },
    press_score: "Umwelt-PRESS-Score:",
    computed_flood_avg_rate: "\xDCberschwemmung",
    solar_existing: "Installierte Photovoltaik-Leistung",
    rockfalls: "Steinschl\xE4ge",
    solar_existing_per_m2: "Installierte Photovoltaik-Leistung pro m\xB2"
  },
  financials: {
    metrics: {
      c_revenue_per_share: "Einnahmen pro Aktie",
      title: "Finanzkennzahlen",
      c_operating_profit: "Betriebsergebnis",
      r_dividend_from_direct_rental_income: "Dividende aus direkten Mieteinnahmen",
      five_years_avg_dividend_yield: "5-Jahres-Durchschnittliche Dividendenrendite",
      c_earnings_per_share: "Gewinn pro Aktie",
      r_total_dividend: "Gesamtaussch\xFCttung",
      r_roi: "ROI (Rendite auf Investition)",
      r_dividend_yield: "Dividendenrendite",
      r_roic: "ROIC (Rendite auf das investierte Kapital)",
      r_debt_ratio: "Verschuldungsgrad",
      c_net_initial_yield: "Nettoanfangsrendite",
      c_ebit_margin: "EBIT-Marge",
      income_statement: {
        title: "Kennzahlen der Gewinn- und Verlustrechnung",
        chart_title: "Visualisierung der Gewinn- und Verlustrechnung"
      },
      quantitative_valuation_ratios: {
        title: "Quantitative Bewertungskennzahlen"
      },
      r_wault: "WAULT (Durchschnittlich gewichtete Restlaufzeit der Mietvertr\xE4ge)",
      ratios: {
        title: "Kennzahlen"
      },
      r_performance: "Performance",
      r_payout_ratio: "Aussch\xFCttungsquote",
      c_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
      c_current_ratio: "Liquidit\xE4tsgrad",
      c_agio_at_year_end: "Agio zum Jahresende",
      m_dividend_yield: "Dividendenrendite",
      c_pe_ratio: "KGV (P/E ratio)",
      r_rental_losses: "Mietausfallrate",
      r_dividend_from_capital_gains: "Dividende aus Kapitalgewinnen",
      c_total_cash_per_share: "Liquide Mittel je Aktie",
      c_debt_ratio: "Verschuldungsgrad",
      r_dividend_from_indirect_rental_income: "Dividende aus indirekten Mieteinnahmen",
      c_price_to_book_value: "Kurs-Buchwert-Verh\xE4ltnis (price-to-book ratio)",
      liquidity: {
        title: "Liquidit\xE4tskennzahlen"
      },
      c_roe: "ROE (Eigenkapitalrendite)",
      balance_sheet: {
        chart_title: "Bilanzvisualisierung"
      },
      c_roce: "ROCE (Rendite auf das gebundene Kapital)",
      c_loan_to_value: "Beleihungsauflauf",
      c_payout_ratio: "Aussch\xFCttungsquote",
      r_estimated_liquidation_taxes: "Gesch\xE4tzte Liquidationssteuern",
      r_roe: "ROE (Eigenkapitalrendite)",
      c_current_liabilities: "Kurzfristige Verbindlichkeiten",
      c_weighted_average_cost_of_debt: "Gewichteter durchschnittlicher Zinssatz",
      r_ebit_margin: "EBIT-Marge",
      dividends: {
        title: "Dividenden"
      },
      c_weighted_average_maturity: "Gewichtete durchschnittliche Laufzeit"
    },
    portfolio: {
      r_total_market_value: "Total",
      r_commercial_cost_price: "Gewerbeimmobilien",
      c_market_value_median: "Median",
      c_commercial_market_value: "Gewerbeimmobilien",
      r_cost_price_q1: "Q1",
      r_residential_market_value: "Wohnimmobilien",
      r_residential_cost_price: "Wohnimmobilien",
      r_commercial_market_value: "Gewerbeimmobilien",
      r_market_value_median: "Median",
      r_others_cost_price: "Sonstige",
      c_others_market_value: "Sonstige",
      c_total_market_value: "Total",
      r_cost_price: {
        title: "Ausgewiesene Einstandspreis der Geb\xE4ude"
      },
      r_market_value_q3: "Q3",
      c_mixed_market_value: "Gemischte Nutzung",
      title: "Portfoliowert",
      computed_market_value: {
        title: "Marktwert der Geb\xE4ude"
      },
      r_cost_price_by_m2: {
        title: "Ausgewiesene Einstandspreis pro m\xB2"
      },
      c_cost_price_by_m2: {
        title: "Einstandspreis pro m\xB2"
      },
      r_plots_cost_price: "Parzellen",
      r_mixed_market_value: "Gemischte Nutzung",
      c_residential_market_value: "Wohnimmobilien",
      r_cost_price_q3: "Q3",
      r_plots_market_value: "Parzellen",
      computed_market_value_by_m2: {
        title: "Marktwert pro m\xB2"
      },
      c_market_value: {
        title: "Gesch\xE4tzter Marktwert der Geb\xE4ude"
      },
      r_other_market_value: "Sonstige",
      r_total_cost_price: "Total",
      c_market_value_by_m2: {
        title: "Marktwert pro m\xB2"
      },
      c_cost_price: {
        title: "Einstandspreis der Geb\xE4ude"
      },
      c_market_value_q3: "Q3",
      r_market_value_by_m2: {
        title: "Ausgewiesene Marktwert pro m\xB2"
      },
      c_market_value_q1: "Q1",
      r_market_value_q1: "Q1",
      r_cost_price_median: "Median",
      r_market_value: {
        title: "Ausgewiesene Marktwert der Geb\xE4ude"
      },
      r_mixed_cost_price: "Gemischte Nutzung",
      r_other_cost_price: "Sonstige"
    },
    accounting: {
      balance_sheet: {
        table_title: "Bilanztabelle"
      },
      income_statement: {
        table_title: "Gewinn- und Verlustrechnungstabelle"
      }
    },
    tile: {
      trade: "Handelsstatistiken",
      return: "Rendite",
      stock_history: "Aktienkursverlauf",
      charges: "Mieternebenkosten",
      evolution: "Entwicklung",
      risk_statistics: "Risikostatistiken",
      key_performance: "Leistungskennzahlen",
      dividends: "Dividenden",
      rental_income: "Mietertr\xE4ge",
      key_financials_per_share: "Finanzielle Leistung (pro Aktie)",
      losses: "Verluste",
      key_financials: "Finanzielle Leistung (Gesamtbetrag)",
      fees: "Geb\xFChren",
      measures: "Bewertungsma\xDFnahmen"
    },
    performance: {
      year_end_total_value: {
        title: "Gesamtwert zum Jahresende"
      },
      c_current_agio_before_distribution: "Agio vor Dividendenzahlung",
      r_tna_after_distribution: "TNA nach Verteilung",
      c_current_agio_after_distribution: "Agio nach Aussch\xFCttung",
      c_tna_compounded: "Aufgezinstes TNA",
      r_tga_after_distribution: "TGA nach Verteilung",
      r_gav_before_distribution: "GAV vor Aussch\xFCttung",
      r_market_cap: "Marktkapitalisierung",
      current_total_value: {
        title: "Aktueller Gesamtwert"
      },
      m_share_price: "Aktienkurs",
      c_gav_compounded: "Aufgezinstes GAV",
      r_share_price: "Aktienkurs",
      r_tna_before_distribution: "TNA vor Aussch\xFCttung",
      m_market_cap: "Marktkapitalisierung",
      m_dividend_yield: "Dividendenrendite",
      r_nav_before_distribution: "NAV vor Aussch\xFCttung",
      c_total_current_agio_compounded: "Gesamtes aufgezinstes Agio",
      c_total_current_agio_after_distribution: "Gesamtes Agio nach Aussch\xFCttung",
      r_tga_before_distribution: "TGA vor Aussch\xFCtung",
      r_agio_at_year_end: "Agio",
      c_gav_after_distribution: "GAV nach Aussch\xFCttung",
      c_current_agio_compounded: "Aufgezinstes Agio",
      c_total_agio_at_year_end: "Agio",
      c_nav_after_distribution: "NAV nach Aussch\xFCttung",
      title: "Performance",
      c_nav_compounded: "Aufgezinstes NAV",
      current_value_per_share: {
        title: "Aktueller Wert pro Aktie"
      },
      c_tga_compounded: "Aufgezinstes TGA",
      year_end_value_per_share: {
        title: "Wert pro Aktie zum Jahresende"
      }
    },
    rental_income: {
      c_total_net_rent: "Total",
      c_commercial_net_rent: "Gewerbeimmobilien",
      computed_by_m2: {
        title: "Mietertr\xE4ge pro m\xB2"
      },
      estimated_by_m2: {
        title: "Mietertr\xE4ge pro m\xB2"
      },
      title: "Mietertr\xE4ge",
      reported_by_m2: {
        title: "Ausgewiesene Mietertr\xE4ge pro m\xB2"
      },
      c_net_rent_q1: "Q1",
      r_others_net_rent: "Sonstige",
      computed: {
        title: "Mietertr\xE4ge"
      },
      r_other_net_rent: "Sonstige",
      r_net_rent_q3: "Q3",
      r_plots_net_rent: "Parzellen",
      r_commercial_net_rent: "Gewerbeimmobilien",
      r_net_rent_median: "Median",
      r_total_net_rent: "Total",
      r_resiential_net_rent: "Wohnimmobilien",
      reported: {
        title: "Ausgewiesene Mietertr\xE4ge"
      },
      r_net_rent_q1: "Q1",
      c_net_rent_median: "Median",
      r_mixed_net_rent: "Gemischte Nutzung",
      c_mixed_net_rent: "Gemischte Nutzung",
      c_resiential_net_rent: "Wohnimmobilien",
      c_net_rent_q3: "Q3",
      estimated: {
        title: "Mietertr\xE4ge"
      }
    },
    stock: {
      three_months_avg_volume: "3-Monats-durchschnittliches Volumen",
      alpha: "Alpha (5J Monatlich)",
      one_year_avg_volume: "1-Jahres-urchschnittliches Volumen",
      evolution: {
        title: "Entwicklung"
      },
      hist_volatility_250_days: "1-Jahres-historische Volatilit\xE4t",
      volume: "Letzter Volumen",
      six_months_avg_volume: "6-Monats-durchschnittliches Volumen",
      five_years_return: "5 Jahre",
      fifty_two_weeks_low: "52-Wochen-Tief",
      qtd_net_return: "Quartal-to-Date (QTD)",
      trade: {
        title: "Handelsstatistiken"
      },
      hist_volatility_180_days: "6-Monats-historische Volatilit\xE4t",
      five_days_avg_volume: "5-Tages-durchschnittliches Volumen",
      unit_outstanding: "Ausstehende Aktien",
      title: "Aktienperformance",
      six_months_return: "6 Monate",
      hist_volatility_30_days: "1-Monats-historische Volatilit\xE4t",
      one_year_return: "1 Jahr",
      three_months_return: "3 Monate",
      fifty_two_weeks_high: "52-Wochen-Hoch",
      three_years_return: "3 Jahre",
      ytd_net_return: "Year-to-date (YTD)",
      mtd_net_return: "Month-to-date (MTD)",
      one_month_return: "1 Monat",
      history: {
        title: "Aktienkursverlauf"
      },
      sharpe_ratio: "Sharpe-Ratio",
      hist_volatility_90_days: "3-Monats-historische Volatilit\xE4t",
      one_month_avg_volume: "1-Monats-durchschnittliches Volumen",
      beta: "Beta (5J Monatlich)",
      risk: {
        title: "Risikostatistiken"
      },
      turnover: "Umsatz",
      r2: "R\xB2"
    },
    fees: {
      r_ter_nav: "TERrefNAV",
      r_property_management_fees: "Immobilienverwaltungsgeb\xFChren",
      r_ter_mv: "TERrefMV",
      r_ter_gav: "TERrefGAV",
      maximum: {
        title: "Maximale Geb\xFChren"
      },
      r_max_share_buyback_commissions: "R\xFCckkaufkommission",
      r_max_management_fees: "Verwaltungsgeb\xFChren",
      r_max_construction_and_works_fees: "Baukonstruktion und Bauarbeiten",
      r_max_purchase_and_sale_fees: "Kauf und Verkauf von Immobilien",
      r_custodian_bank_fees: "Depotbankgeb\xFChren",
      r_construction_and_works_fees: "Baukonstruktion und Bauarbeiten",
      effective: {
        title: "Effektive Geb\xFChren"
      },
      r_max_property_management_fees: "Immobilienverwaltungsgeb\xFChren",
      title: "Geb\xFChren",
      r_purchase_and_sale_fees: "Kauf und Verkauf von Immobilien",
      r_max_share_issue_commissions: "Ausgabekommission",
      r_share_issue_commissions: "Ausgabekommission",
      r_share_buyback_commissions: "R\xFCckkaufkommission",
      r_management_fees: "Verwaltungsgeb\xFChren",
      r_max_custodian_bank_fees: "Depotbankgeb\xFChren"
    },
    cost_price: {
      title: "Einstandspreis"
    },
    charges: {
      title: "Mieternebenkosten"
    },
    title: "Finanzen",
    side_menu: {
      hover_label: "Ver\xE4nderung"
    },
    trading: {
      title: "Handelsinformationen"
    },
    market_value: {
      title: "Marktwert"
    },
    income_statement: {
      title: "Gewinn- und Verlustrechnung"
    },
    highlights: {
      title: "Finanzielle Informationen"
    },
    stock_performance: {
      title: "Aktienperformance"
    },
    evolution: {
      chart: {
        title: "Diagramm"
      },
      title: "Entwicklung"
    },
    debts: {
      title: "Schuldstruktur"
    },
    report: {
      annual: "j\xE4hrlich",
      semi_annual: "halbj\xE4hrlich"
    },
    balance_sheet: {
      title: "Bilanz"
    },
    revenue: {
      title: "Einnahmen"
    },
    benchmark: "W\xE4hlen Sie einen Benchmark"
  },
  performance: {
    total_expense_ratio_ref_mv: "Gesamtkostenquote (Total Expense Ratio - TER_MV)",
    payout_ratio: "Aussch\xFCttungsquote",
    wault_suffix: "Jahre",
    hist_volatility_250_days: "1-Jahres-historische Volatilit\xE4t",
    rent_default_rate: "Mietausfallrate",
    hist_volatility_90_days: "3-Monats-historische Volatilit\xE4t",
    fifty_two_w_high: "52-Wochen-Hoch",
    total_net_assets: "Gesamte Nettoverm\xF6genswerte",
    return_on_asset: "ROA (Gesamtkapitalrentabilit\xE4t)",
    market_capitalization: "Marktkapitalisierung",
    yearly_management_fee: "Verwaltungsgeb\xFChr",
    dividend: "Letzte Dividende",
    three_m_return: "3 Monate",
    five_y_avg_dividend_yield: "5-Jahres-Durchschnittliche Dividendenrendite",
    dividend_yield: "Dividendenrendite",
    volume: "Durchschnittsvolumen",
    fifty_two_w_low: "52-Wochen-Tief",
    alpha: "Alpha (5J Monatlich)",
    one_m_return: "1 Monat",
    return_on_equity: "Eigenkapitalrendite (EKR)",
    turnover: "Umsatz",
    volume_suffix: "Einheiten",
    return_on_capital_employed: "ROCE (Rendite auf das gebundene Kapital)",
    relative_agio: "Agio",
    three_y_return: "3 Jahre",
    debt_financing_ratio: "Verschuldungsgrad",
    distribution_yield: "Aussch\xFCttungsrendite",
    return_on_investment: "Kapitalrendite (ROI)",
    return_on_invested_capital: "Rendite auf das eingesetzte Kapital (ROIC)",
    beta: "Beta (5J Monatlich)",
    mtd_net_return: "Month-to-date (MTD)",
    one_y_return: "1 Jahr",
    total_expense_ratio_ref_nav: "Gesamtkostenquote (TER_NAV)",
    total_gross_assets: "Gesamtbruttoverm\xF6gen",
    ebit_margin: "EBIT-Marge",
    ytd_net_return: "Year-to-date (YTD)",
    hist_volatility_30_days: "1-Monats-historische Volatilit\xE4t",
    hist_volatility_180_days: "6-Monats-historische Volatilit\xE4t",
    r2: "R\xB2",
    total_expense_ratio_ref_gav: "Gesamtkostenquote (TER_GAV)",
    qtd_net_return: "Quartal-to-Date (QTD)",
    wault_label: "Durchschnittlich gewichtete Restlaufzeit der Mietvertr\xE4ge (WAULT)"
  },
  noright: {
    title: "REIVs",
    subtitle: "Diese Funktion erfordert einen umfassenderen Abonnement-Plan.",
    button: "Kontaktieren Sie den Account-Manager",
    details: "Das Modul der Immobilieninvestitionsvehikel (REIVs) zeigt umfassende Informationen \xFCber eine Vielzahl von Schweizer Immobiliengesellschaften."
  },
  governance: {
    tile: {
      certification: "Zertifizierung",
      press_score: "PRESS \u2013 \xD6ffentliche Immobilien-Nachhaltigkeit-Score",
      valuation_expert: "Bewertungsexperten",
      property_management: "Immobilienverwaltung",
      ownership: "Eigentum",
      auditors: "Wirtschaftspr\xFCfer",
      minergie: "Minergie"
    },
    manager: "Fondsmanager",
    certificates_rating: {
      title: "Zertifikate und Bewertung"
    },
    social: "Soziales",
    governance: "Governance",
    custodian_bank: "Depotbank",
    esg: "ESG (Umwelt, Soziales und Unternehmensf\xFChrung)",
    press_score: "Governance-PRESS-Score:",
    director: "Fondsdirektor",
    ranking: "Ranking",
    title: "Governance",
    minergie_buildings: "Anteil der Minergie-Geb\xE4ude",
    organisation: {
      title: "Organisation"
    },
    environmental: "Umwelt"
  },
  administrative: {
    custodian_bank: "Depotbank",
    benchmark_bloomberg_ticker: "Benchmark-Ticker",
    benchmark: "Benchmark",
    manager: "Fondsmanager",
    name: "Aktienregister",
    director: "Fondsdirektor",
    domicile: "Fondsdomizil"
  },
  social: {
    transport_accessibility: {
      road_accessibility: {
        title: "\xDCber die Strasse",
        description: "Durchschnitt der Erreichbarkeitswerte \xFCber die Stra\xDFe gem\xE4\xDF der ARE, f\xFCr jedes Geb\xE4ude",
        key: "Erreichbarkeit \xFCber die Strasse"
      },
      transport_accessibility: {
        key: "Erreichbarkeit mit \xF6ffentlichem Verkehr",
        description: "Durchschnitt der Erreichbarkeitswerte mit \xF6ffentlichem Verkehr gem\xE4\xDF ARE f\xFCr jedes Geb\xE4ude",
        title: "Mit dem Zug"
      },
      title: "Erreichbarkeit"
    },
    accessibility: {
      aged_care: "Altenpflege",
      computed_public_transport_minute_mean: "\xD6ffentlicher Verkehr",
      computed_restaurants_meter_mean: "Restaurants",
      computed_pt_accessibility_mean: {
        title: "Durschnittlicher Erreichbarkeitswert"
      },
      computed_early_years_meter_mean: "Kinderbetreuung",
      mean_shops: "L\xE4den",
      transport_train: "Zug",
      computed_healthcare_minute_mean: "Gesundheitsversorgung",
      mean_primary_education: "Primarbildung",
      tree: {
        title: "Erreichbarkeit nach Transportart"
      },
      mean_restaurants: "Restaurants",
      computed_public_open_space_meter_mean: "\xD6ffentlicher Freiraum",
      computed_healthcare_meter_mean: "Gesundheitsversorgung",
      computed_cultural_venues_meter_mean: "Kulturelle Einrichtungen",
      computed_aged_care_minute_mean: "Altenpflege",
      early_years: "Kinderbetreuung",
      computed_transport_bus_minute_mean: "Bus",
      computed_secondary_education_meter_mean: "Sekundarbildung",
      computed_aged_care_meter_mean: "Altenpflege",
      computed_restaurants_minute_mean: "Restaurants",
      mean_score: "Punktzahl",
      cultural_venues: "Kulturelle Einrichtungen",
      mean_transport_train: "Zug",
      computed_transport_train_meter_mean: "Zug",
      computed_social_and_cultural_activities_minute_mean: "Soziale und kulturelle Aktivit\xE4ten",
      computed_cultural_venues_minute_mean: "Kulturelle Einrichtungen",
      mean_cultural_venues: "Kulturelle Einrichtungen",
      computed_transport_bus_meter_mean: "Bus",
      computed_sports_recreation_meter_mean: "Sport und Freizeit",
      computed_transport_train_minute_mean: "Zug",
      title: "Erreichbarkeit",
      computed_public_open_space_minute_mean: "\xD6ffentlicher Freiraum",
      computed_secondary_education_minute_mean: "Sekundarbildung",
      healthcare: "Gesundheitsversorgung",
      mean_secondary_education: "Sekundarbildung",
      computed_primary_education_meter_mean: "Primarbildung",
      computed_sports_recreation_minute_mean: "Sport und Freizeit",
      shops: "L\xE4den",
      computed_transport_bike_meter_mean: "Veloparkierung",
      computed_primary_education_minute_mean: "Primarbildung",
      transport_bus: "Bus",
      computed_transport_bike_minute_mean: "Veloparkierung",
      mean_aged_care: "Altenpflege",
      computed_shops_meter_mean: "L\xE4den",
      computed_road_accessibility_mean: {
        title: "Durschnittlicher Erreichbarkeitswert"
      },
      table: {
        title: "Durschschnittliche Gehzeit zu den Annehmlichkeiten"
      },
      primary_education: "Primarbildung",
      secondary_education: "Sekundarbildung",
      computed_shops_minute_mean: "L\xE4den",
      mean_early_years: "Kinderbetreuung",
      restaurants: "Restaurants",
      computed_early_years_minute_mean: "Kinderbetreuung",
      computed_aged_and_early_years_care_minute_mean: "Alters- und fr\xFChkindliche Betreuung",
      score: "Punktzahl",
      radar: {
        title: "Erreichbarkeit der Annehmlichkeiten"
      },
      mean_healthcare: "Gesundheitsversorgung",
      mean_transport_bus: "Bus"
    },
    well_being: {
      public_utility_density: {
        key: "Anteil \xF6ffentlicher Geb\xE4ude",
        description: "Dies misst den Anteil der \xF6ffentlichen Geb\xE4ude (Krankenh\xE4user, Altenpflegeeinrichtungen, Schulen usw.) im Portfolio des Fahrzeugs.",
        title: "\xD6ffentliche Geb\xE4ude"
      },
      green_density: {
        title: "Begr\xFCnung",
        key: "Gr\xFCne Dichte",
        description: "Die gr\xFCne Dichte gibt den durchschnittlichen Anteil der umliegenden Hektarfl\xE4chen an, die \xFCberwiegend Gr\xFCnfl\xE4chen enthalten, f\xFCr jedes Geb\xE4ude gem\xE4\xDF der Bodennutzung (NOAS04)"
      },
      computed_public_utility_density: {
        title: "Dichte der \xF6ffentlichen Geb\xE4ude"
      },
      title: "Wohlbefinden",
      computed_green_density: {
        title: "Gr\xFCne Dichte"
      }
    },
    density: {
      title: "Dichte",
      computed_job_density: {
        title: "Arbeitsplatzdichte"
      },
      computed_population_density: {
        title: "Bev\xF6lkerungsdichte"
      },
      population_density: {
        title: "Bev\xF6lkerungsdichte",
        key: "Bev\xF6lkerungsdichte",
        description: "Die Bev\xF6lkerungsdichte misst die durchschnittliche Bev\xF6lkerungsdichte in den umliegenden Hektar pro Geb\xE4ude, gem\xE4\xDF STATPOP."
      },
      job_density: {
        description: "Die Arbeitsplatzdichte misst die durchschnittliche Arbeitsplatzdichte in den umliegenden Hektar pro Geb\xE4ude, gem\xE4\xDF STATENT.",
        title: "Arbeitsplatzdichte",
        key: "Arbeitsplatzdichte"
      }
    },
    promiscuity: {
      tile: {
        occupancy: "Belegungsrate",
        migration: "Migration"
      },
      arrival_per_inhabitant: "Ankunft pro Einwohner",
      title: "Bev\xF6lkerungsdichte",
      departure_per_inhabitant: "Abgang pro Einwohner",
      per_bedroom: "Pro Schlafzimmer",
      per_100_m2: "Pro 100 m\xB2"
    },
    demographic: {
      tile: {
        ages: "Alter",
        gender: "Geschlecht",
        foreigners: "Ausl\xE4nder"
      },
      title: "Demografisch"
    },
    tile: {
      accessibility_to_services: "Zugang zu Dienstleistungen",
      accessibility_others: "Andere (durchschnittliche Entfernung)",
      accessibility_transportation: "\xD6ffentlicher Verkehr (durchschnittliche Entfernung)",
      accessibility_education: "Gesundheit und Bildung (durchschnittliche Entfernung)",
      accessibility_score: "Erreichbarkeit"
    },
    press_score: "Sozial-PRESS-Score:",
    title: "Soziales"
  },
  designation: {
    instrument_name: "Name des Instruments",
    currency: "W\xE4hrung",
    ticker: "Allgemeiner Name",
    isin: "ISIN",
    bloomberg_ticker: "Bloomberg-Ticker",
    valor_no: "Valorennummer"
  },
  financials_per_share: {
    last_distribution: "Letzte Aussch\xFCttung",
    share_class_nb: "Ausstehende Aktien",
    share_class_gav: "Bruttoverm\xF6genswert (GAV)",
    share_market_price: "Aktienkurs",
    share_class_nav: "Nettoinventarwert (NAV)",
    distribution_value: "Verteilungswert"
  },
  composition: {
    lot_area: "Grundst\xFCcksfl\xE4che",
    lots_nb: "Anzahl Grundst\xFCcke",
    fund_age: "Alter des Immobilienportfolios",
    other_area: "Gesamtfl\xE4che anderer Bereiche",
    report_date: "Letzter Bericht",
    buildings_nb: "Anzahl Geb\xE4ude",
    office_area: "Gesamte B\xFCrofl\xE4che",
    semi_annual_report_date: "Letzter Bericht (halbj\xE4hrlich)",
    mixed_area: "Gesamtfl\xE4che gemischter Nutzung\n",
    building_groups_nb: "Anzahl Geb\xE4udegruppen",
    residential_area: "Gesamte Wohnfl\xE4che",
    plot_area: "Gesamte Grundst\xFCcksfl\xE4che",
    commercial_area: "Gesamte Gewerbefl\xE4che",
    dwellings_nb: "Anzahl Wohnungen",
    report_age: "Alter des aktuellen Immobilienberichts",
    industrial_area: "Gesamte Industriefl\xE4che",
    total_area: "Gesamtfl\xE4che",
    annual_report_date: "Letzter Bericht (j\xE4hrlich)"
  },
  trading: {
    title: "Handel"
  },
  overview: {
    agio: "Agio",
    total_co2: "CO\u2082",
    total_net_assets: "TNA",
    debt_ratio: "Verschuldungsgrad",
    esg_rating: "PRESS-Bewertung",
    net_initial_yield: "Nettoanfangsrendite",
    roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
    market_cap: "Marktkapitalisierung",
    net_rent: "Mietertr\xE4ge",
    ter_gav: "TERrefGAV"
  },
  description: {
    ranking: "Ranking der Fonds:",
    tile: {
      buildings: "Geb\xE4ude",
      allocation_treemap: "Geb\xE4udekategorien Treemap",
      geo_treemap: "Geografische Treemap",
      stock: "Aktie",
      composition: "Zusammensetzung",
      administrative: "Verwaltung",
      designation: "Bezeichnung",
      distribution: "Distribution",
      areas: "Fl\xE4chen"
    },
    distribution: {
      value_string: "Fl\xE4che",
      label: {
        reported_type: "Typ",
        typology: "Typologie",
        region: "Kanton",
        type: "Kategorie",
        class: "Klasse"
      },
      label_string: "Kanton"
    },
    allocation: {
      title: "Allokation"
    },
    identification: {
      title: "Identifikation"
    },
    overview: {
      title: "\xDCberblick",
      map: "Karte"
    },
    title: "Beschreibung",
    composition: {
      title: "Zusammensetzung"
    }
  },
  stock: {
    distribution_frequency: "Aussch\xFCttungsh\xE4ufigkeit",
    launch_date: "Startdatum",
    units_nb: "Ausstehende Aktien",
    last_distribution: "Letzte Aussch\xFCttung",
    year_end: "Bilanzstichtag",
    units_class: "Klasse von Einheiten",
    distribution_date: "Aussch\xFCttungsdatum"
  },
  accounting: {
    title: "Buchhaltung"
  },
  environment: {
    energy_distribution: {
      value_string: "Heizfl\xE4che",
      label_string: "Heizsystem"
    }
  },
  transactions: {
    value: {
      sale: "verkauft",
      purchase: "gekauft"
    },
    title: "Transaktionen"
  },
  debt: {
    title: "Schulden"
  },
  report: {
    semi_annual: "Halbjahresbericht",
    annual: "Jahresbericht"
  },
  page: {
    title: "Alle Schweizer Fonds"
  },
  assets: {
    title: "Bestand"
  }
};
var screener = {
  tabs: {
    esg: "ESG (Umwelt, Soziales und Unternehmensf\xFChrung)",
    accounting: "Buchhaltung",
    information: "Informationen",
    governance: "Governance",
    trading: "Handel",
    structure: "Struktur",
    fees: "Geb\xFChren",
    financial: "Finanziell",
    stock: "Aktienperformance",
    type: "Typ",
    saved_screens: "Gespeicherte Screener",
    energy: "Energie",
    performance: "Performance",
    social: "Soziales",
    dimension: "Dimension",
    legal_forms: "Rechtsformen",
    transaction: "Transaktion",
    location: "Standort"
  },
  filters: {
    multi_select: {
      options: {
        unlisted_fund: "Nicht kotierte Fonds",
        mixed: "Gemischte Nutzung",
        commercial: "Gewerbeimmobilien",
        foundation: "Stiftung",
        real_estate_firm: "Immobilienfirma",
        listed_fund: "Kotierte Fonds",
        residential: "Wohnimmobilien"
      }
    },
    labels: {
      floors_nb: "Stockwerksanzahl",
      idc: "Energieintensit\xE4t",
      rooms_nb: "Zimmeranzahl",
      street: "Stra\xDFe",
      roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
      price: "Preis",
      columns_to_ignore: "Spalten",
      region: "Region",
      canton: "Kanton",
      potential_net_rent_per_m2: "Potenzielle Nettomiete pro m\xB2",
      net_rent: "Mietertr\xE4ge",
      dwellings_nb: "Anzahl Wohnungen",
      plot_surface: "Grundst\xFCcksfl\xE4che",
      floor: "Stockwerk",
      rent: "Mietertr\xE4ge",
      construction_year: "Baujahr",
      potential_net_rent: "Potenzielle Nettomiete",
      ground_area: "Grundfl\xE4che",
      undefined: "-",
      sort: "Sortieren",
      buildings_nb: "Anzahl Geb\xE4ude",
      potential_charges: "Potenzielle Geb\xFChren",
      label: "Bezeichnung",
      municipality: "Gemeinde",
      co2: "CO\u2082",
      potential_market_value: "Potenzieller Marktwert",
      potential_market_value_per_m2: "Potenzieller Marktwert pro m\xB2",
      locality: "Ortschaft",
      area: "Grundst\xFCcksfl\xE4che",
      potential_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
      charges: "Mieternebenkosten",
      elevator: "Aufzug",
      potential_charges_per_m2: "Potenzielle Kosten pro m\xB2",
      energy_source_heating: "Heizsystem"
    },
    panel: {
      show: "Anzeigen"
    },
    groups: {
      information: "Informationen"
    },
    single_select: {
      options: {
        radar: "Netzdiagramm",
        area: "Fl\xE4chendiagramm",
        scatter: "Streudiagramm",
        boxplot: "Box-Plot",
        heatmap: "Heatmap",
        bar: "S\xE4ulendiagramm",
        line: "Liniendiagramm",
        histogram: "Histogramm",
        "1m": "1M",
        "5y": "5J",
        ytd: "YTD",
        "7d": "7T",
        "2y": "2J",
        "3m": "3M",
        "6m": "6M",
        "1y": "1J",
        "3y": "3J",
        "4y": "4J",
        false: "Falsch",
        max: "Max",
        true: "Faux"
      }
    }
  }
};
var actions = {
  request_download: {
    message: "Anfrage erstellt",
    csv: "CSV herunterladen"
  },
  screener: {
    filter: {
      remove: "Filter entfernen",
      edit: "Filter bearbeiten",
      save: "Filter speichern",
      search: "Filter"
    },
    filter_header: {
      header: "Spalten",
      label: "Sichtbarkeit der Spalten festlegen"
    },
    preset: {
      save: "Bildschirm speichern",
      delete: "Screener l\xF6schen",
      copy: "Screener kopieren",
      reset: "Bildschirm zur\xFCcksetzen"
    },
    per_page: {
      header: "Anzahl Zeilen",
      label: "Zeilen pro Seite"
    }
  },
  add_to_portfolios: {
    modal: {
      portfolio_name: "Portfolioname",
      new: "Neu",
      name: "Name",
      add_to_existing: "Zum bestehenden Portfolio hinzuf\xFCgen",
      create_button: "Erstellen"
    },
    confrm_modal: {
      title: "Wohnungen schon enthalten",
      buttons: {
        confirm: "Fortfahren",
        cancel: "Zur\xFCck"
      }
    },
    confirm_modal: {
      text_2: "M\xF6chten Sie sie durch dieses Geb\xE4ude ersetzen?",
      text_1: "Das Portfolio enth\xE4lt bereits Wohnungen von {{building_label}}."
    },
    success_add_portfolio: {
      message: "Hinzuf\xFCgen von {{asset}} zu Ihrem {{portfolio_state}} Portfolio",
      title: "Erfolgreich"
    },
    adding_portfolio: {
      title: "Hinzuf\xFCgen",
      message: "Hinzuf\xFCgen von {{asset}}(s) zu Ihrem Portfolio"
    },
    success_create_portfolio: {
      message: "Ein neues Portfolio wurde erstellt",
      title: "Erfolgreich"
    },
    title: "Zum Portfolio hinzuf\xFCgen"
  },
  portfolios: {
    remove: {
      success: {
        message: "{{ asset }}(s) aus Ihrem Portfolio entfernt"
      }
    }
  },
  update: {
    processing: {
      done: "Die Operation wurde erfolgreich abgeschlossen. Die Seite wird bald aktualisiert.",
      message: "Die Operation wird bald durchgef\xFChrt.",
      title: "Aktualisierung"
    }
  },
  watchlist: {
    remove: {
      button: {
        label: "Entfolgen"
      },
      success: {
        message: "Verm\xF6genswert von Ihrer Beobachtungsliste entfernt"
      }
    },
    add: {
      button: {
        label: "Folgen"
      },
      success: {
        message: "Verm\xF6genswert zu Ihrer Beobachtungsliste hinzugef\xFCgt"
      }
    }
  },
  companies: {
    delete: "L\xF6schen",
    create: "Unternehmen gr\xFCnden"
  },
  add_to_watchlist: {
    title: "Zur Beobachtungsliste hinzuf\xFCgen"
  }
};
var table_header = {
  r_total_cash: "Fl\xFCssige Mittel insgesamt",
  total_net_assets: "Gesamte Nettoverm\xF6genswerte",
  reported_total_area: "Mietfl\xE4che",
  r_ebit_margin: "EBIT-Marge",
  area: "Fl\xE4che",
  c_total_current_agio_compounded: "Gesamtes aktuelles  aufgezinstes Agio",
  m_dividend_yield: "Aktuelle Dividendenrendite",
  buyer_name: "K\xE4ufer",
  email: "E-Mail",
  energy_source_heating: "Heizsystem",
  r_gav_before_distribution: "GAV vor Aussch\xFCttung",
  cost_price: "Einstandspreis",
  r_nav_before_distribution: "NAV vor Aussch\xFCttung",
  id: "ID",
  total_consumer_seat: "Anzahl der Lizenzen Benutzer-Verbraucher",
  three_years_return: "3-Jahres-Nettorendite",
  r_net_income_available_for_distribution: "Aussch\xFCttungsf\xE4higer Nettogewinn",
  r_tna_before_distribution: "TNA vor Aussch\xFCttung",
  r_capital_distribution: "Kapitalaussch\xFCttung",
  r_total_provisions: "Gesamte R\xFCckstellungen",
  m_share_price: "Aktienkurs",
  potential_market_value_per_m2: "Marktwert pro m\xB2",
  municipality_nb: "Gemeindenummer",
  floor: "Stockwerk",
  consumer_users: "Benutzer-Verbraucher",
  r_absolute_custodian_bank_fees: "Depotbankgeb\xFChren",
  r_long_term_liabilities: "Langfristige Verbindlichkeiten",
  c_pe_ratio: "KGV (P/E ratio)",
  r_taxes: "Steuern",
  commercial_area: "Gewerbefl\xE4che",
  contact_user_email: "E-Mail-Adresse der Ansprechperson",
  c_median_maturity: "Medianlaufzeit",
  r_commercial_rental_space: "Gewerbefl\xE4che",
  r_absolute_directors_fees: "Verwaltungsrathonorar (Betrag)",
  r_realised_capital_gains_and_losses: "Realisierte Kapitalgewinne und -verluste",
  start: "Anfang",
  r_ebit: "EBIT (Ergebnis vor Zinsen und Steuern)",
  region: "Region",
  m_unit_outstanding: "Ausstehende Anteile",
  r_net_assets_at_end_of_the_financial_year: "Nettoverm\xF6genswerte am Ende des Gesch\xE4ftsjahres",
  hist_volatility_30_days: "1-Monats-historische Volatilit\xE4t",
  estimated_idc_per_m2: "Energieintensit\xE4t pro m\xB2",
  share_class_nav: "Nettoinventarwert",
  building_groups_nb: "Anzahl Geb\xE4udegruppen",
  one_year_avg_volume: "1-Jahres-Durchschnittliches Volumen",
  ewid: "Ewid",
  m_dividend: "Dividende",
  canton: "Kanton",
  r_unrealised_capital_gains_and_losses: "Unrealisierte Kapitalgewinne und -verluste",
  share_class_nb: "Anzahl Aktien",
  used_all_seats: "Anzahl der zugewiesene Lizenzen",
  commercial_spaces_area: "Gewerbefl\xE4che",
  fund_names: "Eigent\xFCmer",
  r_agio_at_year_end: "Agio zum Jahresende",
  r_share_buyback_commissions: "R\xFCckkaufkommission",
  r_construction_and_works_fees: "Baukonstruktion- und Bauarbeitsgeb\xFChren",
  r_other_assets: "Sonstige Verm\xF6genswerte",
  actual_rental_status_target: "Soll-Mietertr\xE4ge",
  r_nopat: "NOPAT (Betriebsergebnis nach Steuern)",
  contact_user: "Ansprechperson",
  already_reimbursed: "Bereits zur\xFCckgezahlt",
  c_nav_compounded: "Aufgezinstes NAV",
  r_absolute_management_fees: "Verwaltungsgeb\xFChren",
  sector_nb: "Sektorennummer",
  r_variation_estimated_liquidation_taxes: "Ver\xE4nderung der gesch\xE4tzten Liquidationssteuern",
  related_am: "Verbundener Account-Manager",
  r_tga_before_distribution: "TGA vor Aussch\xFCtung",
  investor_users: "Benutzer-Investor",
  ground_area: "Grundfl\xE4che",
  potential_gross_rent_per_m2: "Bruttomiete pro m\xB2",
  ter_nav: "TERrefNAV",
  value_net_asset: "Nettoinventarwert",
  r_invested_capital: "Investiertes Kapital",
  real_rent: "Reale Mietertr\xE4ge",
  c_current_agio_after_distribution: "Gesamtes aktuelles Agio nach Aussch\xFCttung",
  total_gross_assets: "Gesamtbruttoverm\xF6gen",
  total_institutional_seat: "Anzahl der Lizenzen Benutzer-Institutionell",
  actual_market_value: "Marktwert",
  c_debt_ratio: "Verschuldungsgrad",
  r_total_liabilities: "Gesamtverbindlichkeiten",
  r_ter_nav: "TERrefNAV",
  r_provisions_for_future_works: "R\xFCckstellungen f\xFCr zuk\xFCnftige Arbeiten",
  r_other_revenue: "Sonstige Einnahmen",
  r_tna_after_distribution: "TNA nach Verteilung",
  target_rent: "Sollmiete",
  r_property_management_expenses: "Immobilienverwaltungskosten",
  locality: "Ortschaft",
  co2: "CO\u2082",
  hist_volatility_180_days: "6-Monats-historische Volatilit\xE4t",
  r_maintenance_costs: "Instandhaltungskosten",
  seller_name: "Verk\xE4ufer",
  energy_intensity: "Energieintensit\xE4t",
  r_total_dividend: "Gesamtaussch\xFCttung",
  potential_net_rent: "Mietertr\xE4ge",
  c_total_cash_per_share: "Liquide Mittel je Aktie",
  date: "Jahr",
  potential_charges_monthly: "Monatliche Mieternebenkosten",
  total_investor_seat: "Anzahl der Lizenzen Benutzer-Investor",
  real_net_rent: "Mietertr\xE4ge",
  c_current_liabilities: "Kurzfristige Verbindlichkeiten",
  r_short_term_liabilities: "Kurzfristige Verbindlichkeiten",
  real_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  c_tga_compounded: "Aufgezinstes TGA",
  c_total_current_agio_after_distribution: "Gesamtes aktuelles Agio nach Verteilung",
  qtd_net_return: "Nettorendite bis heute (QTD)",
  c_net_initial_yield: "Nettoanfangsrendite",
  c_current_agio_compounded: "Aktuelles aufgezinstes Agio",
  r_total_revenue: "Gesamtertrag",
  r_other_rental_space: "Andere Mietfl\xE4che",
  implied_volatility: "Implizite Volatilit\xE4t",
  c_gav_after_distribution: "GAV nach Aussch\xFCttung",
  phone: "Telefon",
  potential_total_income: "Nettomiete",
  r_administration_of_buildings: "Geb\xE4udeverwaltung",
  duplex: "Duplex",
  r_dividend_from_direct_rental_income: "Dividende aus direkten Mieteinnahmen",
  last_report_date: "Datum des letzten Berichts",
  mtd_net_return: "Month-to-date-Nettorendite",
  social: "S Score",
  real_charges_monthly: "Monatliche Mieternebenkosten",
  yearly_management_fee: "Verwaltungsgeb\xFChr",
  end: "Ende",
  nb: "Parzellennummer",
  r_mortgage_interest: "Hypothekenzinsen",
  share_class_gav: "Bruttoverm\xF6genswert",
  street_short: "Adresse",
  ticker: "Ticker",
  potential_market_value: "Marktwert",
  one_year_total_return: "1-Jahres-Gesamtrendite",
  r_tna: "TNA",
  label: "Bezeichnung",
  r_absolute_legal_fees: "Anwaltskosten (Betrag)",
  r_net_income: "Nettogewinn",
  roic: "ROIC (Rendite auf das investierte Kapital)",
  rental_losses: "Mietausfallrate",
  municipality_name: "Gemeinde",
  r_administration_expenses: "Verwaltungskosten",
  agio: "Agio",
  license_use: "Zuweisung von Lizenzen",
  has_building: "Hat Geb\xE4ude",
  r_dividend_from_capital_gains: "Dividende aus Kapitalgewinnen",
  r_absolute_property_management_fees: "Immobilienverwaltungsgeb\xFChren (Betrag)",
  r_auditing_expenses: "Auditgeb\xFChren",
  companies: "Unternehmen",
  last_active: "Letzte Aktivit\xE4t",
  energy_source_water: "Wasserheizungsquelle",
  construction_date: "Baujahr",
  r_commercial_spaces_area: "Gewerbefl\xE4che",
  used_consumer_seat: "Zugewiesene Lizenzen Benutzer-Verbraucher",
  r_max_share_buyback_commissions: "Maximale R\xFCckkaufkommission",
  r_market_value: "Marktwert",
  minergie_label: "Bezeichnung",
  rent_default_rate: "Mietausfall",
  rate: "Rate",
  three_months_avg_volume: "3-Monats-durchschnittliches Volumen",
  r_profit_and_capital_taxes: "Gewinnsteuern und Kapitalsteuern",
  actual_rental_status_real: "Mietertr\xE4ge",
  r_roi: "ROI (Rendite auf Investition)",
  r_dividend_from_indirect_rental_income: "Dividende aus indirekten Mieteinnahmen",
  ytd_net_return: "Year-to-date-Nettorendite",
  r_ter_mv: "TERrefMV",
  r2: "R\xB2",
  dwellings_nb: "Anzahl Wohnungen",
  r_cost_price: "Einstandspreis",
  r_performance: "Performance",
  fifty_two_weeks_high: "52-Wochen-hoch",
  actual_target_roa: "Ziel-ROA",
  currency: "W\xE4hrung",
  r_max_custodian_bank_fees: "Maximale Depotbankgeb\xFChren",
  r_long_term_interest_bearing_mortgages: "Langfristige verzinsliche Hypotheken",
  labels: "Minergie-Labels",
  beta: "Beta",
  payout_ratio: "Aussch\xFCttungsquote",
  developer_mode: "Entwicklermodus",
  fifty_two_weeks_low: "52-Wochen-tief",
  high: "Hoch",
  social_rating: "S Bewertung",
  c_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  c_weighted_average_cost_of_debt: "Gewichtete durchschnittliche Fremdkapitalkostensatz",
  r_debt_ratio: "Verschuldungsgrad",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "Nicht realisierte Gewinne/Verluste einschliesslich Ver\xE4nderung der Liquidationssteuern",
  contact_user_phone: "Telefonnummer der Ansprechperson",
  zip: "Postleitzahl",
  dividend_date: "Dividendenstichtag",
  r_residential_area: "Wohnfl\xE4che",
  r_purchase_and_sale_fees: "Kauf- und Verkaufsgeb\xFChren",
  roe: "ROE (Eigenkapitalrendite)",
  low: "Tief",
  r_total_income: "Gesamte Mietertr\xE4ge",
  rights: "Rechte",
  r_roe: "ROE (Eigenkapitalrendite)",
  c_ebit_margin: "EBIT-Marge",
  r_absolute_custodian_bank_commission_fees: "Depotbankprovisionsgeb\xFChren (Betrag)",
  r_other_administration_expenses: "Sonstige Verwaltungskosten",
  r_share_issue_commissions: "Ausgabekommission",
  hist_volatility_250_days: "1-Jahres-historische Volatilit\xE4t",
  six_months_return: "6-Monats-Nettorendite",
  r_wault: "WAULT (Durchschnittlich gewichtete Restlaufzeit der Mietvertr\xE4ge)",
  r_total_net_assets: "Gesamte Nettoverm\xF6genswerte",
  r_maintenance_and_repairs_expenses: "Instandhaltung- und Reparaturkosten",
  r_other_short_term_liabilities: "Andere kurzfristige Verbindlichkeiten",
  lots_nb: "Anzahl Grundst\xFCcke",
  r_custodian_bank_fees: "Depotbankgeb\xFChren",
  r_gross_yield: "ROA (Gesamtkapitalrentabilit\xE4t)",
  r_net_assets_at_beginning_of_the_financial_year: "Nettoverm\xF6genswerte zu Beginn des Gesch\xE4ftsjahres",
  c_earnings_per_share: "Gewinn pro Aktie",
  c_median_cost_of_debt: "Medianer Fremdkapitalkostensatz",
  esg: "ESG Score",
  last_activity_date: "Letzte Aktivit\xE4t",
  potential_charges_per_m2: "Kosten pro m\xB2",
  five_days_avg_volume: "5 Tage Durchschnittsvolumen",
  volume: "Volumen",
  five_years_avg_dividend_yield: "5-Jahres-Durchschnittliche Dividendenrendite",
  r_units_outstanding: "Ausstehende Anteile",
  r_negative_interest: "Negative Zinsen",
  environmental_rating: "E Bewertung",
  c_gav_compounded: "Aufgezinstes GAV",
  one_month_return: "1-Monats-Nettorendite",
  total_area: "Gesamtfl\xE4che",
  r_total_interest: "Gesamtzinsergebnis",
  dividend_yield: "Dividendenrendite",
  institutional_users: "Benutzer-Institutionell",
  r_total_area: "Gesamtfl\xE4che",
  egid: "EGID",
  c_price_to_book_value: "Kurs-Buchwert-Verh\xE4ltnis (price-to-book ratio)",
  r_net_assets_before_estimated_liquidation_taxes: "Nettoverm\xF6genswerte vor den gesch\xE4tzten Liquidationssteuern",
  r_retained_earnings: "Gewinnr\xFCcklagen",
  three_months_return: "3-Monats-Nettorendite",
  value_gross_asset: "Bruttoverm\xF6genswert",
  m_share_price_var: "Aktienkursver\xE4nderungen",
  last_renovation_year: "Jahr der letzten Sanierung",
  subscribed_date: "Abonniert seit",
  r_rental_losses: "Mietausfallrate",
  m_market_cap: "Marktkapitalisierung",
  r_total_properties: "Gesamtliegenschaften",
  free_investor_seat: "Verbleibende Lizenzen Benutzer-Investor",
  r_dividend_yield: "Dividendenrendite am Jahresende",
  r_property_management_fees: "Immobilienverwaltungsgeb\xFChren",
  short_name: "Kurzbezeichnung",
  market_value: "Marktwert",
  bloomberg_ticker: "Ticker",
  rent_defaults: "Mietausf\xE4lle",
  r_short_term_interest_bearing_mortgages: "Kurzfristige verzinsliche Hypotheken",
  free_institutional_seat: "Verbleibende Lizenzen Benutzer-Institutionell",
  estimated_co2_emission_per_m2: "CO\u2082 pro m\xB2",
  r_capital_employed: "Eingesetztes Kapital",
  alpha: "Alpha",
  actual_real_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  debt_ratio: "Verschuldungsgrad",
  enterprise: "Unternehmen",
  net_initial_yield: "Nettoanfangsrendite",
  launch_date: "Startdatum",
  fund_legal_forms: "Eigent\xFCmertyp",
  c_weighted_average_maturity: "Gewichtete durchschnittliche Laufzeit",
  esg_rating: "ESG Bewertung",
  counterpart_fund: "Gegenpartei",
  r_roce: "ROCE (Rendite auf das gebundene Kapital)",
  residential_area: "Wohnfl\xE4che",
  five_years_total_return: "Gesamtrendite 5 Jahre",
  potential_net_rent_per_m2: "Mietertr\xE4ge pro m\xB2",
  environmental: "E Score",
  dividend: "Dividende",
  days_left: "Verbleibende Tage",
  rental_space: "Fl\xE4che",
  r_revenue_from_postal_and_bank_accounts: "Einnahmen aus Postkonten und Bankkonten",
  r_tga: "TGA",
  roi: "ROI (Rendite auf Investition)",
  one_month_avg_volume: "1-Monats-durchschnittliches Volumen",
  roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  r_market_maker_fees: "Marktmachergeb\xFChren",
  r_realised_income: "Realisierte Ertr\xE4ge",
  r_ordinary_maintenance_and_repairs_expenses: "Ordentliche Wartungs- und Reparaturkosten",
  r_roic: "ROIC (Rendite auf das investierte Kapital)",
  r_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  rooms_nb: "Anzahl Zimmer",
  hist_volatility_90_days: "3-Monats-historische Volatilit\xE4t",
  six_months_avg_volume: "6-Monats-durchschnittliches Volumen",
  c_revenue_per_share: "Einnahmen pro Aktie",
  c_payout_ratio: "Aussch\xFCttungsquote",
  address: "Adresse",
  subscription_start: "Abonnementdatum",
  c_roce: "ROCE (Rendite auf das gebundene Kapital)",
  r_absolute_custodian_bank_distribution_fees: "Depotbankvertriebgeb\xFChren (Betrag)",
  turnover: "Umsatz",
  net_rent: "Nettomiete",
  value: "Wert",
  potential_charges: "Mieternebenkosten",
  r_tga_after_distribution: "TGA nach Verteilung",
  all_users: "Teammitglieder",
  r_payout_ratio: "Aussch\xFCttungsquote",
  role: "Rolle",
  ter_gav: "TERrefGAV",
  solar_existing: "Installierte Photovoltaik-Leistung",
  r_max_management_fees: "Maximale Verwaltungsgeb\xFChren",
  potential_gross_rent: "Bruttomiete",
  rate_type: "Ratenart",
  r_building_expenses: "Bewirtschaftungskosten",
  expires_at: "Ablaufdatum",
  r_residential_rental_space: "Wohnfl\xE4che",
  c_total_agio_at_year_end: "Gesamtes Agio zum Jahresende",
  r_property_tax: "Liegenschaftssteuer",
  r_valuation_and_auditing_expenses: "Bewertungs- und Auditgeb\xFChren",
  r_estimated_liquidation_taxes: "Gesch\xE4tzte Liquidationssteuern",
  isin: "ISIN",
  r_max_share_issue_commissions: "Maximale Ausgabekommission",
  real_market_value: "Marktwert",
  c_agio_at_year_end: "Agio zum Jahresende",
  state: "Einladungsprozess",
  vwap: "VWAP (volumengewichteter Durchschnittspreis)",
  governance: "G Score",
  c_operating_profit: "Betriebsergebnis",
  r_mixed_rental_space: "Mietfl\xE4che gemischter Nutzung",
  r_market_cap: "Marktkapitalisierung zum Jahresende",
  r_max_property_management_fees: "Maximale Immobilienverwaltungsgeb\xFChren",
  r_real_rent: "Mietertr\xE4ge",
  building_category: "Geb\xE4udeklasse",
  c_three_years_total_return: "3-Jahres-Gesamtrendite",
  real_charges: "Mieternebenkosten",
  fund_name: "Fondsname",
  r_ter_gav: "TERrefGAV",
  c_nav_after_distribution: "NAV nach Aussch\xFCttung",
  environment: {
    score: "Umwelt-Score"
  },
  r_other_expenses: "Sonstige Ausgaben",
  c_loan_to_value: "Beleihungsauflauf",
  r_share_price: "Aktienkurs",
  free_consumer_seat: "Verbleibende Lizenzen Benutzer-Verbraucher",
  r_other_long_term_liabilities: "Andere langfristige Verbindlichkeiten",
  total_co2: "CO\u2082-Emissionen",
  buildings_nb: "Anzahl Geb\xE4ude",
  r_extraordinary_maintenance_and_repairs_expenses: "Au\xDFerordentliche Instandhaltungs- und Reparaturkosten",
  r_max_construction_and_works_fees: "Maximale Baukonstruktion- und Bauarbeitsgeb\xFChren",
  type: "Typ",
  user: "Benutzer",
  total_all_seats: "Gesamtanzahl der Lizenzen",
  r_target_rent: "Soll-Mietertr\xE4ge",
  r_rental_income: "Mietertr\xE4ge",
  egrid: "EGRID",
  r_rental_space: "Mietfl\xE4che",
  used_institutional_seat: "Zugewiesene Lizenzen Benutzer-Institutionell",
  governance_rating: "G Bewertung",
  r_provisions_for_doubtful_debtors: "R\xFCckstellungen f\xFCr zweifelhafte Forderungen",
  r_management_fees: "Verwaltungsgeb\xFChren",
  potential_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
  c_five_years_total_return: "Gesamtrendite 5 Jahre",
  ter_mv: "TERrefMV",
  r_valuation_expenses: "Bewertungsgeb\xFChren",
  three_years_total_return: "3-Jahres-Gesamtrendite",
  legal_form: "Rechtsform",
  five_years_return: "5-Jahres-Nettorendite",
  last: "Letzter",
  name: "Name",
  c_tna_compounded: "Aufgezinstes TNA",
  r_other_interest: "Sonstige Zinsaufwendungen",
  r_total_expenses: "Gesamtaufwand",
  created_at: "Erstellungsdatum",
  market_cap: "Marktkapitalisierung",
  r_ordinary_income_carried_forward_from_previous_financial_year: "Vorgetragene ordentliche Ertr\xE4ge aus dem Vorjahr",
  open: "Er\xF6ffnungspreis",
  key_name: "Schl\xFCsselname",
  real_net_rent_monthly: "Monatliches Mietertr\xE4ge",
  c_current_ratio: "Liquidit\xE4tsgrad",
  c_roe: "ROE (Eigenkapitalrendite)",
  r_plots_rental_space: "Mietfl\xE4che Entwicklungsliegenschaften",
  floors_nb: "Anzahl Stockwerke",
  r_max_purchase_and_sale_fees: "Maximale Kauf- und Verkaufsgeb\xFChren",
  r_interest_on_building_rights: "Zinsen auf Baurechte",
  m_dividend_date: "Dividendenstichtag",
  entity_name: "Name",
  lot_nb: "Parzellennummer",
  used_investor_seat: "Zugewiesene Lizenzen Benutzer-Investor",
  actions: "Weitere Aktionen",
  potential_net_rent_monthly: "Monatliches Mietertr\xE4ge",
  market_price: "Aktienkurs",
  expiration_date: "Vertragsende",
  estimated_area: "Fl\xE4che",
  one_year_return: "1-Jahres-Nettorendite",
  r_total_rental_space: "Gesamtmietfl\xE4che",
  r_dividend_distribution: "Dividendenaussch\xFCttung",
  tx_price: "Transaktionskosten",
  construction_year: "Baujahr",
  tx_year: "Transaktionsjahr"
};
var highlight = {
  label: {
    category: {
      high: "Hoch",
      very_high: "Sehr hoch",
      medium: "Mittlere",
      low: "Gering",
      very_low: "Sehr gering",
      null: "-",
      undefined: "-"
    }
  }
};
var asset_page = {
  environmental: {
    energy: {
      co2: {
        title: "CO\u2082-Emissionen",
        total_official_co2_emission: "Gesamt CO\u2082 (offiziell)",
        total_estimated_co2_emission: "Gesamt CO\u2082",
        estimated_co2_emission_per_m2: "CO\u2082 pro m\xB2",
        official_co2_emission_per_m2: "CO\u2082 pro m\xB2 (offiziell)",
        estimated_co2: "CO\u2082-Emissionen"
      },
      idc: {
        estimated_idc: "Energieintensit\xE4t",
        total_estimated_idc: "Gesamte Energieintensit\xE4t",
        title: "Energieintensit\xE4t",
        total_official_idc: "Gesamte Energieintensit\xE4t (offiziell)",
        official_idc_per_m2: "Energieintensit\xE4t pro m\xB2 (offiziell)",
        estimated_idc_per_m2: "Energieintensit\xE4t pro m\xB2"
      },
      heating: {
        energy_generator_heating_1: "Heizgenerator",
        energy_source_heating_1: "Heizenergiequelle",
        energy_generator_water_1: "Warmwasserhiezung",
        energy_source_water_1: "W\xE4rmequelle f\xFCr Warmwasser",
        title: "W\xE4rmeerzeugung"
      },
      title: "Energie",
      solar: {
        solar_existing: "Installierte Photovoltaik-Leistung",
        title: "Solar",
        solar_potential: "Solarpotenzial"
      }
    },
    risk: {
      climate_risk_index: {
        title: "Klimarisikoindex"
      },
      sia261: "Erdbebenzonen SIA 261",
      debris_flow: "Tr\xFCmmerstrom",
      overbank_sedimentation: "Sedimentation im \xDCberflutungsbereich",
      risk: {
        title: "Umweltgefahren"
      },
      chart: {
        suffix: "/10",
        description: "Der Klimarisikoindex wird entsprechend der Exposition gegen\xFCber verschiedenen Umweltrisiken berechnet. Jedes Risiko hat im Index das gleiche Gewicht."
      },
      avalanches: "Lawinen",
      hail_hazard_10_years_average: "Hagelkorngr\xF6ssen",
      title: "Risiken",
      rockfalls: "Steinschl\xE4ge",
      floods_50_years: "\xDCberschwemmungen",
      landslides: "Erdrutsche",
      windstorm_avg_rate: {},
      hail_avg_rate: {},
      damage_rate: {},
      detailed_rates: {},
      flood_avg_rate: {}
    },
    environment: {
      pollution: {
        road_noise_day: {
          label: "Tags\xFCber Verkehrsl\xE4rm"
        },
        road_noise_night: {
          label: "N\xE4chtlicher Verkehrsl\xE4rm"
        },
        rail_noise_night: {
          label: "N\xE4chtlicher Schienenverkehrsl\xE4rm"
        },
        rail_noise_day: {
          label: "Tags\xFCber Schienenverkehrsl\xE4rm"
        },
        title: "L\xE4rmbelastung"
      },
      climate: {
        temperature: {
          title: "Durchschnittstemperatur"
        },
        title: "Klima",
        rain: {
          title: "Durchschnittliche Niederschlagsmenge"
        },
        sunlight: {
          title: "Durchschnittliche Sonneneinstrahlung"
        }
      },
      title: "Umfeld"
    },
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (Scope 1 + 2 + 3.3)",
      co2_scope_2_per_m2: "CO\u2082 (Scope 2)",
      co2_scope_1_2_per_m2: {
        description: "Die CO\u2082-Emissionen werden berechnet, indem f\xFCr jedes Geb\xE4ude die Energieintensit\xE4t mit dem entsprechenden REIDA-Koeffizienten multipliziert wird.",
        key: "CO\u2082 (Scope 1 + 2)"
      },
      co2_scope_1_per_m2: "CO\u2082 (Scope 1)",
      total_co2_scope_1_2: "Gesamt CO\u2082 (Scope 1 + 2)",
      total_co2_scope_1_2_33: "Total CO\u2082 (Scope 1 + 2 + 3.3)",
      co2_scope_33_per_m2: "CO\u2082 (Scope 3.3)"
    },
    idc: {
      idc_per_m2: {
        description: "Die Energieintensit\xE4t misst den gesch\xE4tzten Energieverbrauch pro Quadratmeter Heizfl\xE4che \xFCber ein Jahr f\xFCr das Geb\xE4ude.",
        key: "Energieintensit\xE4t"
      },
      total_idc: "Gesamtenergie"
    },
    title: "Umwelt",
    risks: {
      damage_rate: {}
    }
  },
  social: {
    demographic: {
      birth: {
        subject: "Geburten"
      },
      civil_status: {
        death: "Todesf\xE4lle pro Jahr",
        divorce: "Scheidungen pro Jahr",
        birth: "Geburten pro Jahr",
        title: "Familienstand",
        household: "Durchschnittliche Haushaltsgr\xF6\xDFe",
        marriage: "Heiraten pro Jahr"
      },
      ages: {
        title: "Alter"
      },
      emigration: {
        subject: "Emigration"
      },
      title: "Demografisch",
      vital_statistics: {
        title: "Vitalstatistiken"
      },
      immigration: {
        subject: "Immigration"
      },
      foreigners: {
        title: "Ausl\xE4nder"
      },
      gender: {
        title: "Geschlecht"
      },
      migration: {
        title: "Migration"
      },
      death: {
        subject: "Todesf\xE4lle"
      }
    },
    transportation_accessibility: {
      computed_early_years_meter: "Kinderbetreuung",
      computed_shops_minute: "L\xE4den",
      computed_primary_education_meter: "Primarbildung",
      computed_cultural_venues_meter: "Kulturelle Einrichtungen",
      computed_restaurants_meter: "Restaurants",
      radar: {
        title: "Erreichbarkeit der Annehmlichkeiten"
      },
      computed_sports_recreation_minute: "Sport und Freizeit",
      computed_transport_bike_minute: "Veloparkierung",
      computed_sports_recreation_meter: "Sport und Freizeit",
      computed_restaurants_minute: "Restaurants",
      official_pt_accessibility: {
        title: "Durschnittlicher Erreichbarkeitswert"
      },
      computed_healthcare_meter: "Gesundheitsversorgung",
      computed_social_and_cultural_activities_minute: "Soziale und kulturelle Aktivit\xE4ten",
      computed_public_open_space_minute: "\xD6ffentlicher Freiraum",
      computed_cultural_venues_minute: "Kulturelle Einrichtungen",
      computed_public_transport_minute: "\xD6ffentlicher Verkehr",
      computed_transport_bus_meter: "Bus",
      road_accessibility: {
        label: "Erreichbarkeit \xFCber die Strasse",
        title: "\xDCber die Strasse",
        description: "Erreichbarkeit \xFCber die Strasse gem\xE4ss der ARE"
      },
      transport_accessibility: {
        title: "Mit dem Zug",
        label: "Erreichbarkeit mit \xF6ffentlichem Verkehr",
        description: "Erreichbarkeitspunktzahl mit \xF6ffentlichem Verkehr gem\xE4ss der ARE"
      },
      computed_aged_care_minute: "Altenpflege",
      title: "Erreichbarkeit",
      computed_aged_care_meter: "Altenpflege",
      computed_transport_bus_minute: "Bus",
      computed_healthcare_minute: "Gesundheitsversorgung",
      official_road_accessibility: {
        title: "Durschnittlicher Erreichbarkeitswert"
      },
      computed_secondary_education_meter: "Sekundarbildung",
      computed_shops_meter: "L\xE4den",
      computed_transport_bike_meter: "Veloparkierung",
      computed_aged_and_early_years_care_minute: "Alters- und fr\xFChkindliche Betreuung",
      computed_early_years_minute: "Kinderbetreuung",
      computed_transport_train_meter: "Zug",
      computed_primary_education_minute: "Primarbildung",
      map: {
        title: "Karte der Annehmlichkeiten"
      },
      computed_transport_train_minute: "Zug",
      table: {
        title: "Durschschnittliche Gehzeit zu den Annehmlichkeiten"
      },
      computed_secondary_education_minute: "Sekundarbildung",
      computed_public_open_space_meter: "\xD6ffentlicher Freiraum"
    },
    well_being: {
      title: "Wohlbefinden",
      public_utility: {
        key: "\xD6ffentliches Geb\xE4ude",
        title: "\xD6ffentliches Geb\xE4ude"
      }
    },
    accessibility: {
      transportation: {
        title: "\xD6ffentlicher Verkehr"
      },
      transport_train: "Zug",
      aged_care: "Altenpflege",
      goods_and_services: {
        title: "Andere"
      },
      title: "Distanz zur n\xE4chstgelegenen Dienstleistungen",
      early_years: "Kinderbetreuung",
      distance: {
        title: "Erreichbarkeit"
      },
      chart: {
        subject: "Index",
        title: "Erreichbarkeit",
        suffix: "/10"
      },
      restaurants: "Restaurants",
      healthcare: "Gesundheitswesen",
      shops: "L\xE4den",
      health_and_edu: {
        title: "Gesundheit & Bildung"
      },
      cultural_venues: "Kulturelle Einrichtungen",
      primary_education: "Primarbildung",
      transport_bus: "Bus",
      secondary_education: "Sekundarbildung"
    },
    income_and_taxes: {
      income: {
        label: "Einkommen",
        description: "Beschreibung",
        title: "Einkommen",
        subject: "Einkommen pro Steuerzahler"
      },
      wealth: {
        label: "Verm\xF6gen"
      },
      title: "Einkommen und Steuern",
      canton_tax: {
        title: "Kantonale Steuerf\xFCsse"
      },
      capital: {
        label: "Kapital"
      },
      municipality_tax: {
        title: "Gemeindesteuerf\xFCsse"
      },
      profit: {
        label: "Gewinn"
      }
    },
    density: {
      occupancy_per_100_m2: {
        title: "Belegung pro 100 m\xB2"
      },
      occupancy: {
        per_meter: "Pro 100 m\xB2",
        per_bedroom: "Pro Schlafzimmer",
        title: "Belegungsrate"
      },
      migration: {
        departure: "Abgang pro Einwohner",
        title: "Migration",
        arrival: "Ankunft pro Einwohner"
      },
      title: "Dichte",
      green_density: {
        key: "Gr\xFCne Dichte",
        description: "Die Gr\xFCne Dichte misst den Anteil der umliegenden Hektaren, die \xFCberwiegend Gr\xFCnfl\xE4chen enthalten, gem\xE4\xDF der Fl\xE4chennutzung (NOAS04)",
        title: "Begr\xFCnung"
      },
      population_density: {
        title: "Bev\xF6lkerungsdichte",
        description: "Die Bev\xF6lkerungsdichte misst die durchschnittliche Bev\xF6lkerungsdichte in den umliegenden Hektar pro Geb\xE4ude, gem\xE4\xDF STATPOP.",
        key: "Bev\xF6lkerungsdichte"
      },
      job_density: {
        title: "Arbeitsplatzdichte",
        description: "Die Arbeitsplatzdichte misst die durchschnittliche Arbeitsplatzdichte in den umliegenden Hektar pro Geb\xE4ude, gem\xE4\xDF STATENT.",
        key: "Arbeitsplatzdichte"
      },
      occupancy_per_m2: {
        subject: "Einwohner"
      },
      income: {
        title: "Einkommen pro Steuerzahler",
        subject: "Einkommen pro Steuerzahler"
      },
      occupancy_per_bedroom: {
        subject: "Einwohner",
        title: "Belegung pro Schlafzimmer"
      }
    },
    title: "Soziales"
  },
  valuation: {
    parameters: {
      transaction_fees: {
        property_transfert_fees: {
          suffix: "%",
          label: "Hand\xE4nderungsgeb\xFChren"
        },
        notary_fees: {
          suffix: "%",
          label: "Notarkosten"
        },
        land_registration_fees: {
          suffix: "%",
          label: "Grundbuchgeb\xFChren"
        },
        title: "Transaktionsgeb\xFChren"
      },
      buyer_seller: {
        other_fees_pts: {
          label: "Sonstige Geb\xFChren",
          suffix: "%"
        },
        title: "K\xE4ufer / Verk\xE4ufer",
        other_fees_chf: {
          label: "Sonstige Geb\xFChren",
          suffix: "CHF"
        },
        share_buyers_seller: {
          suffix: "%",
          label: "Teil K\xE4ufer / Verk\xE4ufer"
        },
        asset_manager_fees: {
          suffix: "%",
          label: "Geb\xFChren f\xFCr Asset-Manager"
        }
      },
      due_diligence_cost: {
        other_valuations: {
          label: "Sonstige Bewertungen",
          suffix: "CHF"
        },
        title: "Due-Diligence-Kosten",
        valuation: {
          suffix: "CHF",
          label: "Bewertung"
        }
      },
      title: "Parameter"
    },
    qh_method: {
      result: {
        title: "Ergebnis",
        total_acquisition_cost: {
          suffix: "CHF",
          label: "Gesamte erwerbskosten"
        },
        purchase_price: {
          label: "Kaufpreis",
          suffix: "CHF"
        }
      },
      description: {
        content: "Die maschinellen Lernalgorithmen von Quanthome sch\xE4tzen die erwartete Zielrendite f\xFCr das Geb\xE4ude und prognostizieren einen auf den gesch\xE4tzten Cashflows basierenden Wert.",
        title: "Beschreibung"
      },
      title: "Die Methode von Quanthome"
    },
    cap_rate_method: {
      cap_rate_inputs: {
        title: "Kapitalisierungsraten-Eingaben",
        capitalization_rate: {
          label: "Kapitalisierungsrate",
          suffix: "%"
        }
      },
      income_inputs: {
        other: {
          label: "Sonstige Einnahmen",
          suffix: "CHF"
        },
        dwelling_net_rent: {
          suffix: "CHF",
          label: "Nettomiete der Wohnung"
        },
        office_net_income: {
          label: "B\xFCro-Nettoeinkommen",
          suffix: "CHF"
        },
        residential_net_income: {
          suffix: "CHF",
          label: "Nettoeinkommen aus Wohnimmobilien"
        },
        title: "Einnahmeninputs",
        industrial: {
          label: "Industriell",
          suffix: "CHF"
        },
        parking: {
          suffix: "CHF",
          label: "Parking"
        },
        commercial: {
          label: "Gewerbliche Einnahmen",
          suffix: "CHF"
        }
      },
      result: {
        total_acquisition_cost: {
          label: "Gesamte erwerbskosten",
          suffix: "CHF"
        },
        purchase_price: {
          suffix: "CHF",
          label: "Kaufpreis"
        },
        title: "Ergebnis"
      },
      description: {
        content: "Die Methode der Kapitalisierungsrate (Cap Rate), die auf Immobilien angewendet wird, dient zur Sch\xE4tzung des potenziellen Wertes einer Immobilie. Sie wird als Mieteinnahmen geteilt durch die angestrebte Rendite berechnet. Cap Rates ber\xFCcksichtigen nicht die zuk\xFCnftige Wertsteigerung oder Finanzierungskosten.",
        title: "Beschreibung"
      },
      title: "Kapitalisierungsrate-Methode"
    },
    title: "Bewertung"
  },
  description: {
    tile: {
      description: "Beschreibung",
      parent_description: "Elternbeschreibung",
      usage: "Nutzung",
      administrative_information: "Administrative Informationen",
      geometry: "Geometrie",
      addresses: "Adressen",
      location: "Standort",
      amenities: "Annehmlichkeiten",
      dwellings: {
        parent_description: "Beschreibung des verwandlten Geb\xE4udes"
      },
      buildings: {
        parent_description: "Beschreibung der Parzelle"
      }
    },
    title: "Beschreibung",
    identification: {
      title: "Identifikation"
    },
    general_information: {
      title: "Allgemeine Informationen"
    }
  },
  financials: {
    ratio_metric: {
      total_tenant_charges: "Gesamte Mietergeb\xFChren",
      price_per_m2: "Preis pro m\xB2",
      office: "B\xFCro",
      residential: "Wohnimmobilien",
      title: "Kennzahlen pro Quadratmeter",
      price: {
        title: "Preis"
      },
      commercial_spaces: {
        label: "Gewerbliche R\xE4ume"
      },
      charges_per_m2: "Mieternebenkosten pro m\xB2",
      charges: {
        title: "Geb\xFChren"
      },
      average: "Durchschnitt",
      market_value_reported: "Marktwert",
      rent_per_m2: "Mietertr\xE4ge pro m\xB2",
      industrial: "Industriell",
      rent: {
        title: "Mietertr\xE4ge"
      },
      commercial: "Gewerbeimmobilien",
      dwellings: {
        label: "Wohnungen"
      },
      market_value: "Marktwert"
    },
    title: "Finanzen",
    unit: {
      chf: "CHF"
    },
    charges: {
      title: "Mieternebenkosten"
    },
    tile: {
      charges: "Mieternebenkosten",
      rental_income: "Mietertr\xE4ge",
      evolution: "Entwicklung"
    },
    dwellings: {
      label: "Wohnungen"
    },
    revenue: {
      title: "Einnahmen"
    },
    comparables: {
      title: "Vergleichswerte"
    },
    units: {
      total_rent: "CHF",
      commercial_rent: "CHF",
      residential_rent: "CHF"
    },
    performance: {
      rental_income: "Mietertr\xE4ge",
      title: "Performance"
    },
    metrics: {
      title: "Kennzahlen pro Quadratmeter"
    },
    total: {
      label: "Total"
    },
    commercial_spaces: {
      label: "Gewerbliche R\xE4ume"
    }
  },
  overview: {
    description: {
      market_value: "Marktwert",
      co2: "CO\u2082",
      net_rent: "Mietertr\xE4ge",
      idc: "Energieintensit\xE4t",
      charges: "Mieternebenkosten",
      roa: "ROA (Gesamtkapitalrentabilit\xE4t)"
    }
  },
  governance: {
    item: {
      management: {
        website: "Website",
        name: "Name"
      },
      ownership: {
        link: "Link",
        owner: "Eigent\xFCmer",
        registry: "Kataster"
      },
      certification: {
        minergy: "Minergie"
      }
    },
    tile: {
      ownership: "Eigentum",
      management: "Immobilienverwaltung",
      certification: "Zertifizierung"
    },
    title: "Governance",
    organisation: {
      title: "Organisation"
    }
  },
  assets: {
    title: "Bestand"
  }
};
var modal = {
  leaving: {
    buttons: {
      proceed: "Fortfahren"
    },
    default_text: "Sie haben auf einen von Quanthome SA bereitgestellten Link geklickt, der Sie au\xDFerhalb der App weiterleitet.\nWir stehen in keinerlei Verbindung zu dieser Website oder deren Eigent\xFCmer. Wir empfehlen Ihnen nachdr\xFCcklich, generell beim Surfen im Internet niemals pers\xF6nliche Daten anzugeben, ohne zuvor sorgf\xE4ltig zu pr\xFCfen, ob die betreffende Website (nach wie vor) vertrauensw\xFCrdig ist.\nKeine Website sollte Sie nach Ihren Quanthome-Zugangsdaten fragen, und kein Verm\xF6gensverwalter wird jemals nach Ihrem Passwort verlangen.",
    registry: {
      title: "Scritte, die im externen Prozess durchf\xFChren werden sollen"
    },
    title: "Sie sind dabei, die App zu verlassen"
  },
  notifications: {
    title_emailinfo: "Sie k\xF6nnen jetzt Ihre E-Mail-Pr\xE4ferenzen festlegen",
    administration_linked: "Sie k\xF6nnen jetzt das Unternehmen {{enterprise}} verwalten.",
    empty_message: "Keine Benachrichtigungen",
    title_download: "Herunterladen",
    subtitle_emailinfo: "verwalten Sie die E-Mails, die Sie von uns erhalten werden",
    administration_days_left: "Der Zustand des Unternehmens {{enterprise}} ben\xF6tigt Ihre Aufmerksamkeit: Der Zustand {{currentState}} hat noch {{daysLeft}} Tage \xFCbrig.",
    title: "Benachrichtigungen",
    title_recoverycode: "Generieren Sie jetzt Ihre Wiederherstellungscodes neu",
    administration_examination: "Das Unternehmen {{enterprise}} befindet sich seit einem Monat im Pr\xFCfungszustand.",
    title_administration: "Verwaltung",
    administration_unlinked: "Das Unternehmen {{enterprise}} wurde von Ihrer Verwaltungsliste entfernt."
  },
  downloads: {
    subtitle: {
      file_ready: "Ihre Datei kann jetzt herunterladen werden",
      file_failed: "Ihre Datei ist aufgrund eines Fehlers fehlgeschlagen - Bitte kontaktieren Sie Ihren Administrator.",
      file_about_to_expire: "Ihre Datei wird bald ablaufen.",
      file_expired: "Ihre Datei ist abgelaufen",
      file_be_ready_soon: "Ihre Datei wird bald zum Download bereit sein."
    },
    empty_message: "Keine Downloads",
    title: "Downloads",
    not_available: "Die Download-Funktion ist bei Ihrem aktuellen Abonnement nicht verf\xFCgbar."
  },
  preset: {
    title: "Voreinstellungen",
    empty_message: "Keine Voreinstellungen"
  },
  support: {
    error_message: {
      bad_category: "Sie m\xFCssen eine Kategorie ausw\xE4hlen",
      too_many_char: "Zu viele Zeichen {{char_nb}} > 500",
      no_message: "Sie m\xFCssen eine Nachricht schreiben"
    },
    message: "Nachricht",
    select: {
      title: "Problem, Nachricht, Bedarf, Idee...",
      message: "Nachricht",
      need: "Bedarf",
      placeholder: "W\xE4hlen",
      problem: "Problem"
    },
    success: {
      message: "Ihr Bericht wurde erfolgreich an unseren Kundenservice gesendet.",
      title: "Der Bericht wurde gesendet"
    },
    title: "Hilfe",
    complete_title: "Support / Kontakt",
    submit_button: "Kontaktieren Sie unseren Support",
    upload: "Hochladen"
  },
  historic: {
    title: "Geschichte"
  },
  history: {
    title: "Geschichte",
    empty_history: "Keine Historie"
  },
  notification: {
    title_download: "Herunterladen"
  }
};
var income_statement = {
  label: {
    total_revenues: "Gesamtertrag",
    r_revenue_from_postal_and_bank_accounts: "Einnahmen aus Postkonten und Bankkonten",
    r_building_expenses: "Bewirtschaftungskosten",
    interest_expenses: "Zinsaufwendungen",
    r_provisions_for_doubtful_debtors: "R\xFCckstellungen f\xFCr zweifelhafte Forderungen",
    r_profit_and_capital_taxes: "Gewinnsteuern und Kapitalsteuern",
    r_valuation_and_auditing_expenses: "Bewertungs- und Auditgeb\xFChren",
    r_mortgage_interest: "Hypothekenzinsen",
    r_net_income: "Nettogewinn",
    r_market_maker_fees: "Marktmachergeb\xFChren",
    r_extraordinary_maintenance_and_repairs_expenses: "Au\xDFerordentliche Instandhaltungs- und Reparaturkosten",
    ordinary_income_carried_forward: "Vorgetragene ordentliche Ertr\xE4ge",
    r_absolute_management_fees: "Verwaltungsgeb\xFChren (Betrag)",
    retained_earnings: "Gewinnr\xFCcklagen",
    r_absolute_custodian_bank_distribution_fees: "Depotbankvertriebgeb\xFChren (Betrag)",
    r_maintenance_costs: "Instandhaltungskosten",
    unrealised_gains_losses_including_liquidation_taxes_variation: "Nicht realisierte Gewinne/Verluste einschliesslich Ver\xE4nderung der Liquidationssteuern",
    total_net_income_available_for_distribution: "Gesamter aussch\xFCttungsf\xE4higer Nettogewinn",
    r_realised_capital_gains_and_losses: "Realisierte Kapitalgewinne und -verluste",
    realised_gains_losses: "Realisierte Gewinne/Verluste",
    r_total_interest: "Gesamtzinsergebnis",
    r_administration_expenses: "Verwaltungskosten",
    r_valuation_expenses: "Bewertungsgeb\xFChren",
    other_revenue: "Sonstige Einnahmen",
    capital_distribution: "Kapitalaussch\xFCttung",
    r_ordinary_income_carried_forward_from_previous_financial_year: "Vorgetragene ordentliche Ertr\xE4ge aus dem Vorjahr",
    valuation_and_auditing_expenses: "Bewertungs- und Auditgeb\xFChren",
    total_income: "Gesamte Mietertr\xE4ge",
    r_absolute_directors_fees: "Verwaltungsrathonorar (Betrag)",
    r_total_provisions: "Gesamte R\xFCckstellungen",
    r_absolute_legal_fees: "Anwaltskosten (Betrag)",
    r_maintenance_and_repairs_expenses: "Unterhalts- und Reparaturkosten",
    r_provisions_for_future_work: "R\xFCckstellungen f\xFCr zuk\xFCnftige Bauarbeiten",
    r_dividend_distribution: "Dividendenaussch\xFCttung",
    r_net_income_available_for_distribution: "Aussch\xFCttungsf\xE4higer Nettogewinn",
    r_provisions_for_future_works: "R\xFCckstellungen f\xFCr zuk\xFCnftige Arbeiten",
    reproted_market_maker_fees: "Marktmachergeb\xFChren",
    r_absolute_custodian_bank_commission_fees: "Depotbankprovisionsgeb\xFChren (Betrag)",
    r_auditing_expenses: "Auditgeb\xFChren",
    dividend_distribution: "Dividendenaussch\xFCttung",
    taxes: "Steuern",
    r_unrealised_gains_and_losses_including_var_est_liq_tax: "Nicht realisierte Gewinne/Verluste einschliesslich Ver\xE4nderung der Liquidationssteuern",
    r_interest_on_building_rights: "Zinsen auf Baurechte",
    r_taxes: "Steuern",
    r_other_interest: "Sonstige Zinsaufwendungen",
    r_other_administration_expenses: "Sonstige Verwaltungskosten",
    r_other_expenses: "Sonstige Ausgaben",
    other_expenses: "Sonstige Ausgaben",
    negative_interest: "Negative Zinsen",
    realised_income: "Realisierte Ertr\xE4ge",
    maintenance_costs: "Instandhaltungskosten",
    r_unrealised_capital_gains_and_losses: "Unrealisierte Kapitalgewinne und -verluste",
    r_total_expenses: "Gesamtaufwand",
    r_total_revenue: "Gesamtertrag",
    reproted_ordinary_maintenance_and_repairs_expenses: "Ordentliche Wartungs- und Reparaturkosten",
    r_negative_interest: "Negative Zinsen",
    r_total_income: "Gesamte Mietertr\xE4ge",
    r_retained_earnings: "Gewinnreserven",
    r_absolute_custodian_bank_fees: "Depotbankgeb\xFChren (Betrag)",
    revenue_from_postal_and_bank_accounts: "Einnahmen aus Postkonten und Bankkonten",
    year: "Jahr",
    r_absolute_property_management_fees: "Immobilienverwaltungsgeb\xFChren (Betrag)",
    r_capital_distribution: "Kapitalaussch\xFCttung",
    r_administration_of_buildings: "Geb\xE4udeverwaltung",
    net_income: "Nettogewinn",
    r_ordinary_maintenance_and_repairs_expenses: "Ordentliche Wartungs- und Reparaturkosten",
    rental_income: "Mietertr\xE4ge",
    r_rental_income: "Mietertr\xE4ge",
    other_net_income_available_for_distribution: "Sonstige verf\xFCgbare Nettoertr\xE4ge zur Aussch\xFCttung",
    r_property_management_expenses: "Immobilienverwaltungskosten",
    r_other_revenue: "Sonstige Einnahmen",
    r_property_tax: "Liegenschaftssteuer",
    r_realised_income: "Realisierte Ertr\xE4ge",
    total_expenses: "Gesamtaufwand"
  },
  unit: {
    chf: "CHF"
  },
  legend: {
    group: {
      income_statement: "Gewinn- und Verlustrechnung",
      distribution_of_realised_income: "Aussch\xFCttung der realisierten Ertr\xE4ge"
    }
  }
};
var balance_sheet = {
  label: {
    r_total_cash: "Fl\xFCssige Mittel insgesamt",
    r_other_assets: "Sonstige Verm\xF6genswerte",
    r_short_term_liabilities: "Kurzfristige Verbindlichkeiten",
    r_other_long_term_liabilities: "Andere langfristige Verbindlichkeiten",
    r_total_liabilities: "Gesamtverbindlichkeiten",
    date: "Datum",
    r_short_term_interest_bearing_mortgages: "Kurzfristige verzinsliche Hypotheken",
    r_total_net_assets: "Gesamte Nettoverm\xF6genswerte",
    r_long_term_liabilities: "Langfristige Verbindlichkeiten",
    r_total_properties: "Gesamtliegenschaften",
    total_asset: "Gesamtverm\xF6gen",
    r_tga_before_distribution: "Gesamte Verm\xF6genswerte",
    asset_total: "Gesamte Verm\xF6genswerte",
    r_net_assets_before_estimated_liquidation_taxes: "Nettoverm\xF6genswerte vor gesch\xE4tzten Liquidationssteuern",
    other_liabilities: "Sonstige Verbindlichkeiten",
    r_tna_before_distribution: "TNA vor Aussch\xFCttung",
    r_estimated_liquidation_taxes: "Gesch\xE4tzte Liquidationssteuern",
    r_other_short_term_liabilities: "Andere kurzfristige Verbindlichkeiten",
    total_liabilities: "Gesamtverbindlichkeiten",
    r_long_term_interest_bearing_mortgages: "Langfristige verzinsliche Hypotheken"
  },
  legend: {
    group: {
      asset: "Verm\xF6gen",
      liabilities: "Verbindlichkeiten",
      equity: "Eigenkapital"
    }
  },
  unit: {
    chf: "CHF"
  }
};
var portfolios = {
  designation: {
    fund_age: "Alter des Immobilienportfolios",
    residential_area: "Gesamte Wohnfl\xE4che",
    total_area: "Gesamtfl\xE4che",
    created_at: "Erstellungsdatum",
    buildings_nb: "Anzahl Geb\xE4ude",
    individual_dwellings_nb: "Anzahl Wohnungen ohne zugeh\xF6riges Geb\xE4ude im Portfolio",
    type: "Verm\xF6gensallokation des Portfolios",
    industrial_area: "Gesamte Industriefl\xE4che",
    office_area: "Gesamte B\xFCrofl\xE4che",
    dwellings_nb: "Anzahl Wohnungen",
    updated_at: "Letzte Aktualisierung",
    name: "Name des Instruments",
    commercial_area: "Gesamte Gewerbefl\xE4che"
  },
  notification: {
    success_create: {
      message: "Das Portfolio wurde erfolgreich erstellt",
      title: "Erfolgreiche Erstellung"
    }
  },
  environmental: {
    solar_potential: "Gesamtes Solarpotenzial",
    solar_existing_per_m2: "Installierte Photovoltaik-Leistung pro m\xB2",
    debris_flow: "Tr\xFCmmerstrom",
    solar_existing: "Installierte Photovoltaik-Leistung",
    floods_50_years: "\xDCberschwemmungen",
    evolution: {
      chart: {
        title: "Diagramm"
      }
    },
    avalanches: "Lawinen",
    rockfalls: "Steinschl\xE4ge",
    estimated_co2_emission_per_m2: "CO\u2082 pro m\xB2",
    landslides: "Erdrutsche",
    building_with_solar_existing: "Geb\xE4ude mit Photovoltaikanlage",
    overbank_sedimentation: "Sedimentation im \xDCberflutungsbereich",
    hail_hazard_10_years_average: "Hagelkorngr\xF6ssen",
    total_estimated_co2_emission: "Gesamt CO\u2082",
    estimated_idc_per_m2: "Energieintensit\xE4t pro m\xB2",
    total_estimated_idc: "Gesamte Energieintensit\xE4t"
  },
  description: {
    distribution: {
      label_string: "Kanton",
      value_string: "Fl\xE4che"
    }
  },
  tiles: {
    energy_source: {
      title: "Energiequelle"
    },
    risks: {
      title: "Umweltgefahren"
    },
    designation: {
      title: "Bezeichnung"
    },
    solar: {
      title: "Solar"
    },
    distribution: {
      title: "Distribution"
    },
    risk_index: {
      title: "Klimarisikoindex"
    },
    idc_and_co2: {
      title: "Energieintensit\xE4t & CO\u2082"
    },
    composition: {
      title: "Zusammensetzung"
    }
  },
  environment: {
    energy_distribution: {
      label_string: "Heizsystem",
      value_string: "Heizfl\xE4che"
    }
  },
  financials: {
    evolution: {
      title: "Entwicklung",
      chart: {
        title: "Diagramm"
      }
    },
    performance: {
      title: "Performance",
      evolution: {
        title: "Entwicklung"
      }
    }
  },
  noright: {
    details: "Das Portfolio-Modul erm\xF6glicht Ihnen, einen globalen \xDCberblick \xFCber ein Immobilienportfolio von finanziellen bis hin zu ESG-Daten zu haben.",
    title: "Portfolios",
    button: "Kontaktieren Sie den Account-Manager",
    subtitle: "Diese Funktion erfordert einen umfassenderen Abonnement-Plan."
  },
  widget: {
    identification: {
      title: "Identifikation"
    },
    risk: {
      title: "Risiko"
    },
    energy: {
      title: "Energie"
    }
  },
  overview: {
    type: {
      dwelling: "Wohnung",
      mixed: "Gemischte Nutzung",
      empty: "Leer",
      building: "Geb\xE4ude"
    },
    potential_market_value: "Marktwert",
    potential_roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
    potential_charges: "Geb\xFChren",
    potential_net_rent: "Mietertr\xE4ge"
  },
  modal: {
    confirm_delete: {
      title: "Portfolio l\xF6schen",
      text: "Sind Sie sicher, dass Sie dieses Portfolio l\xF6schen m\xF6chten?",
      cancel: "Zur\xFCck",
      proceed: "Fortfahren",
      notification: {
        text: "Das Portfolio wurde gel\xF6scht"
      }
    }
  },
  create_modal: {
    title: "Neues Portfolio"
  }
};
var asset = {
  description: {
    amenities: {
      buildings: {
        imputed_cachet: "Cachet",
        fallout_shelter: "Schutzraum",
        imputed_elevator: "Aufzug",
        imputed_near_highway: "In der N\xE4he der Autobahn",
        imputed_near_transports: "In der N\xE4he von Verkehrsanbindungen",
        imputed_bike_room: "Fahrradraum"
      },
      dwellings: {
        imputed_mansarde: "Mansarde",
        imputed_cellar: "Keller",
        imputed_balcony: "Balkon",
        imputed_attique: "Attika"
      }
    },
    buildings: {
      industrial_area: "Industriefl\xE4che",
      construction_date: "Baujahr",
      category: "Kategorie",
      city: "Stadt",
      class: "Klasse",
      official_nb: "Offizielle Nummer",
      total_area: "Gesamtfl\xE4che",
      egid: "EGID",
      type: "Typ",
      commercial_area: "Gewerbefl\xE4che",
      dwellings_nb: "Anzahl Wohnungen",
      area: "Grundfl\xE4che",
      status: "Status",
      land_use: "Fl\xE4chennutzung",
      floors_nb: "Anzahl Stockwerke",
      office_area: "B\xFCrofl\xE4che",
      volume: "Gesamtvolumen",
      residential_area: "Wohnfl\xE4che"
    },
    lots: {
      municipality: "Gemeinde",
      sector: "Sektor",
      surface: "Fl\xE4che",
      type: "Typ",
      land_use: "Fl\xE4chennutzung",
      built_up_area: "Geb\xE4udefl\xE4che",
      number: "Nummer",
      built_up_ratio: "Bebauungsgrad",
      city: "Stadt",
      label: "Bezeichnung",
      egrid: "EGRID"
    },
    dwellings: {
      floor: "Stockwerk",
      rooms_nb: "Anzahl Zimmer",
      city: "Stadt",
      category: "Kategorie",
      land_use: "Fl\xE4chennutzung",
      construction_date: "Baujahr",
      status: "Status",
      ewid: "Ewid",
      egid: "EGID",
      class: "Klasse",
      surface: "Fl\xE4che",
      type: "Typ"
    }
  },
  get_building_from_group: {
    empty: {
      message: "Es gibt kein Geb\xE4ude in dieser Gruppe.",
      title: "Kein Geb\xE4ude in dieser Gruppe"
    }
  }
};
var policy = {
  eea_rights_list: {
    objection: "Recht, der Verarbeitung Ihrer Daten zu widersprechen und Ihre Einwilligung zu widerrufen (Art. 21 DSGVO),",
    access: "Recht auf Auskunft \xFCber die Daten (Art. 15 DSGVO),",
    forgotten: "Recht auf Vergessenwerden (Art. 17 DSGVO),",
    complaint: "Recht, eine Klage bei einer Beh\xF6rde an Ihrem gew\xF6hnlichen Wohn- oder Arbeitsort oder dort, wo ein Versto\xDF stattgefunden hat, einzureichen (Art. 77 DSGVO),",
    automated_decisions: "Recht, nicht automatisierten individuellen Entscheidungen unterworfen zu werden (ein Prozess, den QUANTHOME nicht verwendet).",
    rectification: "Recht auf Berichtigung (Art. 16 DSGVO),",
    processing_restriction: "Recht auf Einschr\xE4nkung der Verarbeitung auf Anfrage (Art. 18 DSGVO)"
  },
  data_list: {
    company_name: "Der Name oder die Firmenbezeichnung des Unternehmens, das Sie vertreten",
    first_name: "Ihr Vorname",
    phone_number: "Ihre Telefonnummer",
    last_name: "Ihr Nachname",
    email_address: "Ihre E-Mail-Adresse"
  },
  data_protection: "Wie sch\xFCtzt QUANTHOME Ihre Daten?",
  rights_exercise: "F\xFCr weitere Details oder um Ihre Rechte auszu\xFCben, kontaktieren Sie uns unter <2>contact@quanthome.com</2>.",
  data_correction: "Sie k\xF6nnen uns kontaktieren, um Ihre Personendaten zu erhalten, deren Richtigkeit zu \xFCberpr\xFCfen, und deren Vervollst\xE4ndigung, Aktualisierung, Berichtigung oder L\xF6schung zu beantragen, soweit gesetzlich zul\xE4ssig, insbesondere gem\xE4\xDF Art. 32 DSG.",
  cookies: {
    types_list: {
      functional: "Funktionale Cookies: Verbessern die Funktionalit\xE4t unserer Website, indem Sie zuvor angesehene Inhalte oder Registrierungsdetails speichern. Diese Cookies erm\xF6glichen, personalisierte Inhalte zu erstellen, und helfen Ihnen, Zeit zu sparen, da Sie sich bei zuk\xFCnftigen Besuchen nicht erneut registrieren m\xFCssen. Wir verwenden auch Cookies f\xFCr Analysen und Werbung.",
      essential: "Wesentliche Cookies: Notwendig f\xFCr den Betrieb unserer Website.",
      statistical: "Statistische Cookies: Sie helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie Informationen \xFCber besuchte Seiten, Verweildauer und jegliche Probleme, wie Fehlermeldungen, bereitstellen. Dies tr\xE4gt zur Verbesserung der Leistung unserer Website bei.",
      third_party: "Drittanbieter-Cookies: Von Dritten gesetzt, die wir f\xFCr verschiedene Dienstleistungen verwenden (z. B. Website-Analyse oder Werbung). QUANTHOME verwendet Google Analytics-Cookies, die Informationen \xFCber das Nutzerverhalten bereitstellen, ohne diese zu identifizieren. Google Analytics-Cookies sammeln keine Daten \xFCber die Besucher der Website. Weitere Informationen zu Google Analytics finden Sie unter <2>https://support.google.com/analytics/answer/6004245?hl=fr</11>."
    },
    consent: "Wir bitten um Ihre ausdr\xFCckliche Zustimmung zur Verwendung von Cookies beim Zugriff auf die Website. Auch wenn Sie diese Richtlinie akzeptieren, k\xF6nnen Sie Cookies ablehnen. Sie k\xF6nnen Cookies jederzeit \xFCber die Einstellungen Ihres Browsers oder Ihres elektronischen Ger\xE4ts verwalten. Bitte beachten Sie jedoch, dass einige Cookies f\xFCr die Funktion der Website unerl\xE4sslich sind und deren Verwendung beeintr\xE4chtigt werden k\xF6nnte, wenn Cookies abgelehnt oder blockiert werden.",
    what_are_cookies: "Was sind Cookies?",
    purpose: "Wir verwenden Cookies, um die Benutzerfreundlichkeit und Funktionalit\xE4t unserer Website zu verbessern und um Ihr Surferlebnis zu personalisieren oder zu optimieren, sodass Ihr n\xE4chster Besuch angenehmer wird.",
    more_information: "F\xFCr weitere Informationen besuchen Sie <2>https://gdpr.eu/cookies/</2>. \xDCberpr\xFCfen Sie auch den Hilfebereich Ihres Browsers oder elektronischen Ger\xE4ts auf spezifische Anweisungen zur Verwaltung von Cookies.",
    types: "Welche Arten von Cookies werden verwendet?",
    usage: "Warum und wie verwenden wir Cookies?",
    types_overview: "Die von uns verwendeten Cookies umfassen:",
    definition: "Cookies sind kleine Textdateien, die von den Websites, die Sie besuchen, auf Ihrem Computer abgelegt werden. Sie werden h\xE4ufig verwendet, um sicherzustellen, dass Websites funktionieren oder effizienter arbeiten, und um Informationen an die Website-Besitzer bereitzustellen. Cookies k\xF6nnen automatisch Daten auf Ihrem Ger\xE4t verarbeiten und/oder Daten \xFCber Sie an den Website-Besitzer oder Dritte \xFCbertragen. Sie k\xF6nnen die Cookies der Website verwalten."
  },
  retention_request: "Sie k\xF6nnen QUANTHOME bitten, Ihre Daten f\xFCr eine m\xF6gliche zuk\xFCnftige Registrierung zu speichern oder um weiterhin unseren Newsletter zu erhalten.",
  consent: "Wenn die oben genannten Gr\xFCnde nicht als legitim angesehen werden, stimmen Sie der Verarbeitung der Daten zu den genannten Zwecken zu, indem Sie diese Richtlinie akzeptieren.",
  personal_data_definition: "Personendaten ('Daten') beziehen sich auf alle Informationen, die sich auf eine Person beziehen. Solche Daten k\xF6nnen Sie entweder direkt (z. B. Ihr Name, Ihre E-Mail-Adresse oder Ihre Sozialversicherungsnummer) oder indirekt identifizieren, indem verschiedene Informationen \xFCber Sie kombiniert werden k\xF6nnen (z. B. die IP-Adresse Ihres Computers, Ihre Kreditkarte oder Ihre Telefonnummer).",
  access_right: "Sofern das anwendbare Recht nichts anderes vorsieht, haben Sie das Recht zu erfahren, ob wir Daten, die Sie betreffen, zu irgendeinem Zeitpunkt verarbeiten und Ihr Zugriffsrecht gem\xE4\xDF Art. 25 DSG auszu\xFCben.",
  data_usage: {
    contact_information: "Ihre Adresse, E-Mail und Telefonnummer erm\xF6glichen es uns, Sie zu kontaktieren. Diese sind f\xFCr den Verkauf von Produkten erforderlich. Wenn sie f\xFCr Newsletter oder Werbekommunikation verwendet werden, geschieht dies auf Grundlage Ihrer Einwilligung.",
    cookies_analytics: "Die durch die Cookies der Website \xFCbermittelten Daten dienen internen Analysen und Werbung. Dies basiert auf unserem berechtigten Interesse und Ihrer Zustimmung, wenn dies gesetzlich erforderlich ist.",
    payment_verification: "Ihre Bankdaten validieren Ihre Zahlung f\xFCr Produkte. Dies ist vertraglich erforderlich.",
    account_creation: "Ihr Vorname, Nachname und, falls zutreffend, der Name Ihres Unternehmens, um Ihr Konto zu erstellen und Ihnen den Zugang zur Website zu erm\xF6glichen sowie Produkte zu bestellen. Dies ist vertraglich erforderlich.",
    legal_compliance: "Alle \xFCbermittelten Daten k\xF6nnen verarbeitet werden, um den gesetzlichen Verpflichtungen und anderen rechtlichen Imperativen nachzukommen",
    legal_age_verification: "Ihr Geburtsdatum stellt sicher, dass Sie vollj\xE4hrig sind, um Vertr\xE4ge mit uns abzuschlie\xDFen. Dies basiert auf unserem berechtigten Interesse."
  },
  eea_representative: "Unser Vertreter im EWR ist [auszuf\xFCllen]. Die folgenden Richtlinien gelten f\xFCr alle Daten, die Sie QUANTHOME zur Verf\xFCgung stellen.",
  processing_methods: "Wir k\xF6nnen Ihre Daten entweder automatisch oder manuell verarbeiten, und setzen dabei stets geeignete Sicherheitsma\xDFnahmen um.",
  why_collect_data: "Warum sammelt QUANTHOME diese Daten?",
  your_rights: "Welche Rechte haben Sie bez\xFCglich Ihrer Daten?",
  law_compliance: "Wir verarbeiten Ihre Daten in \xDCbereinstimmung mit den geltenden Gesetzen, insbesondere den Schweizer und Europ\xE4ischen Datenschutzgesetzen, und ergreifen Ma\xDFnahmen, um unbefugten Zugriff, Offenlegung, Ver\xE4nderung oder Zerst\xF6rung zu verhindern.",
  data_handling: "Wie behandelt QUANTHOME Ihre Daten?",
  retention_period: "QUANTHOME speichert Ihre Daten nur so lange, wie es notwendig ist, in der Regel 3 Jahre nach Ihrem letzten Kontakt mit QUANTHOME. Aufgrund unserer gesetzlichen Verpflichtungen m\xFCssen einige Daten, insbesondere solche, die mit unserer vertraglichen Beziehung verbunden sind, mindestens 10 Jahre lang aufbewahrt werden.",
  data_hosting: "Wo werden Ihre Daten gehostet?",
  terms_invitation: "Wir laden Sie auch ein, unsere Nutzungsbedingungen und unsere Endbenutzer-Lizenzvertrag zu \xFCberpr\xFCfen",
  credential_safety: "Um die Vertraulichkeit Ihrer Daten zu sch\xFCtzen, m\xFCssen Sie Ihre Zugangsdaten sicher aufbewahren und sie niemandem offenbaren. Sie sind verantwortlich f\xFCr jede Nutzung der auf der Website angebotenen Dienste mit Ihren Zugangsdaten.",
  data_sharing: "Mit wem k\xF6nnte QUANTHOME Ihre Daten teilen?",
  consent_withdrawal: "Wenn wir uns auf Ihre Zustimmung zur Verarbeitung Ihrer Daten st\xFCtzen, werden wir Ihre freie und spezifische Zustimmung einholen und klare Anweisungen bereitstellen. Sie k\xF6nnen Ihre Zustimmung jederzeit widerrufen. Sie haben auch das Recht, die Portabilit\xE4t Ihrer automatisch verarbeiteten Daten auf der Grundlage Ihrer Zustimmung oder vertraglichen Notwendigkeit zu beantragen.",
  cookies_section: "Cookies",
  non_identifying_data_use: "Weitere nicht identifizierende Daten, einschlie\xDFlich aggregierter oder anonymisierter Daten, k\xF6nnen verwendet werden, um Dienstleistungen zu verwalten, die Kundenbeziehungen zu verbessern, technische Probleme zu diagnostizieren und aggregierte demografische Informationen zu sammeln.",
  data_provided: "Daten, die QUANTHOME automatisch sammelt, wenn Sie auf die Website zugreifen oder die Sie freiwillig bei der Erstellung eines Kontos oder sp\xE4ter bei Bestellungen bereitstellen (Felder, die mit einem Sternchen gekennzeichnet sind, sind erforderlich, und zus\xE4tzliche Felder k\xF6nnen optional bereitgestellt werden):",
  introduction: "Ihre Privatsph\xE4re ist uns wichtig. Als Datenverantwortlicher verpflichtet sich Quanthome SA, die Personendaten, die Sie mit uns teilen, transparent und gem\xE4\xDF den geltenden Gesetzen zu verarbeiten.",
  rights_overview: "Sie haben das Recht, die Daten, die wir \xFCber Sie verarbeiten, zu kennen und die L\xF6schung, Berichtigung oder Aktualisierung zu verlangen.",
  legal_updates: "Aktualisierung der rechtlichen Informationen.",
  third_party_security: "Wir bem\xFChen uns auch sicherzustellen, dass Dritte, mit denen Ihre Daten geteilt werden k\xF6nnten (wie oben beschrieben), diese sicher behandeln und ihre Vertraulichkeit und Integrit\xE4t wahren.",
  sharing_list: {
    corporate_events: "Bei Fusionen, \xDCbernahmen oder Umstrukturierungsereignissen oder m\xF6glichen Insolvenzverfahren k\xF6nnten Ihre Daten als Verm\xF6genswert von QUANTHOME an Dritte \xFCbertragen werden. Wir werden uns bem\xFChen, Sie im Voraus \xFCber solche \xDCbertragungen zu informieren, k\xF6nnen jedoch keine Opt-out-Garantie geben",
    service_execution: "Mit allen Dritten, die f\xFCr die Ausf\xFChrung des Dienstes erforderlich sind (z. B. Mitarbeiter, verbundene Unternehmen, Zahlungsanbieter, Logistikunternehmen, unser Hosting-Anbieter und IT-Personal).",
    legal_requirements: "Mit jedem Dritten, der aufgrund einer Richtlinie von gerichtlichen oder staatlichen Beh\xF6rden oder zur Einhaltung unserer gesetzlichen Verpflichtungen rechtlich erforderlich ist."
  },
  legal_processing_objection: "Sie haben auch das Recht zu verlangen, dass wir jede spezifische Verarbeitung von Daten abbrechen, die unter Versto\xDF gegen das Gesetz erlangt oder verarbeitet wurden, und gegen die Verarbeitung von Daten aus legitimen Gr\xFCnden Widerspruch einlegen.",
  security_measures: "QUANTHOME bem\xFCht sich, die Sicherheit Ihrer Daten zu gew\xE4hrleisten und unbefugten Zugriff, Nutzung, \xC4nderung oder Offenlegung zu verhindern.",
  company_info: "Quanthome SA, nachfolgend 'QUANTHOME', 'wir' oder 'unser' genannt, ist eine Aktiengesellschaft, die im Handelsregister des Kantons Waadt eingetragen ist und sich in der Avenue de Mon-Repos 24, 1005 Lausanne, Schweiz, befindet.",
  agreement: "Durch den Zugriff auf die Website <1>www.quanthome.com</1> (\u201ESite\u201C), die wir betreiben, stimmen Sie ausdr\xFCcklich der Verarbeitung Ihrer Daten gem\xE4\xDF dieser Richtlinie zu.",
  eea_rights: "Wenn Sie ein EWR-Einwohner sind, haben Sie spezifisch die folgenden Rechte:",
  what_is_personal_data: "Was sind Personendaten?",
  data_retention: "Wie lange bewahrt QUANTHOME Ihre Daten auf?",
  hosting_details: "Die von QUANTHOME gesammelten Daten werden in der Schweiz gehostet und von Infomaniak verarbeitet",
  updates: "Wir behalten uns das Recht vor, \xC4nderungen und Berichtigungen an diesen Bestimmungen vorzunehmen. Bitte \xFCberpr\xFCfen Sie diese Seite regelm\xE4\xDFig auf Aktualisierungen und neue Informationen.",
  title: "Datenschutzrichtlinie",
  type_of_data: "Welche Art von Daten stellen Sie QUANTHOME zur Verf\xFCgung?",
  data_processing_basis: "Wir verarbeiten Ihre Daten auf der Grundlage der unten angegebenen legitimen Gr\xFCnde oder auf der Grundlage Ihrer Einwilligung:",
  policy_date: "Diese Datenschutzrichtlinie (die 'Richtlinie') idatiert vom 30. September 2023. Sie kann regelm\xE4\xDFig \xFCberpr\xFCft werden (siehe Artikel 11).",
  data_deletion_request: "Wenn Sie m\xF6chten, dass wir Ihre Daten aus unseren Systemen l\xF6schen, senden Sie eine Anfrage an den untenstehenden Kontakt, der wir nachkommen werden, es sei denn, wir m\xFCssen Ihre Daten aus rechtlichen Gr\xFCnden oder einem anderen legitimen Zweck aufbewahren.",
  sharing_overview: "QUANTHOME kann Ihre Daten wie folgt teilen:",
  security_breach_protocol: "Bitte informieren Sie uns umgehend \xFCber jeglichen Verdacht oder die Best\xE4tigung eines Missbrauchs Ihrer Anmeldedaten. Denken Sie daran, dass keine Sicherheitsma\xDFnahme narrensicher ist.",
  anonymization_alternative: "Anstatt Ihre Daten zu vernichten oder zu l\xF6schen, k\xF6nnte QUANTHOME diese dauerhaft anonymisieren, wodurch eine Identifizierung unm\xF6glich wird.",
  additional_information: "Alle pers\xF6nlichen Informationen, die Sie spontan mit uns in E-Mail-Austauschen teilen; Alle anderen Daten, die durch Cookies und den Webserver gesammelt werden. Weitere Details zu automatisch gesammelten Daten finden Sie in Artikel 10 der Richtlinie",
  international_transfers: "In einigen F\xE4llen, insbesondere aus technischen Gr\xFCnden, k\xF6nnten Ihre Daten au\xDFerhalb der Schweiz oder der Europ\xE4ischen Union \xFCbertragen werden. In solchen F\xE4llen garantieren Dritte angemessene Ma\xDFnahmen, um sicherzustellen, dass die gesetzlichen Anforderungen und der Schutz Ihrer Rechte eingehalten werden.",
  transfer_consent: "Durch den Zugriff auf die Website und das Teilen von Daten stimmen Sie ausdr\xFCcklich solchen \xDCbertragungen zu.",
  anonymization_use: "Wir k\xF6nnten Ihre Daten verarbeiten, um identifizierbare Informationen zu entfernen (Anonymisierung), und dann diese anonymen Daten f\xFCr Zwecke verwenden, die in der Richtlinie nicht aufgef\xFChrt sind (z. B. vergleichende Analyse, Kampagnenzielgruppen oder Entwicklung und Vermarktung neuer Dienstleistungen)",
  data_provision_consequences: "Sie sind nicht rechtlich oder vertraglich verpflichtet, uns Daten zur Verf\xFCgung zu stellen. Das Verweigern bestimmter Daten oder die Aus\xFCbung der im Artikel 9 genannten Rechte k\xF6nnte uns jedoch daran verhindern, Ihnen unsere Produkte, einschlie\xDFlich des Zugangs zur Website, bereitzustellen.",
  inquiries: "F\xFCr Anfragen zu dieser Richtlinie oder zur Verwendung Ihrer Daten kontaktieren Sie uns bitte unter <2>contact@quanthome.com</2> oder rufen Sie +41 21 312 16 93 an."
};
var boarding_page = {
  login: {
    abort: "Stornieren",
    aal2: {
      forgot_button: "Verwenden Sie die Wiederherstellungscodes",
      subtitle: "Bitte schliessen Sie den zweiten Schritt des Authentifizierungsprozesses aus.",
      submit_button: "Einreichen",
      title: "Geben Sie das OTP (Einmalpasswort) ein"
    },
    aal1: {
      submit_button: "Einloggen",
      forgot_button: "Passwort vergessen/wiederherstellen?",
      title: "Loggen Sie sich in Ihr Konto ein",
      subtitle: "Willkommen zur\xFCck!"
    },
    missing_otp: {
      title: "Ung\xFCltige OTP-Konfiguration",
      description: "Das Einmalpasswort (OTP) f\xFCr dieses Konto ist nicht konfiguriert oder ist falsch. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Administrator, um das Problem zu beheben."
    },
    failed: {
      title: "Fehler beim Einloggen"
    }
  },
  show_recovery: {
    button: {
      download: "Herunterladen",
      regenerate_code: "Neue Wiederherstellungscodes generieren",
      copied: "Kopiert",
      proceed: "Fortfahren",
      copy: "Kopie",
      print: "Drucken"
    },
    warning: "Bewahren Sie Ihren Wiederherstellungscode sicher auf. Diese Codes sind das einzige Mittel, um auf Ihr Konto zuzugreifen, falls Sie Ihren zweiten Faktor verlieren. Wenn Sie diesen Code nicht finden k\xF6nnen, <0>werden Sie den Zugang zu Ihrem Konto verlieren</0>.",
    explain: {
      regenerate_code: "Wenn Sie neue Wiederherstellungscodes generieren, m\xFCssen Sie die neuen Codes herunterladen oder ausdrucken. Ihre vorherigen Codes werden nicht mehr funktionieren."
    },
    label: {
      regenerate_code: "Neue Wiederherstellungscodes generieren"
    },
    title: "Wiederherstellungscode",
    subtitle: "Verlieren Sie niemals Ihren Wiederherstellungscode."
  },
  otp: {
    subtitle: "Dual-Faktor-Authenticator, um Daten bestm\xF6glich zu sch\xFCtzen.",
    step: {
      type_code: "Wenn der OTP bereit ist, \xFCberpr\xFCfen Sie, indem Sie Ihr TOTP eingeben",
      scan_qr: "Scannen Sie diesen QR-Code, um Ihr vertrauensw\xFCrdiges Ger\xE4t \xFCber Ihre OTP-App einzurichten.",
      trusted_device: "\xD6ffnen Sie Ihre bevorzugte OTP-App auf Ihrem vertrauensw\xFCrdigen Ger\xE4t"
    },
    button: {
      abort: "Ich werde das sp\xE4ter machen",
      verify: "Mein Ger\xE4t mit TOPT \xFCberpr\xFCfen"
    },
    legend: "(T)OTP* : (Zeitbasierte) Einmalpasswort",
    failed: {
      title: "Fehler beim Einrichten des OTP-Ger\xE4ts"
    },
    title: "Ihr OTP (Einmalpasswort) einrichten"
  },
  verify_mail: {
    step: {
      choose_method: {
        description: "Geben Sie Ihre E-Mail-Adresse zur \xDCberpr\xFCfung ein",
        success: {
          message: "Eine E-Mail zur Beendigung Ihrer Verifizierung wurde Ihnen gesendet.",
          title: "Code gesendet"
        },
        subtitle: "\xDCberpr\xFCfen Sie Ihre E-Mail-Adresse",
        button: "Code senden"
      },
      sent_email: {
        subtitle: "\xDCberpr\xFCfen Sie Ihre E-Mail-Adresse",
        button: "\xDCberpr\xFCfen Sie den Code",
        description: "Schreiben Sie den Code, den Sie gerade per E-Mail erhalten haben",
        success: {
          message: "Ihre E-Mail ist jetzt verifiziert",
          title: "\xDCberpr\xFCfung abgeschlossen"
        }
      }
    },
    abort: "Ich werde das sp\xE4ter machen",
    title: "Vervollst\xE4ndigen Sie die Einrichtung"
  },
  forgot_password: {
    last_step: "Sie k\xF6nnen jetzt Ihr Passwort \xE4ndern:",
    button: {
      send: "Mein Code senden",
      cancel: "Wiederherstellung abbrechen",
      save: "Mein Passwort speichern",
      verify: "\xDCberpr\xFCfen Sie meinen Code"
    },
    subtitle: "Keine Sorge, alles wird gut",
    success: {
      title: "Passwort erfolgreich ge\xE4ndert",
      message: "Sie k\xF6nnen sich jetzt mit Ihrem neuen Passwort anmelden."
    },
    title: "Passwort vergessen",
    check_code_from_email: "Ein Wiederherstellungscode wurde an Ihre E-Mail gesendet..."
  },
  recovery_code: {
    form: {
      button: "\xDCberpr\xFCfen"
    },
    title: "Zwei-Faktor-Authentifizierung Wiederherstellung",
    abort_button: "Stornieren",
    faq: {
      what_is_recovery: {
        question: "Was ist ein Wiederherstellungscode?",
        answer: "Der Wiederherstellungscode ist der Code, den Sie erhalten haben, als Sie Ihr Ger\xE4t zum ersten Mal verbunden haben. Sie sollten ihn an einem sicheren Ort aufbewahrt haben."
      },
      lock: {
        question: "Aus dem Konto ausgesperrt?",
        answer: "Bitte kontaktieren Sie Ihren Administrator zur Wiederherstellung Ihres Kontos."
      },
      description: "Wenn Sie auf Ihr mobiles Ger\xE4t nicht zugreifen k\xF6nnen, geben Sie Ihren Wiederherstellungscode ein, um Ihre Identit\xE4t zu verifizieren."
    },
    reset: {
      success: {
        message: "Sie k\xF6nnen jetzt ein neues Ger\xE4t binden.",
        title: "Der Wiederherstellungscode ist korrekt"
      }
    },
    missing: {
      description: "Der Wiederherstellungscode f\xFCr dieses Konto wurde nicht definiert oder ist abgelaufen. Bitte kontaktieren Sie den Support von Quanthome, um das Problem zu l\xF6sen.",
      title: "Ung\xFCltiger Wiederherstellungscode"
    }
  },
  register: {
    notification: {
      changed_email: {
        message: "Ihre Informationen wurden erfolgreich aktualisiert - Sie sollten eine neue E-Mail erhalten haben, um Ihre neue E-Mail-Adresse zu best\xE4tigen.",
        title: "E-Mail-Adresse wurde ge\xE4ndert"
      },
      privileged_session_reached: {
        message: "Aus Sicherheitsgr\xFCnden muss der Registrierungsprozess innerhalb von 30 Minuten abgeschlossen werden. Bitte fordern Sie einen weiteren Einladungslink an, um die Registrierung neu zu starten.",
        title: "Privilegierte Sitzung abgelaufen (Timeout-Zeit)"
      },
      flow_expiration: {
        message: "Der Fluss ist abgelaufen - Kontaktieren Sie Ihren Administrator.",
        title: "Abgelaufen"
      }
    },
    button: "Speichern",
    title: "Willkommen bei Quanthome_",
    repeat_password: "Passwort wiederholen",
    error: {
      repeat_password: "Passw\xF6rter m\xFCssen \xFCbereinstimmen"
    },
    subtitle: "Richten Sie Ihr Konto ein:"
  },
  totp_setup: {
    notification: {
      privileged_session_reached: {
        message: "Privilegierte Sitzungszeit abgelaufen (Timeout). Bitte melden Sie sich erneut an."
      }
    }
  }
};
var global = {
  chart: {
    legend: {
      gav: "GAV",
      r_debt_ratio: "Verschuldungsgrad",
      r_rental_losses: "Mietausfallrate",
      total_idc: "Gesamtenergie",
      market_market_cap: "Marktkapitalisierung",
      transport_tram: "Tramhaltestellen",
      realised_gains_losses: "Realisierte Gewinne/Verluste",
      long_term_interest_bearing_mortgages: "Langfristige verzinsliche Hypotheken",
      estimated_co_2_scope_1_2_33: "Gesamt-CO\u2082-Emissionen Scope 1 + 2 + 3.3",
      market_share_price: "Aktienkurs",
      r_market_value: "Marktwert der Geb\xE4ude",
      estimated_total_market_value: "Gesamtmarkwert",
      offices: "B\xFCros",
      revenues: "Einnahmen",
      total_net_asset: "Gesamte Nettoverm\xF6genswerte",
      restaurants: "Restaurants",
      idc_per_m_2: "Energieintensit\xE4t",
      r_nav_before_distribution: "NAV vor Aussch\xFCttung",
      shops: "L\xE4den",
      r_market_cap: "Marktkapitalisierung",
      co_2_scope_1_2_33_per_m_2: "CO\u2082 Scope 1 + 2 + 3.3",
      r_cost_price: "Einstandspreis der Geb\xE4ude",
      roa: "ROA (Gesamtkapitalrentabilit\xE4t)",
      other: "Andere",
      estimated_total_net_rent: "Gesamte Nettomiete",
      reported_total_target_rent: "Gesamte Soll-Mietertr\xE4ge",
      co_2_listed: "CO\u2082",
      region_lemanique: "Genferseeregion",
      total_income: "Gesamte Mietertr\xE4ge",
      reported_ebit_margin: "EBIT-Marge",
      short_term_liabilities: "Kurzfristige Verbindlichkeiten",
      total_properties: "Gesamtliegenschaften",
      nordwestschweiz: "Nordwestschweiz",
      commercial: "Gewerbeimmobilien",
      mixed: "Gemischte Nutzung",
      estimated_co_2_scope_1_2_33_per_m_2: "CO\u2082 Scope 1 + 2 + 3.3",
      secondary_education: "Sekundarbildung",
      co_2_scope_2_per_m_2: "CO\u2082 Scope 2",
      cultural_venues: "Kulturelle Einrichtungen",
      r_ebit_margin: "EBIT-Marge",
      r_total_target_rent: "Gesamte Soll-Mietertr\xE4ge",
      public_open_space: "\xD6ffentlicher Freiraum",
      purchased: "Gekaufte Geb\xE4ude",
      c_market_value: "Marktwert der Geb\xE4ude",
      total_co_2_scope_1_2_33: "Gesamt-CO\u2082-Emissionen Scope 1 + 2 + 3.3",
      reported_rental_losses: "Mietausfallrate",
      r_total_real_rent: "Gesamte reale Miete",
      none: "Keine Heizung",
      nav: "NAV",
      asset: "Verm\xF6gen",
      r_total_cost_price: "Gesamteinstandspreis",
      very_low: "Sehr gering",
      primary_education: "Primarbildung",
      medium: "Mittlere",
      net_income: "Nettogewinn",
      r_target_rent: "Soll-Mietertr\xE4ge",
      r_tga_before_distribution: "TGA vor Aussch\xFCtung",
      equity: "Eigenkapital",
      r_real_rent: "Reale Miete",
      legend: "Legende",
      liabilities: "Verbindlichkeiten",
      r_payout_ratio: "Aussch\xFCttungsquote",
      co_2_scope_1_per_m_2: "CO\u2082 Scope 1",
      reported_dividend_yield: "Dividendenrendite",
      rent_listed: "Mietertr\xE4ge",
      date: "Datum",
      transport_bike: "Veloparkierung",
      r_total_market_value: "Gesamtmarkwert",
      reported_total_cost_price: "Gesamteinstandspreis",
      c_net_rent: "Mietertr\xE4ge",
      amount: "Betrag",
      benchmark_fund: "Benchmark-Fonds",
      tessin: "Tessin",
      realised_income: "Realisierte Ertr\xE4ge",
      reported_total_market_value: "Gesamtmarkwert",
      rent_expected: "Erwartete Mietertr\xE4ge",
      intermediate: "Intermedi\xE4r",
      sold: "Verkaufte Geb\xE4ude",
      ordinary_income_carried_forward: "Vorgetragene ordentliche Ertr\xE4ge",
      default: "Betrag",
      estimated_total_energy: "Gesamtenergie",
      ostschweiz: "Ostschweiz",
      very_high: "Sehr hoch",
      total_co_2_scope_33: "Gesamt-CO\u2082-Emissionen Scope 3.3",
      total_co_2_scope_1_2: "Gesamt-CO\u2082-Emissionen Scope 1 + 2",
      reported_roe: "ROE (Eigenkapitalrendite)",
      r_dividend_yield: "Dividendenrendite",
      estimated_energy_intensity: "Energieintensit\xE4t",
      short_term_interest_bearing_mortgages: "Kurzfristige verzinsliche Hypotheken",
      other_long_term_liabilities: "Andere langfristige Verbindlichkeiten",
      sports_recreation: "Sport und Freizeit",
      current_building: "Bestandsgeb\xE4ude",
      r_roe: "ROE (Eigenkapitalrendite)",
      transport_bus: "Bushaltestellen",
      plots: "Parzellen",
      reported_tga_before_distribution: "TGA vor Aussch\xFCtung",
      high: "Hoch",
      m_market_cap: "Marktkapitalisierung",
      early_years: "Kinderbetreuung",
      estimated_co_2_scope_1_2: "Gesamt-CO\u2082-Emissionen Scope 1 + 2",
      reported_total_real_rent: "Gesamte reale Miete",
      current_fund: "Aktueller Fonds",
      reported_payout_ratio: "Aussch\xFCttungsquote",
      zentralschweiz: "Zentralschweiz",
      healthcare: "Gesundheitswesen",
      total_co_2_scope_1: "Gesamt-CO\u2082-Emissionen Scope 1",
      non_fossil: "Nicht fossile",
      other_short_term_liabilities: "Andere kurzfristige Verbindlichkeiten",
      total_co_2_scope_2: "Gesamte CO\u2082-Emissionen Scope 2",
      reported_tna_before_distribution: "TNA vor Aussch\xFCttung",
      residential: "Wohnimmobilien",
      fossil: "Fossile",
      reported_nav_before_distribution: "NAV vor Aussch\xFCttung",
      r_tna_before_distribution: "TNA vor Aussch\xFCttung",
      expenses: "Ausgaben",
      zurich: "Z\xFCrich",
      co_2_expected: "CO\u2082 (erwartet)",
      espace_mitelland: "Raum Mittelland",
      co_2_scope_1_2_per_m_2: "CO\u2082 Scope 1 + 2",
      m_share_price: "Aktienkurs",
      other_asset: "Anderes Verm\xF6gen",
      low: "Gering",
      long_term_liabilities: "Langfristige Verbindlichkeiten",
      co_2_scope_33_per_m_2: "CO\u2082 Scope 3.3",
      reported_debt_ratio: "Verschuldungsgrad",
      cash_holding_and_balances_at_sight: "Barmittel und Guthaben",
      surface: "Fl\xE4che",
      r_share_price: "Aktienkurs",
      sustainability: "Nachhaltigkeit",
      woman: "Frau",
      unrealised_gains_losses_including_liquidation_taxes_variation: "Nicht realisierte Gewinne/Verluste einschliesslich Ver\xE4nderung der Liquidationssteuern",
      man: "Mann",
      net_income_available_for_distribution: "Aussch\xFCttungsf\xE4higer Nettogewinn",
      estimated_co_2_scope_1_2_per_m_2: "CO\u2082 Scope 1 + 2",
      aged_care: "Altenpflege",
      unchanged: "Unver\xE4nderte Geb\xE4ude",
      foundation: "Stiftung",
      unlisted_fund: "Nicht kotierter Fonds",
      real_estate_firm: "Immobiliengesellschaft",
      listed_fund: "Kotierter Fonds"
    },
    tooltip: {
      potential: "Erwartet",
      real: "Angezeigt"
    },
    export: {
      png: "png",
      excel: "xlsx",
      csv: "csv"
    },
    export_as: "Herunterladen als"
  },
  assets: {
    building: "Geb\xE4ude",
    lot: "Parzelle",
    dwelling: "Wohnung"
  }
};
var status = {
  completed: "Abgeschlossen",
  not_complete: "Nicht abgeschlossen",
  resend: "Erneut senden"
};
var errors = {
  fii: {
    fii_portfolio_duplicated_dwelling_id: "Alle Wohnungen wurden bereits zu diesem Portfolio hinzugef\xFCgt",
    fii_invalid_dwelling_id: "Keine g\xFCltige Wohnungs-ID.",
    fii_portfolio_duplicated_building_id: "Alle Geb\xE4ude wurden bereits zu diesem Portfolio hinzugef\xFCgt.",
    fii_invalid_building_id: "Keine g\xFCltige Geb\xE4ude-ID."
  }
};
var double_range_input = {
  error_msg: "Der Mindestwert muss kleiner als der H\xF6chstwert sein.",
  year_error_msg: "Bitte geben Sie ein g\xFCltiges Jahr ein",
  clear: "klar",
  start: "Startdatum",
  min: "min",
  max: "max",
  end: "Enddatum"
};
var common = {
  connection_lost: {
    message_1: "Sie sind m\xF6glicherweise nicht mehr mit dem Internet verbunden.",
    message_2: "Die Anwendung kann nicht wie erwartet funktionieren",
    message_3: "Bitte laden Sie die Seite neu.",
    reload_button: "Neu laden",
    title: "Verbindung verloren"
  },
  funds: {
    pascalcase: "Fonds"
  },
  enterprise_state: {
    exempt: "Exempt",
    unpaid: "Unbezahlt",
    ended: "Beendet",
    subscribed: "Abonniert",
    trial_end: "Ende der Testphase",
    state: "Vertragsart",
    examination: "Pr\xFCfung",
    trial: "Test"
  },
  real_estate_firm: {
    pascalcase: "Immobilienfirma"
  },
  lots: {
    lowercase: "Parzellen",
    pascalcase: "Parzellen"
  },
  financials: {
    array: {
      industrial: "Industriell",
      total: "Total",
      commercial: "Gewerbeimmobilien",
      office: "B\xFCro",
      residential: "Wohnimmobilien"
    }
  },
  keys: "Schl\xFCssel",
  buildings: {
    pascalcase: "Geb\xE4ude",
    lowercase: "Geb\xE4ude"
  },
  comparables: {
    pascalcase: "Vergleichswerte"
  },
  delete_user: "Benutzer l\xF6schen",
  portfolios: {
    pascalcase: "Portfolios"
  },
  error: "Ein Fehler ist aufgetreten",
  developer_mode: {
    deactivated: "Deaktiviert",
    activated: "Aktiviert",
    state: "Entwicklermodus"
  },
  unlisted_fund: {
    pascalcase: "Nicht kotierte Fonds"
  },
  warning: "Warnung",
  role: {
    manager: "Manager",
    user: "Benutzer",
    owner: "Eigent\xFCmer"
  },
  assign_contact_user: "Als Ansprechperson zuweisen",
  slot: {
    institutional: "Institutionell",
    investor: "Investor",
    consumer: "Verbraucher"
  },
  create: "Erstellen",
  removing: "Entfernung",
  assets: {
    pascalcase: "Verm\xF6genswerte"
  },
  transactions: {
    pascalcase: "Transaktionen"
  },
  warning_msg: "Der Vorgang zu {{ failed }} ist fehlgeschlagen.",
  error_message: "Ein Fehler ist aufgetreten",
  key: "Schl\xFCssel",
  cancel_button: "Stornieren",
  confirm_button: "Best\xE4tigen",
  notification: {
    success: {
      title: "Erfolg"
    }
  },
  dwellings: {
    pascalcase: "Wohnungen",
    lowercase: "Wohnungen"
  },
  listed_fund: {
    pascalcase: "Kotierte Fonds"
  },
  foundation: {
    pascalcase: "Investitionsgrundlage"
  },
  edit: "Bearbeiten",
  institutions: {
    pascalcase: "REIVs"
  },
  success: "Erfolgreich"
};
var footer = {
  license_agreement: "Lizenzvertrag",
  impressum: "Impressum",
  confidential_policy: "Datenschutzerkl\xE4rung"
};
var source_badge = {
  reported: "Gemeldet",
  official: "Offiziell",
  expected: "Erwartet",
  forecasted: "Prognostiziert",
  listed: "Angezeigt",
  market_data: "Marktdaten",
  computed: "Berechnet",
  estimated: "Gesch\xE4tzt",
  quanthome_data: "Quanthome-Daten"
};
var dashboard = {
  indicators: {
    title: "Indikatoren",
    switzerland_vacancy_rate: "Schweizer Leerstandsquote",
    reference_interest_rate: "Referenzzinssatz",
    ipc_lik: "LIK Landesindex der Konsumentenpreise (IPC/LIK)",
    snb_policy_rate: "Leitzins der Schweizerischen Nationalbank"
  },
  indices: {
    swiss_residential_property_price: "Schweizer Wohnimmobilienpreisindex",
    title: "Indizes",
    construction_price_index_building: "Schweizer Bauindex - Geb\xE4ude",
    construction_price_index_total: "Schweizer Bauindex - Gesamt",
    construction_price_index_civil_engineering: "Schweizer Bauindex - Bauingenieurwesen"
  },
  empty: {
    portfolios: "Sie haben kein gespeichertes Portfolio.",
    funds: "Sie haben keinen gespeicherten Fonds."
  },
  trend: {
    title: "Schweizer Markttrend: Nettomiete pro m\xB2"
  },
  rent: {
    title: "Miete pro m\xB2 pro Kanton"
  },
  error: {
    feature: {
      rights: "Sie haben keinen Zugriff auf diese Funktion"
    }
  }
};
var notification = {
  terminated_session: {
    title: "Sitzung beendet",
    message: "Sie k\xF6nnten auf einem anderen Ger\xE4t verbunden sein oder die Sitzungsdauer wurde erreicht."
  }
};
var administration = {
  companies: {
    actions: {
      delete_company: "Unternehmen l\xF6schen",
      update_company_slots: "Aktualisieren der Lizenzen des Unternehmens",
      update_company: "Unternehmenseinstellungen bearbeiten"
    },
    col_name: {
      contact_user: "Ansprechperson",
      developer_mode: "Entwicklermodus",
      total_consumer_seat: "Anzahl der Lizenzen Benutzer-Verbraucher",
      days_left: "Verbleibende Tage",
      free_investor_seat: "Verbleibende Lizenzen Benutzer-Investor",
      consumer_users: "Benutzer-Verbraucher",
      contact_user_email: "E-Mail-Adresse der Ansprechperson",
      free_institutional_seat: "Verbleibende Lizenzen Benutzer-Institutionell",
      used_investor_seat: "Zugewiesene Lizenzen Benutzer-Investor",
      related_am: "Verbundener Account-Manager",
      all_users: "Teammitglieder",
      license_use: "Zuweisung von Lizenzen",
      total_all_seats: "Gesamtanzahl der Lizenzen",
      state: "Vertragsart",
      subscription_start: "Abonnementdatum",
      free_consumer_seat: "Verbleibende Lizenzen Benutzer-Verbraucher",
      used_consumer_seat: "Zugewiesene Lizenzen Benutzer-Verbraucher",
      name: "Unternehmen",
      institutional_users: "Benutzer-Institutionell",
      used_institutional_seat: "Zugewiesene Lizenzen Benutzer-Institutionell",
      used_all_seats: "Anzahl der zugewiesene Lizenzen",
      investor_users: "Benutzer-Investor",
      contact_user_phone: "Telefonnummer der Ansprechperson",
      total_investor_seat: "Anzahl der Lizenzen Benutzer-Investor",
      expiration_date: "Vertragsende",
      total_institutional_seat: "Anzahl der Lizenzen Benutzer-Institutionell"
    },
    headers: {
      companies_count: "{{count}} Unternehmen",
      member_count: "{{ count }} Mitglieder"
    },
    cells: {
      user_count: "{{ count }} Nutzer"
    },
    teams: "Teams",
    table_title: "Unternehmen"
  },
  breadcrumb: {
    edit: "Bearbeiten",
    create_company: "Erstellen",
    details: "Details",
    companies: "Unternehmen"
  },
  collaborators: {
    headers: {
      members_count: "{{ count }} Mitglieder"
    }
  }
};
var management = {
  nav: {
    profile: {
      title: "Profil",
      subtitle: "Aktualisieren Sie Ihre Profileinstellungen."
    },
    connections: {
      title: "API",
      subtitle: "Erstellen und verwalten Sie API-Schl\xFCssel, um auf quanthome Daten von einem Betriebssystem, einer Anwendung oder einem anderen Dienst zuzugreifen."
    },
    seats: {
      subtitle: "Hier ist alles, was Sie \xFCber Lizenten und Abrechnung wissen m\xFCssen",
      title: "Lizenzen"
    },
    collaborators: {
      subtitle: "Hier ist alles, was Sie \xFCber die Personen wissen d\xFCrgfen, die auf die Plattform in Ihrem Unternehmen zugreifen.",
      title: "Mitarbeiter"
    },
    organization: {
      subtitle: "Hier sind alle Informationen \xFCber das Unternehmen, in dem Sie arbeiten.",
      title: "Organisation"
    },
    requests: {
      subtitle: "Alle Anfragen werden hier gesammelt.",
      title: "Anfragen"
    },
    edit_company: {
      subtitle: "Aktualisieren Sie die Informationen eines Unternehmens",
      title: "Unternehmen aktualisieren"
    },
    preferences: {
      subtitle: "Verwalten Sie Ihre Pr\xE4ferenzen",
      title: "Pr\xE4ferenzen"
    },
    security: {
      subtitle: "Erstellen Sie Ihr Passwort, um auf die Plattform zuzugreifen.",
      title: "Sicherheit"
    },
    users: {
      subtitle: "Alle Benutzer aller Unternehmen versammeln sich hier.",
      title: "Benutzer"
    },
    companies: {
      subtitle: "Hier sind alle Unternehmen, die die Plattform abonniert haben.",
      title: "Unternehmen"
    },
    create_company: {
      subtitle: "F\xFCgen Sie ein neues Unternehmen hinzu, indem Sie die meisten seiner Informationen ausf\xFCllen.",
      title: "Neues Unternehmen"
    },
    teams: {
      subtitle: "Hier ist alles, was Sie \xFCber die Personen wissen d\xFCrgfen, die auf die Plattform in Ihrem Unternehmen zugreifen.",
      title: "Teams"
    },
    language: {
      title: "Sprache"
    },
    company: {
      title: "Unternehmen",
      subtitle: "Verwalten der Mitglieder und desr Lizenzen eines Unternehmens."
    },
    languages: {
      subtitle: "Verwalten Sie Ihre Sprachen"
    },
    contracts: {
      title: "Vertr\xE4ge"
    }
  },
  email: {
    addresses: {
      description: "Machen Sie es einzeln oder f\xFCgen Sie eine Liste von E-Mails, die durch ein Komma getrennt sind, ein und best\xE4tigen Sie mit der Enter-Taste",
      title: "E-Mail-Adressen",
      empty: "Ihre Benutzer werden hier angezeigt"
    }
  },
  header: {
    gotoplatform: "Zur Plattform",
    logout: "Sich ausloggen"
  },
  category: {
    administration: {
      title: "Verwaltung"
    },
    team: {
      title: "Team"
    },
    company: {
      title: "Unternehmen"
    },
    customers: {
      title: "Kunden"
    },
    personal: {
      title: "Pers\xF6nlich"
    },
    communication: {
      title: "Kommunikation"
    }
  }
};
var action = {
  portfolios: {
    name: {
      change_success: {
        message: "Sie haben den Namen des Portfolios erfolgreich ge\xE4ndert",
        title: "Der Name wurde ge\xE4ndert"
      }
    },
    remove: {
      loading: {
        message: "Entfernen von {{ asset }}(s) aus Ihrem Portfolio"
      },
      confirmation: {
        title: "Aus dem Portfolio entfernen",
        question: "Sind Sie sicher, dass Sie das Asset aus diesem Portfolio entfernen m\xF6chten?"
      }
    }
  },
  label: {
    create_key: "Schl\xFCssel erstellen",
    invite_member: "Mitglied hinzuf\xFCgen",
    delete: "L\xF6schen",
    create_user: "Benutzer erstellen"
  },
  companies: {},
  users: {
    remove: {
      confirmation: {
        question: "Sind Sie sicher, dass Sie diese Benutzer entfernen m\xF6chten?"
      }
    }
  }
};
var panel_selection = {
  option: {
    computed_road_accessibility_distribution: "\xDCber die Strasse",
    typology: "Typologie",
    market_value: "Marktwert",
    rental_space: "Fl\xE4che",
    actual_rental_status_real: "Mietertrag",
    reported_type: "Typ",
    region: "Region-Kanton",
    type: "Typ-Kategorie",
    actual_market_value: "Marktwert",
    class: "Klasse",
    real_rent: "Reale Mietertr\xE4ge",
    potential_net_rent: "Nettomiete",
    cost_price: "Einstandspreis",
    potential_market_value: "Marktwert",
    computed_pt_accessibility_distribution: "Mit \xF6ffentlichen Verkehrsmitteln",
    area: "Fl\xE4che",
    actual_rental_status_target: "Soll-Mietertrag",
    target_rent: "Sollmiete"
  },
  title: {
    group: "Gruppierung",
    weight: "Gewichtung"
  }
};
var watchlist = {
  dwellings: {
    empty: "Keine Wohnungen in der Beobachtungsliste"
  },
  buildings: {
    empty: "Keine Geb\xE4ude in der Beobachtungsliste"
  }
};
var treemap = {
  label: {
    value: "Wert",
    percentage: "Prozentsatz",
    label: "Bezeichnung"
  },
  unit: {
    percentage: "%"
  }
};
var line_chart = {
  placeholder: {
    no_data_selected: "Bitte w\xE4hlen Sie die anzuzeigenden Daten aus"
  }
};
var fund = {
  financials: {
    accounting: {
      table_action: {
        download: "Buchhaltungstabelle herunterladen"
      }
    }
  },
  overview: {
    benchmark: {
      delete: "Benchmark l\xF6schen"
    }
  }
};
var playground = {
  display: {
    map: "Karte anzeigen",
    table: "Tabelle anzeigen",
    filter: "Filter anzeigen",
    chart: "Diagramm anzeigen"
  },
  chart: {
    message: {}
  },
  screener: {
    message: {}
  },
  chart_selections: {}
};
var buildings = {
  type: {
    residential: "Wohnimmobilien",
    mixed: "Gemischte Nutzung",
    commercial: "Gewerbeimmobilien"
  },
  social: {
    transport_accessibility: {
      transport_accessibility: {},
      road_accessibility: {}
    }
  }
};
var option = {
  sudo: "Sudo",
  institutional: "Institutionell",
  am: "Account-Manager",
  owner: "Eigent\xFCmer",
  admin: "Administrator",
  user: "Benutzer",
  manager: "Manager",
  no_plan: "Kein Abonnement",
  consumer: "Verbraucher",
  triage: "Sortierung",
  investor: "Investor"
};
var potfolios = {
  sections: {
    description: {
      title: "Beschreibung"
    },
    assets: {
      title: "Bestand"
    },
    environmental: {
      title: "Umwelt"
    },
    social: {
      title: "Soziales"
    },
    financials: {
      title: "Finanzen"
    }
  },
  tiles: {
    revenue: {
      title: "Einnahmen"
    },
    charges: {
      title: "Geb\xFChren"
    },
    evolution: {
      title: "Entwicklung"
    }
  },
  widget: {
    charges: {
      title: "Geb\xFChren"
    },
    revenue: {
      title: "Einnahmen"
    }
  }
};
var error = {
  something_went_wrong: {
    title: "Ein Fehler ist aufgetreten"
  },
  notfound: {
    button: "Zur\xFCck",
    code: "Fehler 404",
    subtitle: "Entschuldigung, die von Ihnen gesuchte Seite existiert nicht.",
    title: "Seite nicht gefunden"
  },
  email: {
    format: "Ihre E-Mail ist nicht gut geschrieben"
  }
};
var screener_bar = {
  main_button: {
    launch: "Einf\xFChren",
    screener: "Screener"
  }
};
var traits = {
  contact: {
    office_phone: "Gesch\xE4ftliche Telefonnummer"
  },
  name: {
    last: "Nachname",
    first: "Vorname"
  },
  email: "E-Mail-Adresse"
};
var table = {
  empty: "Keine Daten (noch), wir arbeiten daran \u{1F3C3}",
  fund_type: {
    commercial: "Gewerbeimmobilien",
    mixed: "Gemischte Nutzung",
    residential: "Wohnimmobilien"
  },
  error: "Ein Fehler ist aufgetreten \u{1F647}",
  fund_legal_form: {
    foundation: "Stiftung",
    listed_fund: "Kotierte Fonds",
    real_estate_firm: "Immobilienfirma",
    unlisted_fund: "Nicht kotierte Fonds"
  },
  back_office_empty: "Leere Tabelle"
};
var users = {
  role: {
    user: "Benutzer"
  },
  roles: {
    triage: "Sortierung",
    owner: "Eigent\xFCmer"
  }
};
var multiple_select = {
  placeholder: {
    search: "Durchsuchen"
  },
  clear: "klar",
  not_enough_selected: {}
};
var table_actions = {
  request_download: {
    accounting: "Buchhaltungstabelle herunterladen",
    csv: "Ausgew\xE4hlte Zeilen auf der aktuellen Seite herunterladen",
    header: "Herunterladen als"
  },
  watchlist: {
    remove: {
      button: {
        label: "Ausgew\xE4hlte Verm\xF6genswerte von der Beobachtungsliste entfernen"
      }
    },
    add: {
      button: {
        label: "Ausgew\xE4hlte Verm\xF6genswerte verfolgen"
      }
    }
  },
  portfolios: {
    remove: {
      confirmation: {
        title: "Ausgew\xE4hlte Verm\xF6genswerte aus dem aktuellen Portfolio entfernen"
      }
    }
  },
  add_to_portfolios: {
    title: "Ausgew\xE4hlte Verm\xF6genswerte zum Portfolio hinzuf\xFCgen"
  }
};
var candle_stick_chart = {
  label: {
    volume: "Volumen",
    low: "Gering",
    open: "Er\xF6ffnungspreis",
    close: "Schliessen",
    start_date: "Beginn",
    high: "Hoch",
    end_date: "Ende",
    turnover: "Umsatz",
    date: "Datum"
  },
  unit: {
    chf: "CHF",
    units: "Einheiten"
  }
};
var header = {
  dropdown_menu: {
    profile: "Mein Profil",
    logout: "Sich ausloggen",
    settings: "Einstellungen",
    my_company: "Mein Unternehmen",
    back_office: "Verwaltung"
  },
  navbar: {
    funds: "REIVs",
    dashboard: "Dashboard",
    playground: "Spielplatz",
    portfolios: "Portfolios",
    institutions: "REIVs",
    screener: "Immobilien",
    watchlist: "Beobachtungsliste",
    map: "Karte"
  }
};
var paywall = {
  subtitle: "Bitte kontaktieren Sie Ihren Account-Manager.",
  message: {
    no_slot: "Sie haben derzeit kein Recht, die Anwendung zu nutzen.",
    end_trial: "Ihre Testphase ist vorbei.",
    out_of_scope: "Dieses Feature ist nicht in Ihrem Abonnement-Vertrag enthalten.",
    error: "Es gibt einen Fehler mit Ihrem Abonnement.",
    slot_out_of_scope: "Dieses Feature ist nicht in Ihren Genehmigungsbereichen enthalten."
  },
  button: {
    logout: "Sich ausloggen"
  }
};
var tile = {
  side_menu: {
    meter: "Meter",
    country: "Land",
    minute: "Minuten",
    municipality: "Gemeinde",
    canton: "Kanton"
  },
  wrong: {
    message: "Ein Fehler ist aufgetreten"
  },
  empty: {
    message: "Fehlende Daten"
  }
};
var gradient = {
  label: {
    low: "Gering",
    high: "Hoch"
  },
  quartile_1: "1. Quartil",
  quartile_2: "Median",
  chart: {
    no_data: "Keine Daten"
  },
  quartile_3: "3. Quartil"
};
var companies = {
  notifications: {
    success_delete_enterprises: "Unternehmen erfolgreich gel\xF6scht",
    success_create_users: "Benutzer haben erfolgreich erstellt",
    no_slot_available: "Keine Lizenz verf\xFCgbar"
  },
  button: {
    give_am_rights: "Rechte gew\xE4hren",
    give_default_roles: "Standardrollen zuweisen",
    clear_fund_cache: "Fundscache leeren",
    check_states: "\xDCberpr\xFCfen Sie die Zust\xE4nde",
    clear_all_cache: "Cache leeren",
    clear_cache: "Cache leeren",
    refresh_roles: "Rollen aktualisieren"
  },
  modal: {
    confirm_delete: {
      text: "Sind Sie sicher, dass Sie dieses/diese Unternehmen l\xF6schen m\xF6chten?",
      title: "L\xF6schen best\xE4tigen"
    }
  }
};
var password = " Neues Passwort ";
var unsaved_screener = {
  tooltip: {
    save_button: "Speichern Sie Ihre nicht gespeicherten \xC4nderungen mit diesem Speichern-Button"
  },
  button: {
    leave_page: "Ohne speichern fortfahren",
    back_to_screener: "Zur\xFCck zum Screener"
  },
  warning: {
    content: "Sie haben ein laufendes ungespeicherten Screener."
  },
  modal: {
    title: "Sie sind gerade dabei, die Screener-Seite zu verlassen"
  }
};
var profile_train = {
  tooltip: {
    more: "{{count}} mehr"
  }
};
var unit = {
  chf_per_m2: "CHF/m\xB2"
};
var pyramid_chart = {
  label: {
    group: "Gruppe",
    unit: "%",
    age: "Alter",
    man: "Mann",
    woman: "Frau",
    percentage: "Prozentsatz"
  }
};
var download = {
  action_label: "CSV herunterladen",
  request_created: "Anfrage erstellt."
};
var search = {
  nothing_found: "Keine Ergebnisse gefunden",
  placeholder: "Adressen",
  title: "Suchergebnis"
};
var overview = {
  property: {
    listed_fund: "Kotierte Fonds",
    foundation: "Eigentum einer Stiftung",
    unlisted_fund: "Nicht kotierte Fonds",
    mixed: "Institutionelles Eigentum",
    real_estate_firm: "Immobilienfirma"
  }
};
var valuations = {
  actions: {
    reset: "Zur\xFCcksetzen"
  }
};
var general = {
  app_wall: {
    redirect: {
      message: "Sie haben derzeit keinen Zugriff auf die App. Wir werden Sie zu den Einstellungen weiterleiten\u2026"
    }
  }
};
var preset = {
  modal: {
    confirm_delete: {
      title: "Screener l\xF6schen",
      text: "Sind Sie sicher, dass Sie dieses Screener l\xF6schen m\xF6chten?",
      proceed: "Fortfahren",
      cancel: "Zur\xFCck"
    }
  }
};
var time_selector = {
  header: "Zeitraum"
};
var benchmark_selector = {
  search: {
    placeholder: "Institutionsname"
  },
  header: "Vergleichen mit"
};
var impressum = {
  mail: "E-Mail-Adresse:",
  text: "Impressum Quanthome SA nutzt die Website app.quanthome.com, um Daten zu jeder Immobilie bereitzustellen.",
  address: "Postanschrift: Avenue Mon-Repos 24, 1005 Lausanne"
};
var widget = {
  side_menu: {
    municipality: "Gemeinde",
    country: "Land",
    canton: "Kanton"
  }
};
var portfolio = {
  environmental: {
    evolution: {
      title: "Entwicklung"
    }
  }
};
var view = {
  switch: {
    cards: "Karten anzeigen",
    table: "Tabelle anzeigen"
  }
};
var input = {
  select: "ausw\xE4hlen",
  edit: "Bearbeiten"
};
var single_select = {
  clear: "klar"
};
var badge = {
  beta: "Beta-Funktion"
};
var boarding = {
  suggested_otp: "Vorgeschlagene OTP-App:"
};
var items = {
  array: {
    columns: {
      title: {
        potential: "Gesch\xE4tzt",
        real: "Gemeldet / Aufgelistet",
        difference: "Abweichung"
      }
    }
  },
  charts: {
    gradient: {
      subject: {
        indice: "Index",
        index: "Index"
      }
    }
  }
};
var entity_selector = {
  search: "Suche",
  button: {
    cancel: "Stornieren",
    save: "\xC4nderungen speichern"
  }
};
var inputs = {
  placeholder: {
    preset_name: "Name des Datasets",
    input_name: "Eingabename",
    choose_option: "W\xE4hlen Sie eine Option"
  }
};
var login = {
  error: "Fehler beim Einloggen"
};
var empty_chart = {
  message: "Keine Daten"
};
var chart_selections = {
  chart_type: "Art von Diagramm",
  timespan: "Zeitspanne",
  y_axis: "Y-Achse",
  fields: "Datenfelder",
  x_axis: "X-Achse",
  value: "Werte",
  group_by: "Gruppieren nach",
  base_100: "Indexbasis 100 Punkte",
  color_by: "F\xE4rben nach"
};
var number_input = {};
var scatter_chart = {
  filtered_result: "Gefiltertes Ergebnis"
};
var histogram_chart = {
  tooltip: {}
};
var chart = {};
var de_default = {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart
};

export {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart,
  de_default
};
